import { emptySplitApi as api } from './emptyApi';
export const addTagTypes = [
  'trips',
  'dispatch',
  'run-bambi-run',
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      tripsList: build.query<TripsListApiResponse, TripsListApiArg>({
        query: (queryArg) => ({
          url: `/trips/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            canceled_reason__in: queryArg.canceledReasonIn,
            created_at_range_end: queryArg.createdAtRangeEnd,
            created_at_range_start: queryArg.createdAtRangeStart,
            driver__in: queryArg.driverIn,
            dropoff_municipality__in: queryArg.dropoffMunicipalityIn,
            external_trip_id__in: queryArg.externalTripIdIn,
            has_driver_entered_notes: queryArg.hasDriverEnteredNotes,
            has_invoice: queryArg.hasInvoice,
            has_paid_invoice: queryArg.hasPaidInvoice,
            id__in: queryArg.idIn,
            intermediary__in: queryArg.intermediaryIn,
            is_from_csv: queryArg.isFromCsv,
            not_tag__in: queryArg.notTagIn,
            one_schema_template_id__in: queryArg.oneSchemaTemplateIdIn,
            one_schema_template_multi_id__in:
              queryArg.oneSchemaTemplateMultiIdIn,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            passenger__in: queryArg.passengerIn,
            passengers: queryArg.passengers,
            payer__in: queryArg.payerIn,
            payers: queryArg.payers,
            pickup_municipality__in: queryArg.pickupMunicipalityIn,
            price_max: queryArg.priceMax,
            price_min: queryArg.priceMin,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            search: queryArg.search,
            space_type: queryArg.spaceType,
            space_type__in: queryArg.spaceTypeIn,
            status: queryArg.status,
            status__in: queryArg.statusIn,
            tag__in: queryArg.tagIn,
            tags: queryArg.tags,
            vehicle_id__in: queryArg.vehicleIdIn,
            vehicles: queryArg.vehicles,
          },
        }),
        providesTags: ['trips'],
      }),
      tripsCreate: build.mutation<TripsCreateApiResponse, TripsCreateApiArg>({
        query: (queryArg) => ({
          url: `/trips/`,
          method: 'POST',
          body: queryArg.tripsBulkCreate,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsRetrieve: build.query<TripsRetrieveApiResponse, TripsRetrieveApiArg>(
        {
          query: (queryArg) => ({
            url: `/trips/${queryArg.id}/`,
            headers: { 'Organization-ID': queryArg['Organization-ID'] },
          }),
          providesTags: ['trips'],
        }
      ),
      tripsPartialUpdate: build.mutation<
        TripsPartialUpdateApiResponse,
        TripsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedTrip,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsDestroy: build.mutation<TripsDestroyApiResponse, TripsDestroyApiArg>(
        {
          query: (queryArg) => ({
            url: `/trips/${queryArg.id}/`,
            method: 'DELETE',
            headers: { 'Organization-ID': queryArg['Organization-ID'] },
          }),
          invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
        }
      ),
      tripsAcceptPartialUpdate: build.mutation<
        TripsAcceptPartialUpdateApiResponse,
        TripsAcceptPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/accept/`,
          method: 'PATCH',
          body: queryArg.patchedTripAccept,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsAcceptCancellationRequestPartialUpdate: build.mutation<
        TripsAcceptCancellationRequestPartialUpdateApiResponse,
        TripsAcceptCancellationRequestPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/accept-cancellation-request/`,
          method: 'PATCH',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsActivateWillCallPartialUpdate: build.mutation<
        TripsActivateWillCallPartialUpdateApiResponse,
        TripsActivateWillCallPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/activate-will-call/`,
          method: 'PATCH',
          body: queryArg.patchedTripActivateWillCall,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsAddTripLegPartialUpdate: build.mutation<
        TripsAddTripLegPartialUpdateApiResponse,
        TripsAddTripLegPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/add-trip-leg/`,
          method: 'PATCH',
          body: queryArg.patchedTripAddTripLeg,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsAssignPartialUpdate: build.mutation<
        TripsAssignPartialUpdateApiResponse,
        TripsAssignPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/assign/`,
          method: 'PATCH',
          body: queryArg.patchedTripAssign,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsCancelPartialUpdate: build.mutation<
        TripsCancelPartialUpdateApiResponse,
        TripsCancelPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/cancel/`,
          method: 'PATCH',
          body: queryArg.patchedTripCancel,
          headers: {
            'Device-Requested-At': queryArg['Device-Requested-At'],
            Heading: queryArg.heading,
            Latitude: queryArg.latitude,
            'Location-Accuracy': queryArg['Location-Accuracy'],
            'Location-Queried-At': queryArg['Location-Queried-At'],
            Longitude: queryArg.longitude,
            'Organization-ID': queryArg['Organization-ID'],
            Speed: queryArg.speed,
          },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsCancelCodesRetrieve: build.query<
        TripsCancelCodesRetrieveApiResponse,
        TripsCancelCodesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/cancel-codes/`,
          headers: {
            'Device-Requested-At': queryArg['Device-Requested-At'],
            Heading: queryArg.heading,
            Latitude: queryArg.latitude,
            'Location-Accuracy': queryArg['Location-Accuracy'],
            'Location-Queried-At': queryArg['Location-Queried-At'],
            Longitude: queryArg.longitude,
            'Organization-ID': queryArg['Organization-ID'],
            Speed: queryArg.speed,
          },
        }),
        providesTags: ['trips'],
      }),
      tripsCancelReasonsRetrieve: build.query<
        TripsCancelReasonsRetrieveApiResponse,
        TripsCancelReasonsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/cancel-reasons/`,
          headers: {
            'Device-Requested-At': queryArg['Device-Requested-At'],
            Heading: queryArg.heading,
            Latitude: queryArg.latitude,
            'Location-Accuracy': queryArg['Location-Accuracy'],
            'Location-Queried-At': queryArg['Location-Queried-At'],
            Longitude: queryArg.longitude,
            'Organization-ID': queryArg['Organization-ID'],
            Speed: queryArg.speed,
          },
        }),
        providesTags: ['trips'],
      }),
      tripsCancellationRequestPartialUpdate: build.mutation<
        TripsCancellationRequestPartialUpdateApiResponse,
        TripsCancellationRequestPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/cancellation-request/`,
          method: 'PATCH',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsCompletePartialUpdate: build.mutation<
        TripsCompletePartialUpdateApiResponse,
        TripsCompletePartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/complete/`,
          method: 'PATCH',
          body: queryArg.patchedTripComplete,
          headers: {
            'Device-Requested-At': queryArg['Device-Requested-At'],
            Heading: queryArg.heading,
            Latitude: queryArg.latitude,
            'Location-Accuracy': queryArg['Location-Accuracy'],
            'Location-Queried-At': queryArg['Location-Queried-At'],
            Longitude: queryArg.longitude,
            'Organization-ID': queryArg['Organization-ID'],
            Speed: queryArg.speed,
          },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsCorrelatedList: build.query<
        TripsCorrelatedListApiResponse,
        TripsCorrelatedListApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/correlated/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['trips'],
      }),
      tripsCreatesList: build.query<
        TripsCreatesListApiResponse,
        TripsCreatesListApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/creates/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['trips'],
      }),
      tripsDriverEnteredNotesPartialUpdate: build.mutation<
        TripsDriverEnteredNotesPartialUpdateApiResponse,
        TripsDriverEnteredNotesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/driver-entered-notes/`,
          method: 'PATCH',
          body: queryArg.patchedTripUpdateDriverEnteredNotes,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsEventManualCreatePartialUpdate: build.mutation<
        TripsEventManualCreatePartialUpdateApiResponse,
        TripsEventManualCreatePartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/event-manual-create/`,
          method: 'PATCH',
          body: queryArg.patchedTripManualUpdate,
          headers: {
            'Device-Requested-At': queryArg['Device-Requested-At'],
            Heading: queryArg.heading,
            Latitude: queryArg.latitude,
            'Location-Accuracy': queryArg['Location-Accuracy'],
            'Location-Queried-At': queryArg['Location-Queried-At'],
            Longitude: queryArg.longitude,
            'Organization-ID': queryArg['Organization-ID'],
            Speed: queryArg.speed,
          },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsEventsList: build.query<
        TripsEventsListApiResponse,
        TripsEventsListApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/events/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['trips'],
      }),
      tripsLocationsList: build.query<
        TripsLocationsListApiResponse,
        TripsLocationsListApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/locations/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page },
        }),
        providesTags: ['trips'],
      }),
      tripsLockPartialUpdate: build.mutation<
        TripsLockPartialUpdateApiResponse,
        TripsLockPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/lock/`,
          method: 'PATCH',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsOverrideStatusPartialUpdate: build.mutation<
        TripsOverrideStatusPartialUpdateApiResponse,
        TripsOverrideStatusPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/override-status/`,
          method: 'PATCH',
          body: queryArg.patchedTripOverrideStatusChange,
          headers: {
            'Device-Requested-At': queryArg['Device-Requested-At'],
            Heading: queryArg.heading,
            Latitude: queryArg.latitude,
            'Location-Accuracy': queryArg['Location-Accuracy'],
            'Location-Queried-At': queryArg['Location-Queried-At'],
            Longitude: queryArg.longitude,
            'Organization-ID': queryArg['Organization-ID'],
            Speed: queryArg.speed,
          },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsPriceSummaryRetrieve: build.query<
        TripsPriceSummaryRetrieveApiResponse,
        TripsPriceSummaryRetrieveApiArg
      >({
        query: (queryArg) => ({ url: `/trips/${queryArg.id}/price-summary/` }),
        providesTags: ['trips'],
      }),
      tripsPublicTripTrackingLinkRetrieve: build.query<
        TripsPublicTripTrackingLinkRetrieveApiResponse,
        TripsPublicTripTrackingLinkRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/public-trip-tracking-link/`,
        }),
        providesTags: ['trips'],
      }),
      tripsReassignPartialUpdate: build.mutation<
        TripsReassignPartialUpdateApiResponse,
        TripsReassignPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/reassign/`,
          method: 'PATCH',
          body: queryArg.patchedTripReassign,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsRejectPartialUpdate: build.mutation<
        TripsRejectPartialUpdateApiResponse,
        TripsRejectPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/reject/`,
          method: 'PATCH',
          body: queryArg.patchedTripReject,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsRejectCancellationRequestPartialUpdate: build.mutation<
        TripsRejectCancellationRequestPartialUpdateApiResponse,
        TripsRejectCancellationRequestPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/reject-cancellation-request/`,
          method: 'PATCH',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsRejectCodesRetrieve: build.query<
        TripsRejectCodesRetrieveApiResponse,
        TripsRejectCodesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/reject-codes/`,
          headers: {
            'Device-Requested-At': queryArg['Device-Requested-At'],
            Heading: queryArg.heading,
            Latitude: queryArg.latitude,
            'Location-Accuracy': queryArg['Location-Accuracy'],
            'Location-Queried-At': queryArg['Location-Queried-At'],
            Longitude: queryArg.longitude,
            'Organization-ID': queryArg['Organization-ID'],
            Speed: queryArg.speed,
          },
        }),
        providesTags: ['trips'],
      }),
      tripsRejectReasonsRetrieve: build.query<
        TripsRejectReasonsRetrieveApiResponse,
        TripsRejectReasonsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/reject-reasons/`,
          headers: {
            'Device-Requested-At': queryArg['Device-Requested-At'],
            Heading: queryArg.heading,
            Latitude: queryArg.latitude,
            'Location-Accuracy': queryArg['Location-Accuracy'],
            'Location-Queried-At': queryArg['Location-Queried-At'],
            Longitude: queryArg.longitude,
            'Organization-ID': queryArg['Organization-ID'],
            Speed: queryArg.speed,
          },
        }),
        providesTags: ['trips'],
      }),
      tripsRelatedList: build.query<
        TripsRelatedListApiResponse,
        TripsRelatedListApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/related/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['trips'],
      }),
      tripsRemoveCancellationRequestPartialUpdate: build.mutation<
        TripsRemoveCancellationRequestPartialUpdateApiResponse,
        TripsRemoveCancellationRequestPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/remove-cancellation-request/`,
          method: 'PATCH',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsSignaturesList: build.query<
        TripsSignaturesListApiResponse,
        TripsSignaturesListApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/signatures/`,
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['trips'],
      }),
      tripsStatusPartialUpdate: build.mutation<
        TripsStatusPartialUpdateApiResponse,
        TripsStatusPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/status/`,
          method: 'PATCH',
          body: queryArg.patchedTripStatusChange,
          headers: {
            'Device-Requested-At': queryArg['Device-Requested-At'],
            Heading: queryArg.heading,
            Latitude: queryArg.latitude,
            'Location-Accuracy': queryArg['Location-Accuracy'],
            'Location-Queried-At': queryArg['Location-Queried-At'],
            Longitude: queryArg.longitude,
            'Organization-ID': queryArg['Organization-ID'],
            Speed: queryArg.speed,
          },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsSummaryRetrieve: build.query<
        TripsSummaryRetrieveApiResponse,
        TripsSummaryRetrieveApiArg
      >({
        query: (queryArg) => ({ url: `/trips/${queryArg.id}/summary/` }),
        providesTags: ['trips'],
      }),
      tripsTurnbackReasonsRetrieve: build.query<
        TripsTurnbackReasonsRetrieveApiResponse,
        TripsTurnbackReasonsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/turnback-reasons/`,
          headers: {
            'Device-Requested-At': queryArg['Device-Requested-At'],
            Heading: queryArg.heading,
            Latitude: queryArg.latitude,
            'Location-Accuracy': queryArg['Location-Accuracy'],
            'Location-Queried-At': queryArg['Location-Queried-At'],
            Longitude: queryArg.longitude,
            'Organization-ID': queryArg['Organization-ID'],
            Speed: queryArg.speed,
          },
        }),
        providesTags: ['trips'],
      }),
      tripsUnassignPartialUpdate: build.mutation<
        TripsUnassignPartialUpdateApiResponse,
        TripsUnassignPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/unassign/`,
          method: 'PATCH',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsUncancelPartialUpdate: build.mutation<
        TripsUncancelPartialUpdateApiResponse,
        TripsUncancelPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/uncancel/`,
          method: 'PATCH',
          body: queryArg.patchedTripUncancel,
          headers: {
            'Device-Requested-At': queryArg['Device-Requested-At'],
            Heading: queryArg.heading,
            Latitude: queryArg.latitude,
            'Location-Accuracy': queryArg['Location-Accuracy'],
            'Location-Queried-At': queryArg['Location-Queried-At'],
            Longitude: queryArg.longitude,
            'Organization-ID': queryArg['Organization-ID'],
            Speed: queryArg.speed,
          },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsUnlockPartialUpdate: build.mutation<
        TripsUnlockPartialUpdateApiResponse,
        TripsUnlockPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/unlock/`,
          method: 'PATCH',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsUnrejectPartialUpdate: build.mutation<
        TripsUnrejectPartialUpdateApiResponse,
        TripsUnrejectPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/unreject/`,
          method: 'PATCH',
          body: queryArg.patchedTripUnreject,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsUpdatePickupAtPartialUpdate: build.mutation<
        TripsUpdatePickupAtPartialUpdateApiResponse,
        TripsUpdatePickupAtPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/update-pickup-at/`,
          method: 'PATCH',
          body: queryArg.patchedTripUpdatePickupAt,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsUpdatesList: build.query<
        TripsUpdatesListApiResponse,
        TripsUpdatesListApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/updates/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['trips'],
      }),
      tripsValidatePartialUpdate: build.mutation<
        TripsValidatePartialUpdateApiResponse,
        TripsValidatePartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/${queryArg.id}/validate/`,
          method: 'PATCH',
          body: queryArg.patchedTripValidate,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsActivatedWillCallCountRetrieve: build.query<
        TripsActivatedWillCallCountRetrieveApiResponse,
        TripsActivatedWillCallCountRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/activated-will-call-count/`,
          params: {
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
          },
        }),
        providesTags: ['trips'],
      }),
      tripsAllList: build.query<TripsAllListApiResponse, TripsAllListApiArg>({
        query: (queryArg) => ({
          url: `/trips/all/`,
          params: {
            canceled_reason__in: queryArg.canceledReasonIn,
            created_at_range_end: queryArg.createdAtRangeEnd,
            created_at_range_start: queryArg.createdAtRangeStart,
            driver__in: queryArg.driverIn,
            dropoff_municipality__in: queryArg.dropoffMunicipalityIn,
            external_trip_id__in: queryArg.externalTripIdIn,
            has_driver_entered_notes: queryArg.hasDriverEnteredNotes,
            has_invoice: queryArg.hasInvoice,
            has_paid_invoice: queryArg.hasPaidInvoice,
            id__in: queryArg.idIn,
            intermediary__in: queryArg.intermediaryIn,
            is_from_csv: queryArg.isFromCsv,
            not_tag__in: queryArg.notTagIn,
            one_schema_template_id__in: queryArg.oneSchemaTemplateIdIn,
            one_schema_template_multi_id__in:
              queryArg.oneSchemaTemplateMultiIdIn,
            ordering: queryArg.ordering,
            page: queryArg.page,
            passenger__in: queryArg.passengerIn,
            passengers: queryArg.passengers,
            payer__in: queryArg.payerIn,
            payers: queryArg.payers,
            pickup_municipality__in: queryArg.pickupMunicipalityIn,
            price_max: queryArg.priceMax,
            price_min: queryArg.priceMin,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            search: queryArg.search,
            space_type: queryArg.spaceType,
            space_type__in: queryArg.spaceTypeIn,
            status: queryArg.status,
            status__in: queryArg.statusIn,
            tag__in: queryArg.tagIn,
            tags: queryArg.tags,
            vehicle_id__in: queryArg.vehicleIdIn,
            vehicles: queryArg.vehicles,
          },
        }),
        providesTags: ['trips'],
      }),
      tripsBulkAcceptCreate: build.mutation<
        TripsBulkAcceptCreateApiResponse,
        TripsBulkAcceptCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/bulk-accept/`,
          method: 'POST',
          body: queryArg.bulkTripAccept,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsBulkAssignCreate: build.mutation<
        TripsBulkAssignCreateApiResponse,
        TripsBulkAssignCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/bulk-assign/`,
          method: 'POST',
          body: queryArg.bulkTripAssign,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsBulkCancelCreate: build.mutation<
        TripsBulkCancelCreateApiResponse,
        TripsBulkCancelCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/bulk-cancel/`,
          method: 'POST',
          body: queryArg.bulkTripCancel,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsBulkCancelReasonsCreate: build.query<
        TripsBulkCancelReasonsCreateApiResponse,
        TripsBulkCancelReasonsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/bulk-cancel-reasons/`,
          method: 'POST',
          body: queryArg.bulkTripCancelReasons,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['trips'],
      }),
      tripsBulkPriceCreate: build.mutation<
        TripsBulkPriceCreateApiResponse,
        TripsBulkPriceCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/bulk-price/`,
          method: 'POST',
          body: queryArg.bulkTripPriceChange,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsBulkPriceConfirmCreate: build.mutation<
        TripsBulkPriceConfirmCreateApiResponse,
        TripsBulkPriceConfirmCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/bulk-price/confirm/`,
          method: 'POST',
          body: queryArg.bulkTripPriceChangeConfirm,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsBulkRejectCreate: build.mutation<
        TripsBulkRejectCreateApiResponse,
        TripsBulkRejectCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/bulk-reject/`,
          method: 'POST',
          body: queryArg.bulkTripReject,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsBulkTripEventsCreate: build.mutation<
        TripsBulkTripEventsCreateApiResponse,
        TripsBulkTripEventsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/bulk-trip-events/`,
          method: 'POST',
          body: queryArg.bulkTripIdRequest,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsBulkUnassignCreate: build.mutation<
        TripsBulkUnassignCreateApiResponse,
        TripsBulkUnassignCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/bulk-unassign/`,
          method: 'POST',
          body: queryArg.bulkTripUnassign,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsBulkValidateCreate: build.mutation<
        TripsBulkValidateCreateApiResponse,
        TripsBulkValidateCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/bulk-validate/`,
          method: 'POST',
          body: queryArg.bulkTripValidate,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsExportRetrieve: build.query<
        TripsExportRetrieveApiResponse,
        TripsExportRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/export/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            canceled_reason__in: queryArg.canceledReasonIn,
            created_at_range_end: queryArg.createdAtRangeEnd,
            created_at_range_start: queryArg.createdAtRangeStart,
            driver__in: queryArg.driverIn,
            dropoff_municipality__in: queryArg.dropoffMunicipalityIn,
            external_trip_id__in: queryArg.externalTripIdIn,
            has_driver_entered_notes: queryArg.hasDriverEnteredNotes,
            has_invoice: queryArg.hasInvoice,
            has_paid_invoice: queryArg.hasPaidInvoice,
            id__in: queryArg.idIn,
            intermediary__in: queryArg.intermediaryIn,
            is_from_csv: queryArg.isFromCsv,
            not_tag__in: queryArg.notTagIn,
            one_schema_template_id__in: queryArg.oneSchemaTemplateIdIn,
            one_schema_template_multi_id__in:
              queryArg.oneSchemaTemplateMultiIdIn,
            output_set: queryArg.outputSet,
            passenger__in: queryArg.passengerIn,
            passengers: queryArg.passengers,
            payer__in: queryArg.payerIn,
            payers: queryArg.payers,
            pickup_municipality__in: queryArg.pickupMunicipalityIn,
            price_max: queryArg.priceMax,
            price_min: queryArg.priceMin,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            space_type: queryArg.spaceType,
            space_type__in: queryArg.spaceTypeIn,
            status: queryArg.status,
            status__in: queryArg.statusIn,
            tag__in: queryArg.tagIn,
            tags: queryArg.tags,
            vehicle_id__in: queryArg.vehicleIdIn,
            vehicles: queryArg.vehicles,
          },
        }),
        providesTags: ['trips'],
      }),
      tripsImportCreate: build.mutation<
        TripsImportCreateApiResponse,
        TripsImportCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/import/`,
          method: 'POST',
          body: queryArg.tripImportViewSet,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsMtmDriverManifestList: build.query<
        TripsMtmDriverManifestListApiResponse,
        TripsMtmDriverManifestListApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/mtm-driver-manifest/`,
          params: {
            page: queryArg.page,
            page_size: queryArg.pageSize,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
          },
        }),
        providesTags: ['trips'],
      }),
      tripsMultiloadList: build.query<
        TripsMultiloadListApiResponse,
        TripsMultiloadListApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/multiload/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { page: queryArg.page, page_size: queryArg.pageSize },
        }),
        providesTags: ['trips'],
      }),
      tripsMultiloadCreate: build.mutation<
        TripsMultiloadCreateApiResponse,
        TripsMultiloadCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/multiload/`,
          method: 'POST',
          body: queryArg.multiload,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsMultiloadRetrieve: build.query<
        TripsMultiloadRetrieveApiResponse,
        TripsMultiloadRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/multiload/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['trips'],
      }),
      tripsMultiloadPartialUpdate: build.mutation<
        TripsMultiloadPartialUpdateApiResponse,
        TripsMultiloadPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/multiload/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedMultiload,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsMultiloadDestroy: build.mutation<
        TripsMultiloadDestroyApiResponse,
        TripsMultiloadDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/multiload/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsMultiloadMobileRetrieve: build.query<
        TripsMultiloadMobileRetrieveApiResponse,
        TripsMultiloadMobileRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/multiload/${queryArg.id}/mobile/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['trips'],
      }),
      tripsRequestedCountRetrieve: build.query<
        TripsRequestedCountRetrieveApiResponse,
        TripsRequestedCountRetrieveApiArg
      >({
        query: () => ({ url: `/trips/requested-count/` }),
        providesTags: ['trips'],
      }),
      tripsSubscriptionsList: build.query<
        TripsSubscriptionsListApiResponse,
        TripsSubscriptionsListApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/subscriptions/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: {
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            payers: queryArg.payers,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            search: queryArg.search,
          },
        }),
        providesTags: ['trips'],
      }),
      tripsSubscriptionsCreate: build.mutation<
        TripsSubscriptionsCreateApiResponse,
        TripsSubscriptionsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/subscriptions/`,
          method: 'POST',
          body: queryArg.tripSubscription,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsSubscriptionsRetrieve: build.query<
        TripsSubscriptionsRetrieveApiResponse,
        TripsSubscriptionsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/subscriptions/${queryArg.id}/`,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        providesTags: ['trips'],
      }),
      tripsSubscriptionsPartialUpdate: build.mutation<
        TripsSubscriptionsPartialUpdateApiResponse,
        TripsSubscriptionsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/subscriptions/${queryArg.id}/`,
          method: 'PATCH',
          body: queryArg.patchedTripSubscription,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsSubscriptionsDestroy: build.mutation<
        TripsSubscriptionsDestroyApiResponse,
        TripsSubscriptionsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/subscriptions/${queryArg.id}/`,
          method: 'DELETE',
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
          params: { delete: queryArg['delete'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsSuggestedPickupAtCreate: build.mutation<
        TripsSuggestedPickupAtCreateApiResponse,
        TripsSuggestedPickupAtCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/suggested-pickup-at/`,
          method: 'POST',
          body: queryArg.tripSuggestedPickupTime,
          headers: { 'Organization-ID': queryArg['Organization-ID'] },
        }),
        invalidatesTags: ['trips', 'dispatch', 'run-bambi-run'],
      }),
      tripsTripSubscriptionExpiringSoonCountRetrieve: build.query<
        TripsTripSubscriptionExpiringSoonCountRetrieveApiResponse,
        TripsTripSubscriptionExpiringSoonCountRetrieveApiArg
      >({
        query: () => ({ url: `/trips/trip-subscription-expiring-soon-count/` }),
        providesTags: ['trips'],
      }),
      tripsWithSummaryList: build.query<
        TripsWithSummaryListApiResponse,
        TripsWithSummaryListApiArg
      >({
        query: (queryArg) => ({
          url: `/trips/with-summary/`,
          params: {
            canceled_reason__in: queryArg.canceledReasonIn,
            created_at_range_end: queryArg.createdAtRangeEnd,
            created_at_range_start: queryArg.createdAtRangeStart,
            driver__in: queryArg.driverIn,
            dropoff_municipality__in: queryArg.dropoffMunicipalityIn,
            external_trip_id__in: queryArg.externalTripIdIn,
            has_driver_entered_notes: queryArg.hasDriverEnteredNotes,
            has_invoice: queryArg.hasInvoice,
            has_paid_invoice: queryArg.hasPaidInvoice,
            id__in: queryArg.idIn,
            intermediary__in: queryArg.intermediaryIn,
            is_from_csv: queryArg.isFromCsv,
            not_tag__in: queryArg.notTagIn,
            one_schema_template_id__in: queryArg.oneSchemaTemplateIdIn,
            one_schema_template_multi_id__in:
              queryArg.oneSchemaTemplateMultiIdIn,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            passenger__in: queryArg.passengerIn,
            passengers: queryArg.passengers,
            payer__in: queryArg.payerIn,
            payers: queryArg.payers,
            pickup_municipality__in: queryArg.pickupMunicipalityIn,
            price_max: queryArg.priceMax,
            price_min: queryArg.priceMin,
            range_end: queryArg.rangeEnd,
            range_start: queryArg.rangeStart,
            search: queryArg.search,
            space_type: queryArg.spaceType,
            space_type__in: queryArg.spaceTypeIn,
            status: queryArg.status,
            status__in: queryArg.statusIn,
            tag__in: queryArg.tagIn,
            tags: queryArg.tags,
            vehicle_id__in: queryArg.vehicleIdIn,
            vehicles: queryArg.vehicles,
          },
        }),
        providesTags: ['trips'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as bambiApi };
export type TripsListApiResponse = /** status 200  */ PaginatedTripListListRead;
export type TripsListApiArg = {
  'Organization-ID'?: string;
  /** Multiple values may be separated by commas. */
  canceledReasonIn?: (
    | ''
    | 'appointment canceled'
    | 'no show'
    | 'other'
    | 'passenger not ready'
    | 'passenger refused'
    | 'passenger unable'
    | 'payer canceled'
    | 'scheduling conflict'
    | 'user requested'
  )[];
  createdAtRangeEnd?: string;
  createdAtRangeStart?: string;
  /** Multiple values may be separated by commas. */
  driverIn?: (string | null)[];
  /** Multiple values may be separated by commas. */
  dropoffMunicipalityIn?: string[];
  /** Multiple values may be separated by commas. */
  externalTripIdIn?: string[];
  hasDriverEnteredNotes?: boolean;
  hasInvoice?: boolean;
  hasPaidInvoice?: boolean;
  /** Multiple values may be separated by commas. */
  idIn?: string[];
  /** Multiple values may be separated by commas. */
  intermediaryIn?: (
    | ''
    | 'alivi'
    | 'call_the_car'
    | 'clearview'
    | 'cts'
    | 'kinetik'
    | 'momentm'
    | 'mtm'
    | 'provide_a_ride'
    | 'tennessee_carriers'
    | 'vectorcare'
    | 'verida'
    | 'welltrans'
  )[];
  isFromCsv?: boolean;
  /** Multiple values may be separated by commas. */
  notTagIn?: string[];
  /** Multiple values may be separated by commas. */
  oneSchemaTemplateIdIn?: (string | null)[];
  /** Multiple values may be separated by commas. */
  oneSchemaTemplateMultiIdIn?: (string | null)[];
  /** Sort trips by an attribute */
  ordering?:
    | 'created_at'
    | 'dropoff_address'
    | 'input_price_cents'
    | 'name'
    | 'payer_name'
    | 'pickup_address'
    | 'scheduled_pickup_at'
    | 'status';
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** Multiple values may be separated by commas. */
  passengerIn?: string[];
  passengers?: string;
  /** Multiple values may be separated by commas. */
  payerIn?: string[];
  payers?: string;
  /** Multiple values may be separated by commas. */
  pickupMunicipalityIn?: string[];
  /** The manually inputted price of the trip */
  priceMax?: number | null;
  /** The manually inputted price of the trip */
  priceMin?: number | null;
  rangeEnd?: string;
  rangeStart?: string;
  /** A search term. */
  search?: string;
  spaceType?: string;
  /** Multiple values may be separated by commas. */
  spaceTypeIn?: (
    | 'ambulatory'
    | 'broda chair'
    | 'delivery'
    | 'geri chair'
    | 'stretcher'
    | 'stretcher xl'
    | 'wheelchair'
    | 'wheelchair xl'
  )[];
  status?: string;
  /** Multiple values may be separated by commas. */
  statusIn?: (
    | 'assigned'
    | 'at dropoff'
    | 'at pickup'
    | 'canceled'
    | 'completed'
    | 'en route'
    | 'pending'
    | 'rejected'
    | 'requested'
    | 'transporting'
  )[];
  /** Multiple values may be separated by commas. */
  tagIn?: string[];
  tags?: string;
  /** Multiple values may be separated by commas. */
  vehicleIdIn?: string[];
  vehicles?: string;
};
export type TripsCreateApiResponse = /** status 201  */ TripsBulkCreateRead;
export type TripsCreateApiArg = {
  'Organization-ID'?: string;
  tripsBulkCreate: TripsBulkCreateWrite;
};
export type TripsRetrieveApiResponse = /** status 200  */ TripRead;
export type TripsRetrieveApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this trip. */
  id: string;
};
export type TripsPartialUpdateApiResponse = /** status 200  */ TripRead;
export type TripsPartialUpdateApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this trip. */
  id: string;
  patchedTrip: PatchedTripWrite;
};
export type TripsDestroyApiResponse = /** status 204 No response body */ void;
export type TripsDestroyApiArg = {
  'Organization-ID'?: string;
  /** A UUID string identifying this trip. */
  id: string;
};
export type TripsAcceptPartialUpdateApiResponse = /** status 200  */ TripAccept;
export type TripsAcceptPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
  patchedTripAccept: PatchedTripAcceptWrite;
};
export type TripsAcceptCancellationRequestPartialUpdateApiResponse =
  /** status 200 No response body */ void;
export type TripsAcceptCancellationRequestPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
};
export type TripsActivateWillCallPartialUpdateApiResponse =
  /** status 200  */ TripActivateWillCall;
export type TripsActivateWillCallPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
  patchedTripActivateWillCall: PatchedTripActivateWillCallWrite;
};
export type TripsAddTripLegPartialUpdateApiResponse =
  /** status 200  */ TripAddTripLegRead;
export type TripsAddTripLegPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
  patchedTripAddTripLeg: PatchedTripAddTripLegWrite;
};
export type TripsAssignPartialUpdateApiResponse = /** status 200  */ TripAssign;
export type TripsAssignPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
  patchedTripAssign: PatchedTripAssignWrite;
};
export type TripsCancelPartialUpdateApiResponse = /** status 200  */ TripCancel;
export type TripsCancelPartialUpdateApiArg = {
  'Device-Requested-At'?: string;
  /** Heading in degrees. */
  heading?: string;
  latitude?: string;
  /** Location accuracy in meters. */
  'Location-Accuracy'?: string;
  'Location-Queried-At'?: string;
  longitude?: string;
  'Organization-ID'?: string;
  /** Speed in meters per second. */
  speed?: string;
  id: string;
  patchedTripCancel: PatchedTripCancelWrite;
};
export type TripsCancelCodesRetrieveApiResponse =
  /** status 200  */ TripCancelReasonCodeRead;
export type TripsCancelCodesRetrieveApiArg = {
  'Device-Requested-At'?: string;
  /** Heading in degrees. */
  heading?: string;
  latitude?: string;
  /** Location accuracy in meters. */
  'Location-Accuracy'?: string;
  'Location-Queried-At'?: string;
  longitude?: string;
  'Organization-ID'?: string;
  /** Speed in meters per second. */
  speed?: string;
  id: string;
};
export type TripsCancelReasonsRetrieveApiResponse =
  /** status 200  */ TripCancelReasonsRead;
export type TripsCancelReasonsRetrieveApiArg = {
  'Device-Requested-At'?: string;
  /** Heading in degrees. */
  heading?: string;
  latitude?: string;
  /** Location accuracy in meters. */
  'Location-Accuracy'?: string;
  'Location-Queried-At'?: string;
  longitude?: string;
  'Organization-ID'?: string;
  /** Speed in meters per second. */
  speed?: string;
  id: string;
};
export type TripsCancellationRequestPartialUpdateApiResponse =
  /** status 200 No response body */ void;
export type TripsCancellationRequestPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
};
export type TripsCompletePartialUpdateApiResponse =
  /** status 200  */ TripComplete;
export type TripsCompletePartialUpdateApiArg = {
  'Device-Requested-At'?: string;
  /** Heading in degrees. */
  heading?: string;
  latitude?: string;
  /** Location accuracy in meters. */
  'Location-Accuracy'?: string;
  'Location-Queried-At'?: string;
  longitude?: string;
  'Organization-ID'?: string;
  /** Speed in meters per second. */
  speed?: string;
  id: string;
  patchedTripComplete: PatchedTripCompleteWrite;
};
export type TripsCorrelatedListApiResponse =
  /** status 200  */ PaginatedTripListRead;
export type TripsCorrelatedListApiArg = {
  'Organization-ID'?: string;
  id: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type TripsCreatesListApiResponse =
  /** status 200  */ PaginatedTripCreateListRead;
export type TripsCreatesListApiArg = {
  'Organization-ID'?: string;
  id: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type TripsDriverEnteredNotesPartialUpdateApiResponse =
  /** status 200  */ TripUpdateDriverEnteredNotes;
export type TripsDriverEnteredNotesPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
  patchedTripUpdateDriverEnteredNotes: PatchedTripUpdateDriverEnteredNotesWrite;
};
export type TripsEventManualCreatePartialUpdateApiResponse =
  /** status 200  */ TripManualUpdate;
export type TripsEventManualCreatePartialUpdateApiArg = {
  'Device-Requested-At'?: string;
  /** Heading in degrees. */
  heading?: string;
  latitude?: string;
  /** Location accuracy in meters. */
  'Location-Accuracy'?: string;
  'Location-Queried-At'?: string;
  longitude?: string;
  'Organization-ID'?: string;
  /** Speed in meters per second. */
  speed?: string;
  id: string;
  patchedTripManualUpdate: PatchedTripManualUpdateWrite;
};
export type TripsEventsListApiResponse =
  /** status 200  */ PaginatedTripEventListRead;
export type TripsEventsListApiArg = {
  'Organization-ID'?: string;
  id: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type TripsLocationsListApiResponse =
  /** status 200  */ PaginatedLocationLogEntryMinimalReadOnlyListRead;
export type TripsLocationsListApiArg = {
  'Organization-ID'?: string;
  id: string;
  /** A page number within the paginated result set. */
  page?: number;
};
export type TripsLockPartialUpdateApiResponse =
  /** status 200 No response body */ void;
export type TripsLockPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
};
export type TripsOverrideStatusPartialUpdateApiResponse =
  /** status 200  */ TripOverrideStatusChange;
export type TripsOverrideStatusPartialUpdateApiArg = {
  'Device-Requested-At'?: string;
  /** Heading in degrees. */
  heading?: string;
  latitude?: string;
  /** Location accuracy in meters. */
  'Location-Accuracy'?: string;
  'Location-Queried-At'?: string;
  longitude?: string;
  'Organization-ID'?: string;
  /** Speed in meters per second. */
  speed?: string;
  id: string;
  patchedTripOverrideStatusChange: PatchedTripOverrideStatusChangeWrite;
};
export type TripsPriceSummaryRetrieveApiResponse =
  /** status 200  */ TripPriceSummaryRead;
export type TripsPriceSummaryRetrieveApiArg = {
  id: string;
};
export type TripsPublicTripTrackingLinkRetrieveApiResponse =
  /** status 200  */ TripPublicTripTrackingLinkRead;
export type TripsPublicTripTrackingLinkRetrieveApiArg = {
  id: string;
};
export type TripsReassignPartialUpdateApiResponse =
  /** status 200  */ TripReassign;
export type TripsReassignPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
  patchedTripReassign: PatchedTripReassignWrite;
};
export type TripsRejectPartialUpdateApiResponse = /** status 200  */ TripReject;
export type TripsRejectPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
  patchedTripReject: PatchedTripRejectWrite;
};
export type TripsRejectCancellationRequestPartialUpdateApiResponse =
  /** status 200 No response body */ void;
export type TripsRejectCancellationRequestPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
};
export type TripsRejectCodesRetrieveApiResponse =
  /** status 200  */ TripRejectionReasonsRead;
export type TripsRejectCodesRetrieveApiArg = {
  'Device-Requested-At'?: string;
  /** Heading in degrees. */
  heading?: string;
  latitude?: string;
  /** Location accuracy in meters. */
  'Location-Accuracy'?: string;
  'Location-Queried-At'?: string;
  longitude?: string;
  'Organization-ID'?: string;
  /** Speed in meters per second. */
  speed?: string;
  id: string;
};
export type TripsRejectReasonsRetrieveApiResponse =
  /** status 200  */ TripRejectReasonsRead;
export type TripsRejectReasonsRetrieveApiArg = {
  'Device-Requested-At'?: string;
  /** Heading in degrees. */
  heading?: string;
  latitude?: string;
  /** Location accuracy in meters. */
  'Location-Accuracy'?: string;
  'Location-Queried-At'?: string;
  longitude?: string;
  'Organization-ID'?: string;
  /** Speed in meters per second. */
  speed?: string;
  id: string;
};
export type TripsRelatedListApiResponse =
  /** status 200  */ PaginatedTripListRead;
export type TripsRelatedListApiArg = {
  'Organization-ID'?: string;
  id: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type TripsRemoveCancellationRequestPartialUpdateApiResponse =
  /** status 200 No response body */ void;
export type TripsRemoveCancellationRequestPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
};
export type TripsSignaturesListApiResponse =
  /** status 200  */ PaginatedSignatureListRead;
export type TripsSignaturesListApiArg = {
  id: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type TripsStatusPartialUpdateApiResponse =
  /** status 200  */ TripStatusChange;
export type TripsStatusPartialUpdateApiArg = {
  'Device-Requested-At'?: string;
  /** Heading in degrees. */
  heading?: string;
  latitude?: string;
  /** Location accuracy in meters. */
  'Location-Accuracy'?: string;
  'Location-Queried-At'?: string;
  longitude?: string;
  'Organization-ID'?: string;
  /** Speed in meters per second. */
  speed?: string;
  id: string;
  patchedTripStatusChange: PatchedTripStatusChangeWrite;
};
export type TripsSummaryRetrieveApiResponse =
  /** status 200  */ TripSummaryRead;
export type TripsSummaryRetrieveApiArg = {
  id: string;
};
export type TripsTurnbackReasonsRetrieveApiResponse =
  /** status 200  */ TripTurnbackReasonRead;
export type TripsTurnbackReasonsRetrieveApiArg = {
  'Device-Requested-At'?: string;
  /** Heading in degrees. */
  heading?: string;
  latitude?: string;
  /** Location accuracy in meters. */
  'Location-Accuracy'?: string;
  'Location-Queried-At'?: string;
  longitude?: string;
  'Organization-ID'?: string;
  /** Speed in meters per second. */
  speed?: string;
  id: string;
};
export type TripsUnassignPartialUpdateApiResponse =
  /** status 200 No response body */ void;
export type TripsUnassignPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
};
export type TripsUncancelPartialUpdateApiResponse =
  /** status 200  */ TripUncancel;
export type TripsUncancelPartialUpdateApiArg = {
  'Device-Requested-At'?: string;
  /** Heading in degrees. */
  heading?: string;
  latitude?: string;
  /** Location accuracy in meters. */
  'Location-Accuracy'?: string;
  'Location-Queried-At'?: string;
  longitude?: string;
  'Organization-ID'?: string;
  /** Speed in meters per second. */
  speed?: string;
  id: string;
  patchedTripUncancel: PatchedTripUncancelWrite;
};
export type TripsUnlockPartialUpdateApiResponse =
  /** status 200 No response body */ void;
export type TripsUnlockPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
};
export type TripsUnrejectPartialUpdateApiResponse =
  /** status 200  */ TripUnreject;
export type TripsUnrejectPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
  patchedTripUnreject: PatchedTripUnrejectWrite;
};
export type TripsUpdatePickupAtPartialUpdateApiResponse =
  /** status 200  */ TripUpdatePickupAt;
export type TripsUpdatePickupAtPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
  patchedTripUpdatePickupAt: PatchedTripUpdatePickupAtWrite;
};
export type TripsUpdatesListApiResponse =
  /** status 200  */ PaginatedTripUpdateListRead;
export type TripsUpdatesListApiArg = {
  'Organization-ID'?: string;
  id: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type TripsValidatePartialUpdateApiResponse =
  /** status 200  */ TripValidateRead;
export type TripsValidatePartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
  patchedTripValidate: PatchedTripValidateWrite;
};
export type TripsActivatedWillCallCountRetrieveApiResponse =
  /** status 200  */ TripUnassignedActivatedWillCallCount;
export type TripsActivatedWillCallCountRetrieveApiArg = {
  rangeEnd: string;
  rangeStart: string;
};
export type TripsAllListApiResponse =
  /** status 200  */ PaginatedTripWithPriceSummaryListRead;
export type TripsAllListApiArg = {
  /** Multiple values may be separated by commas. */
  canceledReasonIn?: (
    | ''
    | 'appointment canceled'
    | 'no show'
    | 'other'
    | 'passenger not ready'
    | 'passenger refused'
    | 'passenger unable'
    | 'payer canceled'
    | 'scheduling conflict'
    | 'user requested'
  )[];
  createdAtRangeEnd?: string;
  createdAtRangeStart?: string;
  /** Multiple values may be separated by commas. */
  driverIn?: (string | null)[];
  /** Multiple values may be separated by commas. */
  dropoffMunicipalityIn?: string[];
  /** Multiple values may be separated by commas. */
  externalTripIdIn?: string[];
  hasDriverEnteredNotes?: boolean;
  hasInvoice?: boolean;
  hasPaidInvoice?: boolean;
  /** Multiple values may be separated by commas. */
  idIn?: string[];
  /** Multiple values may be separated by commas. */
  intermediaryIn?: (
    | ''
    | 'alivi'
    | 'call_the_car'
    | 'clearview'
    | 'cts'
    | 'kinetik'
    | 'momentm'
    | 'mtm'
    | 'provide_a_ride'
    | 'tennessee_carriers'
    | 'vectorcare'
    | 'verida'
    | 'welltrans'
  )[];
  isFromCsv?: boolean;
  /** Multiple values may be separated by commas. */
  notTagIn?: string[];
  /** Multiple values may be separated by commas. */
  oneSchemaTemplateIdIn?: (string | null)[];
  /** Multiple values may be separated by commas. */
  oneSchemaTemplateMultiIdIn?: (string | null)[];
  /** Sort trips by an attribute */
  ordering?:
    | 'created_at'
    | 'dropoff_address'
    | 'input_price_cents'
    | 'name'
    | 'payer_name'
    | 'pickup_address'
    | 'scheduled_pickup_at'
    | 'status';
  /** A page number within the paginated result set. */
  page?: number;
  /** Multiple values may be separated by commas. */
  passengerIn?: string[];
  passengers?: string;
  /** Multiple values may be separated by commas. */
  payerIn?: string[];
  payers?: string;
  /** Multiple values may be separated by commas. */
  pickupMunicipalityIn?: string[];
  /** The manually inputted price of the trip */
  priceMax?: number | null;
  /** The manually inputted price of the trip */
  priceMin?: number | null;
  rangeEnd?: string;
  rangeStart?: string;
  /** A search term. */
  search?: string;
  spaceType?: string;
  /** Multiple values may be separated by commas. */
  spaceTypeIn?: (
    | 'ambulatory'
    | 'broda chair'
    | 'delivery'
    | 'geri chair'
    | 'stretcher'
    | 'stretcher xl'
    | 'wheelchair'
    | 'wheelchair xl'
  )[];
  status?: string;
  /** Multiple values may be separated by commas. */
  statusIn?: (
    | 'assigned'
    | 'at dropoff'
    | 'at pickup'
    | 'canceled'
    | 'completed'
    | 'en route'
    | 'pending'
    | 'rejected'
    | 'requested'
    | 'transporting'
  )[];
  /** Multiple values may be separated by commas. */
  tagIn?: string[];
  tags?: string;
  /** Multiple values may be separated by commas. */
  vehicleIdIn?: string[];
  vehicles?: string;
};
export type TripsBulkAcceptCreateApiResponse =
  /** status 200  */ BulkTripAcceptResults;
export type TripsBulkAcceptCreateApiArg = {
  'Organization-ID'?: string;
  bulkTripAccept: BulkTripAcceptWrite;
};
export type TripsBulkAssignCreateApiResponse =
  /** status 201  */ BulkTripAssign;
export type TripsBulkAssignCreateApiArg = {
  'Organization-ID'?: string;
  bulkTripAssign: BulkTripAssignWrite;
};
export type TripsBulkCancelCreateApiResponse =
  /** status 200  */ BulkTripCancelResults;
export type TripsBulkCancelCreateApiArg = {
  'Organization-ID'?: string;
  bulkTripCancel: BulkTripCancelWrite;
};
export type TripsBulkCancelReasonsCreateApiResponse =
  /** status 200  */ BulkTripCancelReasonsRead;
export type TripsBulkCancelReasonsCreateApiArg = {
  'Organization-ID'?: string;
  bulkTripCancelReasons: BulkTripCancelReasonsWrite;
};
export type TripsBulkPriceCreateApiResponse =
  /** status 200  */ BulkTripPriceChangeResultsRead;
export type TripsBulkPriceCreateApiArg = {
  'Organization-ID'?: string;
  bulkTripPriceChange: BulkTripPriceChange;
};
export type TripsBulkPriceConfirmCreateApiResponse =
  /** status 200  */ BulkTripPriceChangeConfirmResultsRead;
export type TripsBulkPriceConfirmCreateApiArg = {
  'Organization-ID'?: string;
  bulkTripPriceChangeConfirm: BulkTripPriceChangeConfirm;
};
export type TripsBulkRejectCreateApiResponse =
  /** status 200  */ BulkTripRejectResults;
export type TripsBulkRejectCreateApiArg = {
  'Organization-ID'?: string;
  bulkTripReject: BulkTripRejectWrite;
};
export type TripsBulkTripEventsCreateApiResponse =
  /** status 200  */ PaginatedTripEventListRead;
export type TripsBulkTripEventsCreateApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  bulkTripIdRequest: BulkTripIdRequest;
};
export type TripsBulkUnassignCreateApiResponse =
  /** status 200  */ BulkTripUnassignResults;
export type TripsBulkUnassignCreateApiArg = {
  'Organization-ID'?: string;
  bulkTripUnassign: BulkTripUnassignWrite;
};
export type TripsBulkValidateCreateApiResponse =
  /** status 200  */ BulkTripValidateResults;
export type TripsBulkValidateCreateApiArg = {
  'Organization-ID'?: string;
  bulkTripValidate: BulkTripValidateWrite;
};
export type TripsExportRetrieveApiResponse = /** status 200  */ Blob;
export type TripsExportRetrieveApiArg = {
  'Organization-ID'?: string;
  /** Multiple values may be separated by commas. */
  canceledReasonIn?: (
    | ''
    | 'appointment canceled'
    | 'no show'
    | 'other'
    | 'passenger not ready'
    | 'passenger refused'
    | 'passenger unable'
    | 'payer canceled'
    | 'scheduling conflict'
    | 'user requested'
  )[];
  createdAtRangeEnd?: string;
  createdAtRangeStart?: string;
  /** Multiple values may be separated by commas. */
  driverIn?: (string | null)[];
  /** Multiple values may be separated by commas. */
  dropoffMunicipalityIn?: string[];
  /** Multiple values may be separated by commas. */
  externalTripIdIn?: string[];
  hasDriverEnteredNotes?: boolean;
  hasInvoice?: boolean;
  hasPaidInvoice?: boolean;
  /** Multiple values may be separated by commas. */
  idIn?: string[];
  /** Multiple values may be separated by commas. */
  intermediaryIn?: (
    | ''
    | 'alivi'
    | 'call_the_car'
    | 'clearview'
    | 'cts'
    | 'kinetik'
    | 'momentm'
    | 'mtm'
    | 'provide_a_ride'
    | 'tennessee_carriers'
    | 'vectorcare'
    | 'verida'
    | 'welltrans'
  )[];
  isFromCsv?: boolean;
  /** Multiple values may be separated by commas. */
  notTagIn?: string[];
  /** Multiple values may be separated by commas. */
  oneSchemaTemplateIdIn?: (string | null)[];
  /** Multiple values may be separated by commas. */
  oneSchemaTemplateMultiIdIn?: (string | null)[];
  outputSet?:
    | 'call_the_car'
    | 'evertransit'
    | 'kinetik'
    | 'kinetik_rcm'
    | 'mini'
    | 'modivcare'
    | 'mtm'
    | 'saferide'
    | 'tennessee_carriers'
    | 'welltrans'
    | 'with_price_summary';
  /** Multiple values may be separated by commas. */
  passengerIn?: string[];
  passengers?: string;
  /** Multiple values may be separated by commas. */
  payerIn?: string[];
  payers?: string;
  /** Multiple values may be separated by commas. */
  pickupMunicipalityIn?: string[];
  /** The manually inputted price of the trip */
  priceMax?: number | null;
  /** The manually inputted price of the trip */
  priceMin?: number | null;
  rangeEnd?: string;
  rangeStart?: string;
  spaceType?: string;
  /** Multiple values may be separated by commas. */
  spaceTypeIn?: (
    | 'ambulatory'
    | 'broda chair'
    | 'delivery'
    | 'geri chair'
    | 'stretcher'
    | 'stretcher xl'
    | 'wheelchair'
    | 'wheelchair xl'
  )[];
  status?: string;
  /** Multiple values may be separated by commas. */
  statusIn?: (
    | 'assigned'
    | 'at dropoff'
    | 'at pickup'
    | 'canceled'
    | 'completed'
    | 'en route'
    | 'pending'
    | 'rejected'
    | 'requested'
    | 'transporting'
  )[];
  /** Multiple values may be separated by commas. */
  tagIn?: string[];
  tags?: string;
  /** Multiple values may be separated by commas. */
  vehicleIdIn?: string[];
  vehicles?: string;
};
export type TripsImportCreateApiResponse = /** status 201  */ TripImportRead;
export type TripsImportCreateApiArg = {
  'Organization-ID'?: string;
  tripImportViewSet: TripImportViewSetWrite;
};
export type TripsMtmDriverManifestListApiResponse =
  /** status 200  */ PaginatedMtmDriverManifestListRead;
export type TripsMtmDriverManifestListApiArg = {
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  rangeEnd: string;
  rangeStart: string;
};
export type TripsMultiloadListApiResponse =
  /** status 200  */ PaginatedMultiloadListRead;
export type TripsMultiloadListApiArg = {
  'Organization-ID'?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type TripsMultiloadCreateApiResponse = /** status 201  */ MultiloadRead;
export type TripsMultiloadCreateApiArg = {
  'Organization-ID'?: string;
  multiload: Multiload;
};
export type TripsMultiloadRetrieveApiResponse =
  /** status 200  */ MultiloadRead;
export type TripsMultiloadRetrieveApiArg = {
  'Organization-ID'?: string;
  id: string;
};
export type TripsMultiloadPartialUpdateApiResponse =
  /** status 200  */ MultiloadRead;
export type TripsMultiloadPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
  patchedMultiload: PatchedMultiload;
};
export type TripsMultiloadDestroyApiResponse =
  /** status 204 No response body */ void;
export type TripsMultiloadDestroyApiArg = {
  'Organization-ID'?: string;
  id: string;
};
export type TripsMultiloadMobileRetrieveApiResponse =
  /** status 200  */ MultiloadMobileRead;
export type TripsMultiloadMobileRetrieveApiArg = {
  'Organization-ID'?: string;
  id: string;
};
export type TripsRequestedCountRetrieveApiResponse =
  /** status 200  */ TripRequestedCount;
export type TripsRequestedCountRetrieveApiArg = void;
export type TripsSubscriptionsListApiResponse =
  /** status 200  */ PaginatedTripSubscriptionListListRead;
export type TripsSubscriptionsListApiArg = {
  'Organization-ID'?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  payers?: string;
  rangeEnd?: string;
  rangeStart?: string;
  /** A search term. */
  search?: string;
};
export type TripsSubscriptionsCreateApiResponse =
  /** status 201  */ TripSubscriptionRead;
export type TripsSubscriptionsCreateApiArg = {
  'Organization-ID'?: string;
  tripSubscription: TripSubscriptionWrite;
};
export type TripsSubscriptionsRetrieveApiResponse =
  /** status 200  */ TripSubscriptionRead;
export type TripsSubscriptionsRetrieveApiArg = {
  'Organization-ID'?: string;
  id: string;
};
export type TripsSubscriptionsPartialUpdateApiResponse =
  /** status 200  */ TripSubscriptionRead;
export type TripsSubscriptionsPartialUpdateApiArg = {
  'Organization-ID'?: string;
  id: string;
  patchedTripSubscription: PatchedTripSubscriptionWrite;
};
export type TripsSubscriptionsDestroyApiResponse =
  /** status 204 No response body */ void;
export type TripsSubscriptionsDestroyApiArg = {
  'Organization-ID'?: string;
  delete?: boolean;
  id: string;
};
export type TripsSuggestedPickupAtCreateApiResponse =
  /** status 200  */ TripSuggestedPickupTimeRead;
export type TripsSuggestedPickupAtCreateApiArg = {
  'Organization-ID'?: string;
  tripSuggestedPickupTime: TripSuggestedPickupTimeWrite;
};
export type TripsTripSubscriptionExpiringSoonCountRetrieveApiResponse =
  /** status 200  */ TripSubscriptionExpiringSoonCount;
export type TripsTripSubscriptionExpiringSoonCountRetrieveApiArg = void;
export type TripsWithSummaryListApiResponse =
  /** status 200  */ PaginatedTripWithPriceSummaryListRead;
export type TripsWithSummaryListApiArg = {
  /** Multiple values may be separated by commas. */
  canceledReasonIn?: (
    | ''
    | 'appointment canceled'
    | 'no show'
    | 'other'
    | 'passenger not ready'
    | 'passenger refused'
    | 'passenger unable'
    | 'payer canceled'
    | 'scheduling conflict'
    | 'user requested'
  )[];
  createdAtRangeEnd?: string;
  createdAtRangeStart?: string;
  /** Multiple values may be separated by commas. */
  driverIn?: (string | null)[];
  /** Multiple values may be separated by commas. */
  dropoffMunicipalityIn?: string[];
  /** Multiple values may be separated by commas. */
  externalTripIdIn?: string[];
  hasDriverEnteredNotes?: boolean;
  hasInvoice?: boolean;
  hasPaidInvoice?: boolean;
  /** Multiple values may be separated by commas. */
  idIn?: string[];
  /** Multiple values may be separated by commas. */
  intermediaryIn?: (
    | ''
    | 'alivi'
    | 'call_the_car'
    | 'clearview'
    | 'cts'
    | 'kinetik'
    | 'momentm'
    | 'mtm'
    | 'provide_a_ride'
    | 'tennessee_carriers'
    | 'vectorcare'
    | 'verida'
    | 'welltrans'
  )[];
  isFromCsv?: boolean;
  /** Multiple values may be separated by commas. */
  notTagIn?: string[];
  /** Multiple values may be separated by commas. */
  oneSchemaTemplateIdIn?: (string | null)[];
  /** Multiple values may be separated by commas. */
  oneSchemaTemplateMultiIdIn?: (string | null)[];
  /** Sort trips by an attribute */
  ordering?:
    | 'created_at'
    | 'dropoff_address'
    | 'input_price_cents'
    | 'name'
    | 'payer_name'
    | 'pickup_address'
    | 'scheduled_pickup_at'
    | 'status';
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** Multiple values may be separated by commas. */
  passengerIn?: string[];
  passengers?: string;
  /** Multiple values may be separated by commas. */
  payerIn?: string[];
  payers?: string;
  /** Multiple values may be separated by commas. */
  pickupMunicipalityIn?: string[];
  /** The manually inputted price of the trip */
  priceMax?: number | null;
  /** The manually inputted price of the trip */
  priceMin?: number | null;
  rangeEnd?: string;
  rangeStart?: string;
  /** A search term. */
  search?: string;
  spaceType?: string;
  /** Multiple values may be separated by commas. */
  spaceTypeIn?: (
    | 'ambulatory'
    | 'broda chair'
    | 'delivery'
    | 'geri chair'
    | 'stretcher'
    | 'stretcher xl'
    | 'wheelchair'
    | 'wheelchair xl'
  )[];
  status?: string;
  /** Multiple values may be separated by commas. */
  statusIn?: (
    | 'assigned'
    | 'at dropoff'
    | 'at pickup'
    | 'canceled'
    | 'completed'
    | 'en route'
    | 'pending'
    | 'rejected'
    | 'requested'
    | 'transporting'
  )[];
  /** Multiple values may be separated by commas. */
  tagIn?: string[];
  tags?: string;
  /** Multiple values may be separated by commas. */
  vehicleIdIn?: string[];
  vehicles?: string;
};
export type PurposeEnum = 'pickup' | 'dropoff';
export type TripListLocationDetail = {
  id?: string;
  /** Purpose of this location, pickup, dropoff, etc. */
  purpose: PurposeEnum;
  place_id: string;
};
export type TripListLocationDetailRead = {
  id?: string;
  /** Purpose of this location, pickup, dropoff, etc. */
  purpose: PurposeEnum;
  address: string;
  latitude: number;
  longitude: number;
  place_id: string;
};
export type IntermediaryEnum =
  | 'call_the_car'
  | 'kinetik'
  | 'momentm'
  | 'mtm'
  | 'alivi'
  | 'provide_a_ride'
  | 'cts'
  | 'welltrans'
  | 'verida'
  | 'tennessee_carriers'
  | 'clearview'
  | 'vectorcare';
export type BlankEnum = '';
export type TripList = {
  scheduled_pickup_at: string;
  pickup: TripListLocationDetail;
  dropoff: TripListLocationDetail;
  one_schema_template_id?: string;
  one_schema_template_multi_id?: string;
  confirmation_code?: string;
  /** Notes entered by the driver */
  driver_entered_notes?: string;
  intermediary?: IntermediaryEnum | BlankEnum;
  /** Whether the passenger will call when it is time to be picked up */
  is_will_call?: boolean;
  /** Whether the passenger has called in that they are ready to be picked up */
  is_will_call_activated?: boolean;
};
export type OverrideStatusEnum =
  | 'requested'
  | 'pending'
  | 'assigned'
  | 'en route'
  | 'at pickup'
  | 'transporting'
  | 'at dropoff'
  | 'completed'
  | 'canceled'
  | 'rejected';
export type GenderEnum = 'female' | 'male' | 'other';
export type TripListPassenger = {
  id?: string;
  dob?: string | null;
  /** email address (unique in organization) */
  email?: string | null;
  /** Patient gender according to their primary insurance */
  gender?: GenderEnum | BlankEnum;
  weight?: number | null;
  needs_bariatric_transport?: boolean;
  notes?: string;
  deleted_at?: string | null;
};
export type TripListPassengerRead = {
  id?: string;
  full_name: string;
  dob?: string | null;
  /** email address (unique in organization) */
  email?: string | null;
  /** Patient gender according to their primary insurance */
  gender?: GenderEnum | BlankEnum;
  weight?: number | null;
  needs_bariatric_transport?: boolean;
  notes?: string;
  deleted_at?: string | null;
};
export type TripListPayerOrg = {
  id?: string;
  /** Name the organization uses to refer to this payer across the app */
  display_name: string;
  /** if this payer could be used for current or future trips */
  is_active?: boolean;
};
export type TripListPayerOrgRead = {
  id?: string;
  /** Name the organization uses to refer to this payer across the app */
  display_name: string;
  has_kinetik_account: boolean;
  /** if this payer could be used for current or future trips */
  is_active?: boolean;
};
export type SpaceTypeEnum =
  | 'wheelchair'
  | 'wheelchair xl'
  | 'broda chair'
  | 'geri chair'
  | 'stretcher'
  | 'stretcher xl'
  | 'ambulatory'
  | 'delivery';
export type ServiceTypeEnum =
  | 'curb-to-curb'
  | 'door-to-door'
  | 'door-through-door'
  | 'person-to-person';
export type CanceledReasonEnum =
  | 'no show'
  | 'passenger not ready'
  | 'passenger refused'
  | 'passenger unable'
  | 'scheduling conflict'
  | 'appointment canceled'
  | 'user requested'
  | 'payer canceled'
  | 'other';
export type TripTripTag = {
  tag_name: string;
  color_hex: string;
};
export type TripTripTagRead = {
  id: string;
  tag: string;
  tag_name: string;
  color_hex: string;
  created_at: string;
  updated_at: string;
};
export type TripSourceEnum = 'public_form';
export type TripListRead = {
  id: string;
  /** Current status of this trip */
  status: OverrideStatusEnum;
  passenger: TripListPassengerRead;
  payer: TripListPayerOrgRead;
  /** The trip ID used by the trip originator, (e.g. payer or original broker) */
  external_trip_id: string;
  /** The manually inputted price of the trip */
  input_price_cents: number | null;
  scheduled_pickup_at: string;
  /** The time of the passenger's appointment */
  appointment_at: string | null;
  pickup: TripListLocationDetailRead;
  dropoff: TripListLocationDetailRead;
  /** The type of space in the vehicle this passenger will need */
  space_type: SpaceTypeEnum;
  service_type: ServiceTypeEnum;
  estimated_distance_miles: number | null;
  /** The time the trip was canceled */
  canceled_at: string | null;
  /** The main reason a trip was canceled */
  canceled_reason: CanceledReasonEnum;
  one_schema_template_id?: string;
  one_schema_template_multi_id?: string;
  tags: TripTripTagRead[] | null;
  confirmation_code?: string;
  driver_name: string;
  /** Notes entered by the driver */
  driver_entered_notes?: string;
  invoice_numbers: string | null;
  invoice_id: string | null;
  rejection_reason: string | null;
  /** The trip ID used by an intermediary/broker, may or may not be the originator */
  intermediary_id: string;
  intermediary?: IntermediaryEnum | BlankEnum;
  /** How this trip was created */
  source: TripSourceEnum | BlankEnum;
  vehicle_nickname: string | null;
  /** Whether this trip should avoid being multiloaded with other passengers */
  should_avoid_multiload: boolean;
  /** Whether the passenger will call when it is time to be picked up */
  is_will_call?: boolean;
  /** Whether the passenger has called in that they are ready to be picked up */
  is_will_call_activated?: boolean;
  is_cancellation_requested: boolean;
  created_at: string;
  /** Membership that caused a model creation */
  created_by: string | null;
};
export type PaginatedTripListList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TripList[];
};
export type PaginatedTripListListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TripListRead[];
};
export type ValidationErrorEnum = 'validation_error';
export type TripsListRangeStartErrorComponent = {
  attr: 'range_start';
  code: 'invalid';
  detail: string;
};
export type TripsListRangeEndErrorComponent = {
  attr: 'range_end';
  code: 'invalid';
  detail: string;
};
export type TripsListPayersErrorComponent = {
  attr: 'payers';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type TripsListStatusErrorComponent = {
  attr: 'status';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type TripsListPassengersErrorComponent = {
  attr: 'passengers';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type TripsListTagsErrorComponent = {
  attr: 'tags';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type TripsListVehiclesErrorComponent = {
  attr: 'vehicles';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type TripsListSpaceTypeErrorComponent = {
  attr: 'space_type';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type TripsListPriceErrorComponent = {
  attr: 'price';
  code: 'invalid';
  detail: string;
};
export type TripsListCreatedAtRangeStartErrorComponent = {
  attr: 'created_at_range_start';
  code: 'invalid';
  detail: string;
};
export type TripsListCreatedAtRangeEndErrorComponent = {
  attr: 'created_at_range_end';
  code: 'invalid';
  detail: string;
};
export type TripsListError =
  | ({
      attr: 'range_start';
    } & TripsListRangeStartErrorComponent)
  | ({
      attr: 'range_end';
    } & TripsListRangeEndErrorComponent)
  | ({
      attr: 'payers';
    } & TripsListPayersErrorComponent)
  | ({
      attr: 'status';
    } & TripsListStatusErrorComponent)
  | ({
      attr: 'passengers';
    } & TripsListPassengersErrorComponent)
  | ({
      attr: 'tags';
    } & TripsListTagsErrorComponent)
  | ({
      attr: 'vehicles';
    } & TripsListVehiclesErrorComponent)
  | ({
      attr: 'space_type';
    } & TripsListSpaceTypeErrorComponent)
  | ({
      attr: 'price';
    } & TripsListPriceErrorComponent)
  | ({
      attr: 'created_at_range_start';
    } & TripsListCreatedAtRangeStartErrorComponent)
  | ({
      attr: 'created_at_range_end';
    } & TripsListCreatedAtRangeEndErrorComponent);
export type TripsListValidationError = {
  type: ValidationErrorEnum;
  errors: TripsListError[];
};
export type ClientErrorEnum = 'client_error';
export type ParseErrorCodeEnum = 'parse_error';
export type ParseError = {
  code: ParseErrorCodeEnum;
  detail: string;
  attr: string | null;
};
export type ParseErrorResponse = {
  type: ClientErrorEnum;
  errors: ParseError[];
};
export type TripsListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type ErrorCode403Enum = 'permission_denied';
export type Error403 = {
  code: ErrorCode403Enum;
  detail: string;
  attr: string | null;
};
export type ErrorResponse403 = {
  type: ClientErrorEnum;
  errors: Error403[];
};
export type ErrorCode404Enum = 'not_found';
export type Error404 = {
  code: ErrorCode404Enum;
  detail: string;
  attr: string | null;
};
export type ErrorResponse404 = {
  type: ClientErrorEnum;
  errors: Error404[];
};
export type PatchedTripPassenger = {
  id?: string;
  first_name?: string;
  last_name?: string;
  preferred_name?: string;
  pronoun?: string;
  gender?: string;
  dob?: string | null;
  weight?: number | null;
  needs_bariatric_transport?: boolean;
  phone_number?: string;
  email?: string;
  notes?: string;
  dispatcher_notes?: string;
  allow_sms_message?: boolean;
};
export type PatchedTripPassengerRead = {
  id?: string;
  organization_id?: string;
  first_name?: string;
  last_name?: string;
  full_name?: string;
  preferred_name?: string;
  pronoun?: string;
  gender?: string;
  dob?: string | null;
  weight?: number | null;
  needs_bariatric_transport?: boolean;
  phone_number?: string;
  email?: string;
  notes?: string;
  dispatcher_notes?: string;
  allow_sms_message?: boolean;
  deleted_at?: string;
};
export type PaymentMethodEnum = 'cash' | 'credit-card' | 'invoice';
export type StairEquipmentEnum = 'ramp' | 'stair-chair';
export type TripLocationDetail = {
  address_details?: string;
  /** The number of stairs at this location */
  num_stairs?: number;
  /** Stair equipment required for this location */
  stair_equipment?: StairEquipmentEnum | BlankEnum;
  /** Name of contact for this location, if not passenger */
  contact_name?: string;
  /** Phone number of contact for this location, if not passenger */
  contact_phone_number?: string | null;
  /** Notes visible to the driver for this location */
  driver_notes?: string;
  place_id: string;
};
export type TripLocationDetailRead = {
  id: string;
  /** Purpose of this location, pickup, dropoff, etc. */
  purpose: PurposeEnum;
  address: string;
  address_details?: string;
  latitude: number;
  longitude: number;
  /** The number of stairs at this location */
  num_stairs?: number;
  /** Stair equipment required for this location */
  stair_equipment?: StairEquipmentEnum | BlankEnum;
  /** Name of contact for this location, if not passenger */
  contact_name?: string;
  /** Phone number of contact for this location, if not passenger */
  contact_phone_number?: string | null;
  /** Notes visible to the driver for this location */
  driver_notes?: string;
  place_id: string;
};
export type LinkToPayerEnum = 'always' | 'never' | 'only_with_id';
export type NullEnum = null;
export type SeatEquipmentEnum = 'booster-seat' | 'car-seat';
export type Trip = {
  passenger: PatchedTripPassenger;
  /** The trip ID used by the trip originator, (e.g. payer or original broker) */
  external_trip_id?: string;
  /** The manually inputted price of the trip */
  input_price_cents?: number | null;
  payment_method?: PaymentMethodEnum | BlankEnum;
  scheduled_pickup_at: string;
  pickup: TripLocationDetail;
  dropoff: TripLocationDetail;
  /** The time of the passenger's appointment */
  appointment_at?: string | null;
  /** Whether the passenger will call when it is time to be picked up */
  is_will_call?: boolean;
  /** The type of space in the vehicle this passenger will need */
  space_type: SpaceTypeEnum;
  /** Whether the passenger will supply their own wheelchair or not */
  must_provide_wheelchair?: boolean;
  service_type: ServiceTypeEnum;
  /** Notes only visible to the dispatcher */
  dispatcher_notes?: string;
  /** Notes about the trip for billing purposes */
  billing_notes?: string;
  /** Notes entered by the driver */
  driver_entered_notes?: string;
  is_oxygen_required?: boolean;
  oxygen_liters_per_min?: string;
  num_attendants_needed?: number;
  /** How many additional people will be accompanying the primary passenger */
  num_accompanying_passengers?: number;
  one_schema_template_id?: string;
  one_schema_template_multi_id?: string;
  correlation_id?: string;
  /** Who booked this trip, if not passenger */
  booked_by_name?: string;
  /** Phone number of who booked this trip, if not passenger */
  booked_by_phone_number?: string | null;
  /** Phone number extension of who booked this trip, if not passenger */
  booked_by_phone_extension?: string;
  load_time_seconds?: number | null;
  unload_time_seconds?: number | null;
  pickup_wait_time_seconds?: number | null;
  /** Whether this is the first leg of a wait and return trip */
  is_wait_and_return_outbound?: boolean;
  /** Whether this is the second leg of a wait and return trip */
  is_wait_and_return_inbound?: boolean;
  /** The authorization ID for this trip */
  authorization_id?: string;
  /** The insurance policy ID for this trip */
  insurance_policy_id?: string;
  /** Whether this trips pricing is locked (non-editable) */
  is_price_locked?: boolean;
  link_to_payer?: (LinkToPayerEnum | NullEnum) | null;
  confirmation_code?: string;
  intermediary?: IntermediaryEnum | BlankEnum;
  /** Whether the passenger has an infectious disease */
  has_infectious_disease?: boolean;
  /** The seat equipment needed for this trip */
  seat_equipment?: SeatEquipmentEnum | BlankEnum;
  /** Whether this trip should avoid being multiloaded with other passengers */
  should_avoid_multiload?: boolean;
  import_batch_id?: number | null;
};
export type AssignmentMini = {
  start: string;
  end: string;
};
export type AssignmentMiniRead = {
  id: string;
  start: string;
  end: string;
};
export type PayerTypeEnum = 'insurance' | 'broker' | 'private';
export type AddressLocation = {
  place_id: string;
};
export type AddressLocationRead = {
  /** The full address or geolocation label */
  label: string;
  place_id: string;
};
export type AddressTypeEnum = 'medical' | 'organization' | 'residential';
export type Address = {
  location?: AddressLocation;
  /** Address as sent to aws to get location */
  label: string;
  label2?: string;
  address_notes?: string;
  address_type?: AddressTypeEnum;
};
export type AddressRead = {
  id: string;
  organization_id: string;
  location?: AddressLocationRead;
  /** Address as sent to aws to get location */
  label: string;
  label2?: string;
  address_notes?: string;
  address_type?: AddressTypeEnum;
  created_at: string;
  updated_at: string;
};
export type PayerOrganization = {
  payer?: string | null;
  /** Name the organization uses to refer to this payer across the app */
  display_name: string;
  /** Any alternate name the organization uses (ex., full legal name) */
  alternate_name?: string;
  type?: PayerTypeEnum;
  /** if this payer could be used for current or future trips */
  is_active?: boolean;
  /** if this payer is a self-pay payer */
  is_self_pay?: boolean | null;
  /** Whether a payer organization allows any kind of multiloading */
  can_multiload?: boolean;
  /** ID of the organization in the payer's system */
  external_id?: string;
  website?: string;
  /** Employer Identification Number */
  ein?: string;
  /** Default contact email, ex. help@bambi.health */
  email?: string;
  /** Default contact phone number */
  phone_number?: string | null;
  /** Name of person to contact for billing/invoicing help or questions */
  billing_name?: string;
  /** Phone number for billing-specific purposes */
  billing_phone_number?: string | null;
  /** Email for billing/invoicing, ex. nirav@bambi.healh */
  billing_email?: string;
  /** Any additional information to display to dispatchers */
  dispatcher_notes?: string;
  /** Any additional information to display to admins */
  admin_notes?: string;
  deleted_at?: string | null;
  billing_address?: Address | null;
  default_trip_address?: Address | null;
  multiloading_partners?: string[] | null;
};
export type PayerOrganizationTripRequiredFields = {};
export type PayerOrganizationTripRequiredFieldsRead = {
  passenger_phone_number: boolean;
  passenger_weight: boolean;
  authorization_id: boolean;
  insurance_policy_id: boolean;
  payer_passenger_external_id: boolean;
  external_trip_id: boolean;
  booked_by_name: boolean;
  booked_by_phone_number: boolean;
};
export type PayerOrganizationRead = {
  id: string;
  organization_id: string;
  payer?: string | null;
  /** Name the organization uses to refer to this payer across the app */
  display_name: string;
  /** Any alternate name the organization uses (ex., full legal name) */
  alternate_name?: string;
  type?: PayerTypeEnum;
  /** if this payer could be used for current or future trips */
  is_active?: boolean;
  /** if this payer is a self-pay payer */
  is_self_pay?: boolean | null;
  /** Whether a payer organization allows any kind of multiloading */
  can_multiload?: boolean;
  /** ID of the organization in the payer's system */
  external_id?: string;
  website?: string;
  /** Employer Identification Number */
  ein?: string;
  /** Default contact email, ex. help@bambi.health */
  email?: string;
  /** Default contact phone number */
  phone_number?: string | null;
  /** Name of person to contact for billing/invoicing help or questions */
  billing_name?: string;
  /** Phone number for billing-specific purposes */
  billing_phone_number?: string | null;
  /** Email for billing/invoicing, ex. nirav@bambi.healh */
  billing_email?: string;
  /** Any additional information to display to dispatchers */
  dispatcher_notes?: string;
  /** Any additional information to display to admins */
  admin_notes?: string;
  created_at: string;
  updated_at: string;
  deleted_at?: string | null;
  billing_address?: AddressRead | null;
  default_trip_address?: AddressRead | null;
  pickup_default_early_seconds: number;
  pickup_default_late_seconds: number;
  pickup_appointment_early_seconds: number;
  pickup_appointment_late_seconds: number;
  pickup_will_call_early_seconds: number;
  pickup_will_call_late_seconds: number;
  extra_scheduled_pickup_at_seconds: number;
  invoice_due_after_days: number | null;
  requires_signature_pickup_passenger: boolean;
  requires_signature_dropoff_passenger: boolean;
  requires_signature_pickup_driver: boolean;
  requires_signature_dropoff_driver: boolean;
  payer_info_id: string | null;
  payer_info_name: string | null;
  payer_name: string | null;
  payer_website: string | null;
  payer_type: PayerTypeEnum;
  multiloading_partners?: string[] | null;
  has_kinetik_account: boolean;
  trip_required_fields: PayerOrganizationTripRequiredFieldsRead | null;
};
export type TripPayerPassenger = {};
export type TripPayerPassengerRead = {
  id: string;
  external_id: string;
};
export type TripTiming = {};
export type TripTimingRead = {
  /** Estimated arrival at pickup location per vehicle's last location log */
  estimated_pickup_arrival_time: string | null;
  is_on_time: boolean | null;
  delayed_by_seconds: number | null;
  /** Last time this timing was calculated */
  last_calculated_at: string | null;
};
export type TripRead = {
  id: string;
  assignment: AssignmentMiniRead | null;
  /** Current status of this trip */
  status: OverrideStatusEnum;
  /** Locked assignment cannot be changed */
  is_locked: boolean | null;
  passenger: PatchedTripPassengerRead;
  payer: PayerOrganizationRead;
  payer_passenger: TripPayerPassengerRead | null;
  early_pickup_at: string;
  late_pickup_at: string;
  /** The trip ID used by the trip originator, (e.g. payer or original broker) */
  external_trip_id?: string;
  /** The initial price of the trip calculated using a pricing model */
  initial_calculated_price_cents: number | null;
  /** The final price of the trip calculated using a pricing model */
  final_calculated_price_cents: number | null;
  /** The manually inputted price of the trip */
  input_price_cents?: number | null;
  payment_method?: PaymentMethodEnum | BlankEnum;
  scheduled_pickup_at: string;
  current_task: PurposeEnum;
  current_task_at: string;
  pickup: TripLocationDetailRead;
  dropoff: TripLocationDetailRead;
  /** The time of the passenger's appointment */
  appointment_at?: string | null;
  /** Whether the passenger will call when it is time to be picked up */
  is_will_call?: boolean;
  /** Whether the passenger has called in that they are ready to be picked up */
  is_will_call_activated: boolean;
  /** The type of space in the vehicle this passenger will need */
  space_type: SpaceTypeEnum;
  /** Whether the passenger will supply their own wheelchair or not */
  must_provide_wheelchair?: boolean;
  service_type: ServiceTypeEnum;
  /** Notes only visible to the dispatcher */
  dispatcher_notes?: string;
  /** Notes about the trip for billing purposes */
  billing_notes?: string;
  /** Notes entered by the driver */
  driver_entered_notes?: string;
  is_oxygen_required?: boolean;
  oxygen_liters_per_min?: string;
  num_attendants_needed?: number;
  /** How many additional people will be accompanying the primary passenger */
  num_accompanying_passengers?: number;
  estimated_distance_miles: number | null;
  /** The time the trip was canceled */
  canceled_at: string | null;
  /** The main reason a trip was canceled */
  canceled_reason: CanceledReasonEnum;
  one_schema_template_id?: string;
  one_schema_template_multi_id?: string;
  correlation_id?: string;
  /** Who booked this trip, if not passenger */
  booked_by_name?: string;
  /** Phone number of who booked this trip, if not passenger */
  booked_by_phone_number?: string | null;
  /** Phone number extension of who booked this trip, if not passenger */
  booked_by_phone_extension?: string;
  timing: TripTimingRead | null;
  load_time_seconds?: number | null;
  unload_time_seconds?: number | null;
  pickup_wait_time_seconds?: number | null;
  tags: TripTripTagRead[] | null;
  /** The suggested pickup time based off of run_bambi_run results */
  suggested_pickup_time: string | null;
  /** Whether this is the first leg of a wait and return trip */
  is_wait_and_return_outbound?: boolean;
  /** Whether this is the second leg of a wait and return trip */
  is_wait_and_return_inbound?: boolean;
  /** The authorization ID for this trip */
  authorization_id?: string;
  /** The insurance policy ID for this trip */
  insurance_policy_id?: string;
  /** Whether this trips pricing is locked (non-editable) */
  is_price_locked?: boolean;
  link_to_payer?: (LinkToPayerEnum | NullEnum) | null;
  confirmation_code?: string;
  driver_name: string;
  invoice_numbers: string | null;
  invoice_id: string | null;
  rejection_reason: string | null;
  /** The trip ID used by an intermediary/broker, may or may not be the originator */
  intermediary_id: string;
  intermediary?: IntermediaryEnum | BlankEnum;
  /** How this trip was created */
  source: TripSourceEnum | BlankEnum;
  /** Whether the passenger has an infectious disease */
  has_infectious_disease?: boolean;
  completion_time: string | null;
  vehicle_nickname: string | null;
  /** Membership that caused a model creation */
  created_by: string | null;
  created_at: string;
  is_cancellation_requested: boolean;
  /** The seat equipment needed for this trip */
  seat_equipment?: SeatEquipmentEnum | BlankEnum;
  /** Whether this trip should avoid being multiloaded with other passengers */
  should_avoid_multiload?: boolean;
  import_batch_id?: number | null;
};
export type TripWrite = {
  passenger: PatchedTripPassenger;
  payer_id: string;
  payer_passenger_external_id?: string;
  /** The trip ID used by the trip originator, (e.g. payer or original broker) */
  external_trip_id?: string;
  /** The manually inputted price of the trip */
  input_price_cents?: number | null;
  payment_method?: PaymentMethodEnum | BlankEnum;
  scheduled_pickup_at: string;
  pickup: TripLocationDetail;
  dropoff: TripLocationDetail;
  /** The time of the passenger's appointment */
  appointment_at?: string | null;
  /** Whether the passenger will call when it is time to be picked up */
  is_will_call?: boolean;
  /** The type of space in the vehicle this passenger will need */
  space_type: SpaceTypeEnum;
  /** Whether the passenger will supply their own wheelchair or not */
  must_provide_wheelchair?: boolean;
  service_type: ServiceTypeEnum;
  /** Notes only visible to the dispatcher */
  dispatcher_notes?: string;
  /** Notes about the trip for billing purposes */
  billing_notes?: string;
  /** Notes entered by the driver */
  driver_entered_notes?: string;
  is_oxygen_required?: boolean;
  oxygen_liters_per_min?: string;
  num_attendants_needed?: number;
  /** How many additional people will be accompanying the primary passenger */
  num_accompanying_passengers?: number;
  one_schema_template_id?: string;
  one_schema_template_multi_id?: string;
  correlation_id?: string;
  /** Who booked this trip, if not passenger */
  booked_by_name?: string;
  /** Phone number of who booked this trip, if not passenger */
  booked_by_phone_number?: string | null;
  /** Phone number extension of who booked this trip, if not passenger */
  booked_by_phone_extension?: string;
  load_time_seconds?: number | null;
  unload_time_seconds?: number | null;
  pickup_wait_time_seconds?: number | null;
  tag_ids?: string[] | null;
  added_tags?: string[] | null;
  /** Whether this is the first leg of a wait and return trip */
  is_wait_and_return_outbound?: boolean;
  /** Whether this is the second leg of a wait and return trip */
  is_wait_and_return_inbound?: boolean;
  /** The authorization ID for this trip */
  authorization_id?: string;
  /** The insurance policy ID for this trip */
  insurance_policy_id?: string;
  /** Whether this trips pricing is locked (non-editable) */
  is_price_locked?: boolean;
  link_to_payer?: (LinkToPayerEnum | NullEnum) | null;
  confirmation_code?: string;
  intermediary?: IntermediaryEnum | BlankEnum;
  /** Whether the passenger has an infectious disease */
  has_infectious_disease?: boolean;
  /** The seat equipment needed for this trip */
  seat_equipment?: SeatEquipmentEnum | BlankEnum;
  /** Whether this trip should avoid being multiloaded with other passengers */
  should_avoid_multiload?: boolean;
  import_batch_id?: number | null;
};
export type TripsBulkCreate = {
  trips: Trip[];
};
export type TripsBulkCreateRead = {
  trips: TripRead[];
};
export type TripsBulkCreateWrite = {
  trips: TripWrite[];
};
export type TripsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsCreateTripsNonFieldErrorsErrorComponent = {
  attr: 'trips.non_field_errors';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type TripsCreateTripsIndexNonFieldErrorsErrorComponent = {
  attr: 'trips.INDEX.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsCreateTripsIndexAssignmentStartErrorComponent = {
  attr: 'trips.INDEX.assignment.start';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type TripsCreateTripsIndexAssignmentEndErrorComponent = {
  attr: 'trips.INDEX.assignment.end';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type TripsCreateTripsIndexPassengerNonFieldErrorsErrorComponent = {
  attr: 'trips.INDEX.passenger.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsCreateTripsIndexPassengerIdErrorComponent = {
  attr: 'trips.INDEX.passenger.id';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsCreateTripsIndexPassengerFirstNameErrorComponent = {
  attr: 'trips.INDEX.passenger.first_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPassengerLastNameErrorComponent = {
  attr: 'trips.INDEX.passenger.last_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPassengerPreferredNameErrorComponent = {
  attr: 'trips.INDEX.passenger.preferred_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPassengerPronounErrorComponent = {
  attr: 'trips.INDEX.passenger.pronoun';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPassengerGenderErrorComponent = {
  attr: 'trips.INDEX.passenger.gender';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPassengerDobErrorComponent = {
  attr: 'trips.INDEX.passenger.dob';
  code: 'datetime' | 'invalid';
  detail: string;
};
export type TripsCreateTripsIndexPassengerWeightErrorComponent = {
  attr: 'trips.INDEX.passenger.weight';
  code: 'invalid' | 'max_string_length' | 'min_value';
  detail: string;
};
export type TripsCreateTripsIndexPassengerNeedsBariatricTransportErrorComponent =
  {
    attr: 'trips.INDEX.passenger.needs_bariatric_transport';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsCreateTripsIndexPassengerPhoneNumberErrorComponent = {
  attr: 'trips.INDEX.passenger.phone_number';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPassengerEmailErrorComponent = {
  attr: 'trips.INDEX.passenger.email';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPassengerNotesErrorComponent = {
  attr: 'trips.INDEX.passenger.notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPassengerDispatcherNotesErrorComponent = {
  attr: 'trips.INDEX.passenger.dispatcher_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPassengerAllowSmsMessageErrorComponent = {
  attr: 'trips.INDEX.passenger.allow_sms_message';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsCreateTripsIndexPayerPayerErrorComponent = {
  attr: 'trips.INDEX.payer.payer';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type TripsCreateTripsIndexPayerDisplayNameErrorComponent = {
  attr: 'trips.INDEX.payer.display_name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPayerAlternateNameErrorComponent = {
  attr: 'trips.INDEX.payer.alternate_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPayerTypeErrorComponent = {
  attr: 'trips.INDEX.payer.type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsCreateTripsIndexPayerIsActiveErrorComponent = {
  attr: 'trips.INDEX.payer.is_active';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsCreateTripsIndexPayerIsSelfPayErrorComponent = {
  attr: 'trips.INDEX.payer.is_self_pay';
  code: 'invalid';
  detail: string;
};
export type TripsCreateTripsIndexPayerCanMultiloadErrorComponent = {
  attr: 'trips.INDEX.payer.can_multiload';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsCreateTripsIndexPayerExternalIdErrorComponent = {
  attr: 'trips.INDEX.payer.external_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPayerWebsiteErrorComponent = {
  attr: 'trips.INDEX.payer.website';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPayerEinErrorComponent = {
  attr: 'trips.INDEX.payer.ein';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPayerEmailErrorComponent = {
  attr: 'trips.INDEX.payer.email';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPayerPhoneNumberErrorComponent = {
  attr: 'trips.INDEX.payer.phone_number';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPayerBillingNameErrorComponent = {
  attr: 'trips.INDEX.payer.billing_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPayerBillingPhoneNumberErrorComponent = {
  attr: 'trips.INDEX.payer.billing_phone_number';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPayerBillingEmailErrorComponent = {
  attr: 'trips.INDEX.payer.billing_email';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPayerDispatcherNotesErrorComponent = {
  attr: 'trips.INDEX.payer.dispatcher_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPayerAdminNotesErrorComponent = {
  attr: 'trips.INDEX.payer.admin_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPayerDeletedAtErrorComponent = {
  attr: 'trips.INDEX.payer.deleted_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type TripsCreateTripsIndexPayerBillingAddressNonFieldErrorsErrorComponent =
  {
    attr: 'trips.INDEX.payer.billing_address.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type TripsCreateTripsIndexPayerBillingAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'trips.INDEX.payer.billing_address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsCreateTripsIndexPayerBillingAddressLocationPlaceIdErrorComponent =
  {
    attr: 'trips.INDEX.payer.billing_address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsCreateTripsIndexPayerBillingAddressLabelErrorComponent = {
  attr: 'trips.INDEX.payer.billing_address.label';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPayerBillingAddressLabel2ErrorComponent = {
  attr: 'trips.INDEX.payer.billing_address.label2';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPayerBillingAddressAddressNotesErrorComponent =
  {
    attr: 'trips.INDEX.payer.billing_address.address_notes';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsCreateTripsIndexPayerBillingAddressAddressTypeErrorComponent =
  {
    attr: 'trips.INDEX.payer.billing_address.address_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsCreateTripsIndexPayerDefaultTripAddressNonFieldErrorsErrorComponent =
  {
    attr: 'trips.INDEX.payer.default_trip_address.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type TripsCreateTripsIndexPayerDefaultTripAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'trips.INDEX.payer.default_trip_address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsCreateTripsIndexPayerDefaultTripAddressLocationPlaceIdErrorComponent =
  {
    attr: 'trips.INDEX.payer.default_trip_address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsCreateTripsIndexPayerDefaultTripAddressLabelErrorComponent = {
  attr: 'trips.INDEX.payer.default_trip_address.label';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPayerDefaultTripAddressLabel2ErrorComponent = {
  attr: 'trips.INDEX.payer.default_trip_address.label2';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPayerDefaultTripAddressAddressNotesErrorComponent =
  {
    attr: 'trips.INDEX.payer.default_trip_address.address_notes';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsCreateTripsIndexPayerDefaultTripAddressAddressTypeErrorComponent =
  {
    attr: 'trips.INDEX.payer.default_trip_address.address_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsCreateTripsIndexPayerMultiloadingPartnersNonFieldErrorsErrorComponent =
  {
    attr: 'trips.INDEX.payer.multiloading_partners.non_field_errors';
    code: 'not_a_list';
    detail: string;
  };
export type TripsCreateTripsIndexPayerMultiloadingPartnersIndexErrorComponent =
  {
    attr: 'trips.INDEX.payer.multiloading_partners.INDEX';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsCreateTripsIndexPayerIdErrorComponent = {
  attr: 'trips.INDEX.payer_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsCreateTripsIndexPayerPassengerExternalIdErrorComponent = {
  attr: 'trips.INDEX.payer_passenger_external_id';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexExternalTripIdErrorComponent = {
  attr: 'trips.INDEX.external_trip_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexInputPriceCentsErrorComponent = {
  attr: 'trips.INDEX.input_price_cents';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type TripsCreateTripsIndexPaymentMethodErrorComponent = {
  attr: 'trips.INDEX.payment_method';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsCreateTripsIndexScheduledPickupAtErrorComponent = {
  attr: 'trips.INDEX.scheduled_pickup_at';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type TripsCreateTripsIndexPickupNonFieldErrorsErrorComponent = {
  attr: 'trips.INDEX.pickup.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsCreateTripsIndexPickupAddressDetailsErrorComponent = {
  attr: 'trips.INDEX.pickup.address_details';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPickupNumStairsErrorComponent = {
  attr: 'trips.INDEX.pickup.num_stairs';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
  detail: string;
};
export type TripsCreateTripsIndexPickupStairEquipmentErrorComponent = {
  attr: 'trips.INDEX.pickup.stair_equipment';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsCreateTripsIndexPickupContactNameErrorComponent = {
  attr: 'trips.INDEX.pickup.contact_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPickupContactPhoneNumberErrorComponent = {
  attr: 'trips.INDEX.pickup.contact_phone_number';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPickupDriverNotesErrorComponent = {
  attr: 'trips.INDEX.pickup.driver_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexPickupPlaceIdErrorComponent = {
  attr: 'trips.INDEX.pickup.place_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexDropoffNonFieldErrorsErrorComponent = {
  attr: 'trips.INDEX.dropoff.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsCreateTripsIndexDropoffAddressDetailsErrorComponent = {
  attr: 'trips.INDEX.dropoff.address_details';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexDropoffNumStairsErrorComponent = {
  attr: 'trips.INDEX.dropoff.num_stairs';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
  detail: string;
};
export type TripsCreateTripsIndexDropoffStairEquipmentErrorComponent = {
  attr: 'trips.INDEX.dropoff.stair_equipment';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsCreateTripsIndexDropoffContactNameErrorComponent = {
  attr: 'trips.INDEX.dropoff.contact_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexDropoffContactPhoneNumberErrorComponent = {
  attr: 'trips.INDEX.dropoff.contact_phone_number';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexDropoffDriverNotesErrorComponent = {
  attr: 'trips.INDEX.dropoff.driver_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexDropoffPlaceIdErrorComponent = {
  attr: 'trips.INDEX.dropoff.place_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexAppointmentAtErrorComponent = {
  attr: 'trips.INDEX.appointment_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type TripsCreateTripsIndexIsWillCallErrorComponent = {
  attr: 'trips.INDEX.is_will_call';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsCreateTripsIndexSpaceTypeErrorComponent = {
  attr: 'trips.INDEX.space_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type TripsCreateTripsIndexMustProvideWheelchairErrorComponent = {
  attr: 'trips.INDEX.must_provide_wheelchair';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsCreateTripsIndexServiceTypeErrorComponent = {
  attr: 'trips.INDEX.service_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type TripsCreateTripsIndexDispatcherNotesErrorComponent = {
  attr: 'trips.INDEX.dispatcher_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexBillingNotesErrorComponent = {
  attr: 'trips.INDEX.billing_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexDriverEnteredNotesErrorComponent = {
  attr: 'trips.INDEX.driver_entered_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexIsOxygenRequiredErrorComponent = {
  attr: 'trips.INDEX.is_oxygen_required';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsCreateTripsIndexOxygenLitersPerMinErrorComponent = {
  attr: 'trips.INDEX.oxygen_liters_per_min';
  code:
    | 'invalid'
    | 'max_decimal_places'
    | 'max_digits'
    | 'max_string_length'
    | 'max_whole_digits'
    | 'null';
  detail: string;
};
export type TripsCreateTripsIndexNumAttendantsNeededErrorComponent = {
  attr: 'trips.INDEX.num_attendants_needed';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
  detail: string;
};
export type TripsCreateTripsIndexNumAccompanyingPassengersErrorComponent = {
  attr: 'trips.INDEX.num_accompanying_passengers';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
  detail: string;
};
export type TripsCreateTripsIndexOneSchemaTemplateIdErrorComponent = {
  attr: 'trips.INDEX.one_schema_template_id';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexOneSchemaTemplateMultiIdErrorComponent = {
  attr: 'trips.INDEX.one_schema_template_multi_id';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexCorrelationIdErrorComponent = {
  attr: 'trips.INDEX.correlation_id';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsCreateTripsIndexBookedByNameErrorComponent = {
  attr: 'trips.INDEX.booked_by_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexBookedByPhoneNumberErrorComponent = {
  attr: 'trips.INDEX.booked_by_phone_number';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexBookedByPhoneExtensionErrorComponent = {
  attr: 'trips.INDEX.booked_by_phone_extension';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexLoadTimeSecondsErrorComponent = {
  attr: 'trips.INDEX.load_time_seconds';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type TripsCreateTripsIndexUnloadTimeSecondsErrorComponent = {
  attr: 'trips.INDEX.unload_time_seconds';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type TripsCreateTripsIndexPickupWaitTimeSecondsErrorComponent = {
  attr: 'trips.INDEX.pickup_wait_time_seconds';
  code: 'invalid' | 'max_string_length' | 'min_value';
  detail: string;
};
export type TripsCreateTripsIndexTagIdsErrorComponent = {
  attr: 'trips.INDEX.tag_ids';
  code: 'not_a_list';
  detail: string;
};
export type TripsCreateTripsIndexTagIdsIndexErrorComponent = {
  attr: 'trips.INDEX.tag_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsCreateTripsIndexTagsIndexTagNameErrorComponent = {
  attr: 'trips.INDEX.tags.INDEX.tag_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexTagsIndexColorHexErrorComponent = {
  attr: 'trips.INDEX.tags.INDEX.color_hex';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexAddedTagsErrorComponent = {
  attr: 'trips.INDEX.added_tags';
  code: 'not_a_list';
  detail: string;
};
export type TripsCreateTripsIndexAddedTagsIndexErrorComponent = {
  attr: 'trips.INDEX.added_tags.INDEX';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexIsWaitAndReturnOutboundErrorComponent = {
  attr: 'trips.INDEX.is_wait_and_return_outbound';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsCreateTripsIndexIsWaitAndReturnInboundErrorComponent = {
  attr: 'trips.INDEX.is_wait_and_return_inbound';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsCreateTripsIndexAuthorizationIdErrorComponent = {
  attr: 'trips.INDEX.authorization_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexInsurancePolicyIdErrorComponent = {
  attr: 'trips.INDEX.insurance_policy_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexIsPriceLockedErrorComponent = {
  attr: 'trips.INDEX.is_price_locked';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsCreateTripsIndexLinkToPayerErrorComponent = {
  attr: 'trips.INDEX.link_to_payer';
  code: 'invalid_choice';
  detail: string;
};
export type TripsCreateTripsIndexConfirmationCodeErrorComponent = {
  attr: 'trips.INDEX.confirmation_code';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCreateTripsIndexIntermediaryErrorComponent = {
  attr: 'trips.INDEX.intermediary';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsCreateTripsIndexHasInfectiousDiseaseErrorComponent = {
  attr: 'trips.INDEX.has_infectious_disease';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsCreateTripsIndexSeatEquipmentErrorComponent = {
  attr: 'trips.INDEX.seat_equipment';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsCreateTripsIndexShouldAvoidMultiloadErrorComponent = {
  attr: 'trips.INDEX.should_avoid_multiload';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsCreateTripsIndexImportBatchIdErrorComponent = {
  attr: 'trips.INDEX.import_batch_id';
  code: 'invalid' | 'max_string_length';
  detail: string;
};
export type TripsCreateError =
  | ({
      attr: 'non_field_errors';
    } & TripsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips.non_field_errors';
    } & TripsCreateTripsNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips.INDEX.non_field_errors';
    } & TripsCreateTripsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips.INDEX.assignment.start';
    } & TripsCreateTripsIndexAssignmentStartErrorComponent)
  | ({
      attr: 'trips.INDEX.assignment.end';
    } & TripsCreateTripsIndexAssignmentEndErrorComponent)
  | ({
      attr: 'trips.INDEX.passenger.non_field_errors';
    } & TripsCreateTripsIndexPassengerNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips.INDEX.passenger.id';
    } & TripsCreateTripsIndexPassengerIdErrorComponent)
  | ({
      attr: 'trips.INDEX.passenger.first_name';
    } & TripsCreateTripsIndexPassengerFirstNameErrorComponent)
  | ({
      attr: 'trips.INDEX.passenger.last_name';
    } & TripsCreateTripsIndexPassengerLastNameErrorComponent)
  | ({
      attr: 'trips.INDEX.passenger.preferred_name';
    } & TripsCreateTripsIndexPassengerPreferredNameErrorComponent)
  | ({
      attr: 'trips.INDEX.passenger.pronoun';
    } & TripsCreateTripsIndexPassengerPronounErrorComponent)
  | ({
      attr: 'trips.INDEX.passenger.gender';
    } & TripsCreateTripsIndexPassengerGenderErrorComponent)
  | ({
      attr: 'trips.INDEX.passenger.dob';
    } & TripsCreateTripsIndexPassengerDobErrorComponent)
  | ({
      attr: 'trips.INDEX.passenger.weight';
    } & TripsCreateTripsIndexPassengerWeightErrorComponent)
  | ({
      attr: 'trips.INDEX.passenger.needs_bariatric_transport';
    } & TripsCreateTripsIndexPassengerNeedsBariatricTransportErrorComponent)
  | ({
      attr: 'trips.INDEX.passenger.phone_number';
    } & TripsCreateTripsIndexPassengerPhoneNumberErrorComponent)
  | ({
      attr: 'trips.INDEX.passenger.email';
    } & TripsCreateTripsIndexPassengerEmailErrorComponent)
  | ({
      attr: 'trips.INDEX.passenger.notes';
    } & TripsCreateTripsIndexPassengerNotesErrorComponent)
  | ({
      attr: 'trips.INDEX.passenger.dispatcher_notes';
    } & TripsCreateTripsIndexPassengerDispatcherNotesErrorComponent)
  | ({
      attr: 'trips.INDEX.passenger.allow_sms_message';
    } & TripsCreateTripsIndexPassengerAllowSmsMessageErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.payer';
    } & TripsCreateTripsIndexPayerPayerErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.display_name';
    } & TripsCreateTripsIndexPayerDisplayNameErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.alternate_name';
    } & TripsCreateTripsIndexPayerAlternateNameErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.type';
    } & TripsCreateTripsIndexPayerTypeErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.is_active';
    } & TripsCreateTripsIndexPayerIsActiveErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.is_self_pay';
    } & TripsCreateTripsIndexPayerIsSelfPayErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.can_multiload';
    } & TripsCreateTripsIndexPayerCanMultiloadErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.external_id';
    } & TripsCreateTripsIndexPayerExternalIdErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.website';
    } & TripsCreateTripsIndexPayerWebsiteErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.ein';
    } & TripsCreateTripsIndexPayerEinErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.email';
    } & TripsCreateTripsIndexPayerEmailErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.phone_number';
    } & TripsCreateTripsIndexPayerPhoneNumberErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.billing_name';
    } & TripsCreateTripsIndexPayerBillingNameErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.billing_phone_number';
    } & TripsCreateTripsIndexPayerBillingPhoneNumberErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.billing_email';
    } & TripsCreateTripsIndexPayerBillingEmailErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.dispatcher_notes';
    } & TripsCreateTripsIndexPayerDispatcherNotesErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.admin_notes';
    } & TripsCreateTripsIndexPayerAdminNotesErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.deleted_at';
    } & TripsCreateTripsIndexPayerDeletedAtErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.billing_address.non_field_errors';
    } & TripsCreateTripsIndexPayerBillingAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.billing_address.location.non_field_errors';
    } & TripsCreateTripsIndexPayerBillingAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.billing_address.location.place_id';
    } & TripsCreateTripsIndexPayerBillingAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.billing_address.label';
    } & TripsCreateTripsIndexPayerBillingAddressLabelErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.billing_address.label2';
    } & TripsCreateTripsIndexPayerBillingAddressLabel2ErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.billing_address.address_notes';
    } & TripsCreateTripsIndexPayerBillingAddressAddressNotesErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.billing_address.address_type';
    } & TripsCreateTripsIndexPayerBillingAddressAddressTypeErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.default_trip_address.non_field_errors';
    } & TripsCreateTripsIndexPayerDefaultTripAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.default_trip_address.location.non_field_errors';
    } & TripsCreateTripsIndexPayerDefaultTripAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.default_trip_address.location.place_id';
    } & TripsCreateTripsIndexPayerDefaultTripAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.default_trip_address.label';
    } & TripsCreateTripsIndexPayerDefaultTripAddressLabelErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.default_trip_address.label2';
    } & TripsCreateTripsIndexPayerDefaultTripAddressLabel2ErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.default_trip_address.address_notes';
    } & TripsCreateTripsIndexPayerDefaultTripAddressAddressNotesErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.default_trip_address.address_type';
    } & TripsCreateTripsIndexPayerDefaultTripAddressAddressTypeErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.multiloading_partners.non_field_errors';
    } & TripsCreateTripsIndexPayerMultiloadingPartnersNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips.INDEX.payer.multiloading_partners.INDEX';
    } & TripsCreateTripsIndexPayerMultiloadingPartnersIndexErrorComponent)
  | ({
      attr: 'trips.INDEX.payer_id';
    } & TripsCreateTripsIndexPayerIdErrorComponent)
  | ({
      attr: 'trips.INDEX.payer_passenger_external_id';
    } & TripsCreateTripsIndexPayerPassengerExternalIdErrorComponent)
  | ({
      attr: 'trips.INDEX.external_trip_id';
    } & TripsCreateTripsIndexExternalTripIdErrorComponent)
  | ({
      attr: 'trips.INDEX.input_price_cents';
    } & TripsCreateTripsIndexInputPriceCentsErrorComponent)
  | ({
      attr: 'trips.INDEX.payment_method';
    } & TripsCreateTripsIndexPaymentMethodErrorComponent)
  | ({
      attr: 'trips.INDEX.scheduled_pickup_at';
    } & TripsCreateTripsIndexScheduledPickupAtErrorComponent)
  | ({
      attr: 'trips.INDEX.pickup.non_field_errors';
    } & TripsCreateTripsIndexPickupNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips.INDEX.pickup.address_details';
    } & TripsCreateTripsIndexPickupAddressDetailsErrorComponent)
  | ({
      attr: 'trips.INDEX.pickup.num_stairs';
    } & TripsCreateTripsIndexPickupNumStairsErrorComponent)
  | ({
      attr: 'trips.INDEX.pickup.stair_equipment';
    } & TripsCreateTripsIndexPickupStairEquipmentErrorComponent)
  | ({
      attr: 'trips.INDEX.pickup.contact_name';
    } & TripsCreateTripsIndexPickupContactNameErrorComponent)
  | ({
      attr: 'trips.INDEX.pickup.contact_phone_number';
    } & TripsCreateTripsIndexPickupContactPhoneNumberErrorComponent)
  | ({
      attr: 'trips.INDEX.pickup.driver_notes';
    } & TripsCreateTripsIndexPickupDriverNotesErrorComponent)
  | ({
      attr: 'trips.INDEX.pickup.place_id';
    } & TripsCreateTripsIndexPickupPlaceIdErrorComponent)
  | ({
      attr: 'trips.INDEX.dropoff.non_field_errors';
    } & TripsCreateTripsIndexDropoffNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips.INDEX.dropoff.address_details';
    } & TripsCreateTripsIndexDropoffAddressDetailsErrorComponent)
  | ({
      attr: 'trips.INDEX.dropoff.num_stairs';
    } & TripsCreateTripsIndexDropoffNumStairsErrorComponent)
  | ({
      attr: 'trips.INDEX.dropoff.stair_equipment';
    } & TripsCreateTripsIndexDropoffStairEquipmentErrorComponent)
  | ({
      attr: 'trips.INDEX.dropoff.contact_name';
    } & TripsCreateTripsIndexDropoffContactNameErrorComponent)
  | ({
      attr: 'trips.INDEX.dropoff.contact_phone_number';
    } & TripsCreateTripsIndexDropoffContactPhoneNumberErrorComponent)
  | ({
      attr: 'trips.INDEX.dropoff.driver_notes';
    } & TripsCreateTripsIndexDropoffDriverNotesErrorComponent)
  | ({
      attr: 'trips.INDEX.dropoff.place_id';
    } & TripsCreateTripsIndexDropoffPlaceIdErrorComponent)
  | ({
      attr: 'trips.INDEX.appointment_at';
    } & TripsCreateTripsIndexAppointmentAtErrorComponent)
  | ({
      attr: 'trips.INDEX.is_will_call';
    } & TripsCreateTripsIndexIsWillCallErrorComponent)
  | ({
      attr: 'trips.INDEX.space_type';
    } & TripsCreateTripsIndexSpaceTypeErrorComponent)
  | ({
      attr: 'trips.INDEX.must_provide_wheelchair';
    } & TripsCreateTripsIndexMustProvideWheelchairErrorComponent)
  | ({
      attr: 'trips.INDEX.service_type';
    } & TripsCreateTripsIndexServiceTypeErrorComponent)
  | ({
      attr: 'trips.INDEX.dispatcher_notes';
    } & TripsCreateTripsIndexDispatcherNotesErrorComponent)
  | ({
      attr: 'trips.INDEX.billing_notes';
    } & TripsCreateTripsIndexBillingNotesErrorComponent)
  | ({
      attr: 'trips.INDEX.driver_entered_notes';
    } & TripsCreateTripsIndexDriverEnteredNotesErrorComponent)
  | ({
      attr: 'trips.INDEX.is_oxygen_required';
    } & TripsCreateTripsIndexIsOxygenRequiredErrorComponent)
  | ({
      attr: 'trips.INDEX.oxygen_liters_per_min';
    } & TripsCreateTripsIndexOxygenLitersPerMinErrorComponent)
  | ({
      attr: 'trips.INDEX.num_attendants_needed';
    } & TripsCreateTripsIndexNumAttendantsNeededErrorComponent)
  | ({
      attr: 'trips.INDEX.num_accompanying_passengers';
    } & TripsCreateTripsIndexNumAccompanyingPassengersErrorComponent)
  | ({
      attr: 'trips.INDEX.one_schema_template_id';
    } & TripsCreateTripsIndexOneSchemaTemplateIdErrorComponent)
  | ({
      attr: 'trips.INDEX.one_schema_template_multi_id';
    } & TripsCreateTripsIndexOneSchemaTemplateMultiIdErrorComponent)
  | ({
      attr: 'trips.INDEX.correlation_id';
    } & TripsCreateTripsIndexCorrelationIdErrorComponent)
  | ({
      attr: 'trips.INDEX.booked_by_name';
    } & TripsCreateTripsIndexBookedByNameErrorComponent)
  | ({
      attr: 'trips.INDEX.booked_by_phone_number';
    } & TripsCreateTripsIndexBookedByPhoneNumberErrorComponent)
  | ({
      attr: 'trips.INDEX.booked_by_phone_extension';
    } & TripsCreateTripsIndexBookedByPhoneExtensionErrorComponent)
  | ({
      attr: 'trips.INDEX.load_time_seconds';
    } & TripsCreateTripsIndexLoadTimeSecondsErrorComponent)
  | ({
      attr: 'trips.INDEX.unload_time_seconds';
    } & TripsCreateTripsIndexUnloadTimeSecondsErrorComponent)
  | ({
      attr: 'trips.INDEX.pickup_wait_time_seconds';
    } & TripsCreateTripsIndexPickupWaitTimeSecondsErrorComponent)
  | ({
      attr: 'trips.INDEX.tag_ids';
    } & TripsCreateTripsIndexTagIdsErrorComponent)
  | ({
      attr: 'trips.INDEX.tag_ids.INDEX';
    } & TripsCreateTripsIndexTagIdsIndexErrorComponent)
  | ({
      attr: 'trips.INDEX.tags.INDEX.tag_name';
    } & TripsCreateTripsIndexTagsIndexTagNameErrorComponent)
  | ({
      attr: 'trips.INDEX.tags.INDEX.color_hex';
    } & TripsCreateTripsIndexTagsIndexColorHexErrorComponent)
  | ({
      attr: 'trips.INDEX.added_tags';
    } & TripsCreateTripsIndexAddedTagsErrorComponent)
  | ({
      attr: 'trips.INDEX.added_tags.INDEX';
    } & TripsCreateTripsIndexAddedTagsIndexErrorComponent)
  | ({
      attr: 'trips.INDEX.is_wait_and_return_outbound';
    } & TripsCreateTripsIndexIsWaitAndReturnOutboundErrorComponent)
  | ({
      attr: 'trips.INDEX.is_wait_and_return_inbound';
    } & TripsCreateTripsIndexIsWaitAndReturnInboundErrorComponent)
  | ({
      attr: 'trips.INDEX.authorization_id';
    } & TripsCreateTripsIndexAuthorizationIdErrorComponent)
  | ({
      attr: 'trips.INDEX.insurance_policy_id';
    } & TripsCreateTripsIndexInsurancePolicyIdErrorComponent)
  | ({
      attr: 'trips.INDEX.is_price_locked';
    } & TripsCreateTripsIndexIsPriceLockedErrorComponent)
  | ({
      attr: 'trips.INDEX.link_to_payer';
    } & TripsCreateTripsIndexLinkToPayerErrorComponent)
  | ({
      attr: 'trips.INDEX.confirmation_code';
    } & TripsCreateTripsIndexConfirmationCodeErrorComponent)
  | ({
      attr: 'trips.INDEX.intermediary';
    } & TripsCreateTripsIndexIntermediaryErrorComponent)
  | ({
      attr: 'trips.INDEX.has_infectious_disease';
    } & TripsCreateTripsIndexHasInfectiousDiseaseErrorComponent)
  | ({
      attr: 'trips.INDEX.seat_equipment';
    } & TripsCreateTripsIndexSeatEquipmentErrorComponent)
  | ({
      attr: 'trips.INDEX.should_avoid_multiload';
    } & TripsCreateTripsIndexShouldAvoidMultiloadErrorComponent)
  | ({
      attr: 'trips.INDEX.import_batch_id';
    } & TripsCreateTripsIndexImportBatchIdErrorComponent);
export type TripsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsCreateError[];
};
export type TripsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TripsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripsPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsPartialUpdateAssignmentStartErrorComponent = {
  attr: 'assignment.start';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type TripsPartialUpdateAssignmentEndErrorComponent = {
  attr: 'assignment.end';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type TripsPartialUpdatePassengerNonFieldErrorsErrorComponent = {
  attr: 'passenger.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsPartialUpdatePassengerIdErrorComponent = {
  attr: 'passenger.id';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsPartialUpdatePassengerFirstNameErrorComponent = {
  attr: 'passenger.first_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePassengerLastNameErrorComponent = {
  attr: 'passenger.last_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePassengerPreferredNameErrorComponent = {
  attr: 'passenger.preferred_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePassengerPronounErrorComponent = {
  attr: 'passenger.pronoun';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePassengerGenderErrorComponent = {
  attr: 'passenger.gender';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePassengerDobErrorComponent = {
  attr: 'passenger.dob';
  code: 'datetime' | 'invalid';
  detail: string;
};
export type TripsPartialUpdatePassengerWeightErrorComponent = {
  attr: 'passenger.weight';
  code: 'invalid' | 'max_string_length' | 'min_value';
  detail: string;
};
export type TripsPartialUpdatePassengerNeedsBariatricTransportErrorComponent = {
  attr: 'passenger.needs_bariatric_transport';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsPartialUpdatePassengerPhoneNumberErrorComponent = {
  attr: 'passenger.phone_number';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePassengerEmailErrorComponent = {
  attr: 'passenger.email';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePassengerNotesErrorComponent = {
  attr: 'passenger.notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePassengerDispatcherNotesErrorComponent = {
  attr: 'passenger.dispatcher_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePassengerAllowSmsMessageErrorComponent = {
  attr: 'passenger.allow_sms_message';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsPartialUpdatePayerPayerErrorComponent = {
  attr: 'payer.payer';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type TripsPartialUpdatePayerDisplayNameErrorComponent = {
  attr: 'payer.display_name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePayerAlternateNameErrorComponent = {
  attr: 'payer.alternate_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePayerTypeErrorComponent = {
  attr: 'payer.type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsPartialUpdatePayerIsActiveErrorComponent = {
  attr: 'payer.is_active';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsPartialUpdatePayerIsSelfPayErrorComponent = {
  attr: 'payer.is_self_pay';
  code: 'invalid';
  detail: string;
};
export type TripsPartialUpdatePayerCanMultiloadErrorComponent = {
  attr: 'payer.can_multiload';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsPartialUpdatePayerExternalIdErrorComponent = {
  attr: 'payer.external_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePayerWebsiteErrorComponent = {
  attr: 'payer.website';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePayerEinErrorComponent = {
  attr: 'payer.ein';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePayerEmailErrorComponent = {
  attr: 'payer.email';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePayerPhoneNumberErrorComponent = {
  attr: 'payer.phone_number';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePayerBillingNameErrorComponent = {
  attr: 'payer.billing_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePayerBillingPhoneNumberErrorComponent = {
  attr: 'payer.billing_phone_number';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePayerBillingEmailErrorComponent = {
  attr: 'payer.billing_email';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePayerDispatcherNotesErrorComponent = {
  attr: 'payer.dispatcher_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePayerAdminNotesErrorComponent = {
  attr: 'payer.admin_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePayerDeletedAtErrorComponent = {
  attr: 'payer.deleted_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type TripsPartialUpdatePayerBillingAddressNonFieldErrorsErrorComponent =
  {
    attr: 'payer.billing_address.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type TripsPartialUpdatePayerBillingAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'payer.billing_address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsPartialUpdatePayerBillingAddressLocationPlaceIdErrorComponent =
  {
    attr: 'payer.billing_address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsPartialUpdatePayerBillingAddressLabelErrorComponent = {
  attr: 'payer.billing_address.label';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePayerBillingAddressLabel2ErrorComponent = {
  attr: 'payer.billing_address.label2';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePayerBillingAddressAddressNotesErrorComponent = {
  attr: 'payer.billing_address.address_notes';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePayerBillingAddressAddressTypeErrorComponent = {
  attr: 'payer.billing_address.address_type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsPartialUpdatePayerDefaultTripAddressNonFieldErrorsErrorComponent =
  {
    attr: 'payer.default_trip_address.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type TripsPartialUpdatePayerDefaultTripAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'payer.default_trip_address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsPartialUpdatePayerDefaultTripAddressLocationPlaceIdErrorComponent =
  {
    attr: 'payer.default_trip_address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsPartialUpdatePayerDefaultTripAddressLabelErrorComponent = {
  attr: 'payer.default_trip_address.label';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePayerDefaultTripAddressLabel2ErrorComponent = {
  attr: 'payer.default_trip_address.label2';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePayerDefaultTripAddressAddressNotesErrorComponent =
  {
    attr: 'payer.default_trip_address.address_notes';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsPartialUpdatePayerDefaultTripAddressAddressTypeErrorComponent =
  {
    attr: 'payer.default_trip_address.address_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsPartialUpdatePayerMultiloadingPartnersNonFieldErrorsErrorComponent =
  {
    attr: 'payer.multiloading_partners.non_field_errors';
    code: 'not_a_list';
    detail: string;
  };
export type TripsPartialUpdatePayerMultiloadingPartnersIndexErrorComponent = {
  attr: 'payer.multiloading_partners.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsPartialUpdatePayerIdErrorComponent = {
  attr: 'payer_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsPartialUpdatePayerPassengerExternalIdErrorComponent = {
  attr: 'payer_passenger_external_id';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdateExternalTripIdErrorComponent = {
  attr: 'external_trip_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdateInputPriceCentsErrorComponent = {
  attr: 'input_price_cents';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type TripsPartialUpdatePaymentMethodErrorComponent = {
  attr: 'payment_method';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsPartialUpdateScheduledPickupAtErrorComponent = {
  attr: 'scheduled_pickup_at';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type TripsPartialUpdatePickupNonFieldErrorsErrorComponent = {
  attr: 'pickup.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsPartialUpdatePickupAddressDetailsErrorComponent = {
  attr: 'pickup.address_details';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePickupNumStairsErrorComponent = {
  attr: 'pickup.num_stairs';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
  detail: string;
};
export type TripsPartialUpdatePickupStairEquipmentErrorComponent = {
  attr: 'pickup.stair_equipment';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsPartialUpdatePickupContactNameErrorComponent = {
  attr: 'pickup.contact_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePickupContactPhoneNumberErrorComponent = {
  attr: 'pickup.contact_phone_number';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePickupDriverNotesErrorComponent = {
  attr: 'pickup.driver_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdatePickupPlaceIdErrorComponent = {
  attr: 'pickup.place_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdateDropoffNonFieldErrorsErrorComponent = {
  attr: 'dropoff.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsPartialUpdateDropoffAddressDetailsErrorComponent = {
  attr: 'dropoff.address_details';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdateDropoffNumStairsErrorComponent = {
  attr: 'dropoff.num_stairs';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
  detail: string;
};
export type TripsPartialUpdateDropoffStairEquipmentErrorComponent = {
  attr: 'dropoff.stair_equipment';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsPartialUpdateDropoffContactNameErrorComponent = {
  attr: 'dropoff.contact_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdateDropoffContactPhoneNumberErrorComponent = {
  attr: 'dropoff.contact_phone_number';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdateDropoffDriverNotesErrorComponent = {
  attr: 'dropoff.driver_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdateDropoffPlaceIdErrorComponent = {
  attr: 'dropoff.place_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdateAppointmentAtErrorComponent = {
  attr: 'appointment_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type TripsPartialUpdateIsWillCallErrorComponent = {
  attr: 'is_will_call';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsPartialUpdateSpaceTypeErrorComponent = {
  attr: 'space_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type TripsPartialUpdateMustProvideWheelchairErrorComponent = {
  attr: 'must_provide_wheelchair';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsPartialUpdateServiceTypeErrorComponent = {
  attr: 'service_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type TripsPartialUpdateDispatcherNotesErrorComponent = {
  attr: 'dispatcher_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdateBillingNotesErrorComponent = {
  attr: 'billing_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdateDriverEnteredNotesErrorComponent = {
  attr: 'driver_entered_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdateIsOxygenRequiredErrorComponent = {
  attr: 'is_oxygen_required';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsPartialUpdateOxygenLitersPerMinErrorComponent = {
  attr: 'oxygen_liters_per_min';
  code:
    | 'invalid'
    | 'max_decimal_places'
    | 'max_digits'
    | 'max_string_length'
    | 'max_whole_digits'
    | 'null';
  detail: string;
};
export type TripsPartialUpdateNumAttendantsNeededErrorComponent = {
  attr: 'num_attendants_needed';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
  detail: string;
};
export type TripsPartialUpdateNumAccompanyingPassengersErrorComponent = {
  attr: 'num_accompanying_passengers';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
  detail: string;
};
export type TripsPartialUpdateOneSchemaTemplateIdErrorComponent = {
  attr: 'one_schema_template_id';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdateOneSchemaTemplateMultiIdErrorComponent = {
  attr: 'one_schema_template_multi_id';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdateCorrelationIdErrorComponent = {
  attr: 'correlation_id';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsPartialUpdateBookedByNameErrorComponent = {
  attr: 'booked_by_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdateBookedByPhoneNumberErrorComponent = {
  attr: 'booked_by_phone_number';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdateBookedByPhoneExtensionErrorComponent = {
  attr: 'booked_by_phone_extension';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdateLoadTimeSecondsErrorComponent = {
  attr: 'load_time_seconds';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type TripsPartialUpdateUnloadTimeSecondsErrorComponent = {
  attr: 'unload_time_seconds';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type TripsPartialUpdatePickupWaitTimeSecondsErrorComponent = {
  attr: 'pickup_wait_time_seconds';
  code: 'invalid' | 'max_string_length' | 'min_value';
  detail: string;
};
export type TripsPartialUpdateTagIdsErrorComponent = {
  attr: 'tag_ids';
  code: 'not_a_list';
  detail: string;
};
export type TripsPartialUpdateTagIdsIndexErrorComponent = {
  attr: 'tag_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsPartialUpdateTagsIndexTagNameErrorComponent = {
  attr: 'tags.INDEX.tag_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdateTagsIndexColorHexErrorComponent = {
  attr: 'tags.INDEX.color_hex';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdateAddedTagsErrorComponent = {
  attr: 'added_tags';
  code: 'not_a_list';
  detail: string;
};
export type TripsPartialUpdateAddedTagsIndexErrorComponent = {
  attr: 'added_tags.INDEX';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdateIsWaitAndReturnOutboundErrorComponent = {
  attr: 'is_wait_and_return_outbound';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsPartialUpdateIsWaitAndReturnInboundErrorComponent = {
  attr: 'is_wait_and_return_inbound';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsPartialUpdateAuthorizationIdErrorComponent = {
  attr: 'authorization_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdateInsurancePolicyIdErrorComponent = {
  attr: 'insurance_policy_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdateIsPriceLockedErrorComponent = {
  attr: 'is_price_locked';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsPartialUpdateLinkToPayerErrorComponent = {
  attr: 'link_to_payer';
  code: 'invalid_choice';
  detail: string;
};
export type TripsPartialUpdateConfirmationCodeErrorComponent = {
  attr: 'confirmation_code';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsPartialUpdateIntermediaryErrorComponent = {
  attr: 'intermediary';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsPartialUpdateHasInfectiousDiseaseErrorComponent = {
  attr: 'has_infectious_disease';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsPartialUpdateSeatEquipmentErrorComponent = {
  attr: 'seat_equipment';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsPartialUpdateShouldAvoidMultiloadErrorComponent = {
  attr: 'should_avoid_multiload';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsPartialUpdateImportBatchIdErrorComponent = {
  attr: 'import_batch_id';
  code: 'invalid' | 'max_string_length';
  detail: string;
};
export type TripsPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & TripsPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'assignment.start';
    } & TripsPartialUpdateAssignmentStartErrorComponent)
  | ({
      attr: 'assignment.end';
    } & TripsPartialUpdateAssignmentEndErrorComponent)
  | ({
      attr: 'passenger.non_field_errors';
    } & TripsPartialUpdatePassengerNonFieldErrorsErrorComponent)
  | ({
      attr: 'passenger.id';
    } & TripsPartialUpdatePassengerIdErrorComponent)
  | ({
      attr: 'passenger.first_name';
    } & TripsPartialUpdatePassengerFirstNameErrorComponent)
  | ({
      attr: 'passenger.last_name';
    } & TripsPartialUpdatePassengerLastNameErrorComponent)
  | ({
      attr: 'passenger.preferred_name';
    } & TripsPartialUpdatePassengerPreferredNameErrorComponent)
  | ({
      attr: 'passenger.pronoun';
    } & TripsPartialUpdatePassengerPronounErrorComponent)
  | ({
      attr: 'passenger.gender';
    } & TripsPartialUpdatePassengerGenderErrorComponent)
  | ({
      attr: 'passenger.dob';
    } & TripsPartialUpdatePassengerDobErrorComponent)
  | ({
      attr: 'passenger.weight';
    } & TripsPartialUpdatePassengerWeightErrorComponent)
  | ({
      attr: 'passenger.needs_bariatric_transport';
    } & TripsPartialUpdatePassengerNeedsBariatricTransportErrorComponent)
  | ({
      attr: 'passenger.phone_number';
    } & TripsPartialUpdatePassengerPhoneNumberErrorComponent)
  | ({
      attr: 'passenger.email';
    } & TripsPartialUpdatePassengerEmailErrorComponent)
  | ({
      attr: 'passenger.notes';
    } & TripsPartialUpdatePassengerNotesErrorComponent)
  | ({
      attr: 'passenger.dispatcher_notes';
    } & TripsPartialUpdatePassengerDispatcherNotesErrorComponent)
  | ({
      attr: 'passenger.allow_sms_message';
    } & TripsPartialUpdatePassengerAllowSmsMessageErrorComponent)
  | ({
      attr: 'payer.payer';
    } & TripsPartialUpdatePayerPayerErrorComponent)
  | ({
      attr: 'payer.display_name';
    } & TripsPartialUpdatePayerDisplayNameErrorComponent)
  | ({
      attr: 'payer.alternate_name';
    } & TripsPartialUpdatePayerAlternateNameErrorComponent)
  | ({
      attr: 'payer.type';
    } & TripsPartialUpdatePayerTypeErrorComponent)
  | ({
      attr: 'payer.is_active';
    } & TripsPartialUpdatePayerIsActiveErrorComponent)
  | ({
      attr: 'payer.is_self_pay';
    } & TripsPartialUpdatePayerIsSelfPayErrorComponent)
  | ({
      attr: 'payer.can_multiload';
    } & TripsPartialUpdatePayerCanMultiloadErrorComponent)
  | ({
      attr: 'payer.external_id';
    } & TripsPartialUpdatePayerExternalIdErrorComponent)
  | ({
      attr: 'payer.website';
    } & TripsPartialUpdatePayerWebsiteErrorComponent)
  | ({
      attr: 'payer.ein';
    } & TripsPartialUpdatePayerEinErrorComponent)
  | ({
      attr: 'payer.email';
    } & TripsPartialUpdatePayerEmailErrorComponent)
  | ({
      attr: 'payer.phone_number';
    } & TripsPartialUpdatePayerPhoneNumberErrorComponent)
  | ({
      attr: 'payer.billing_name';
    } & TripsPartialUpdatePayerBillingNameErrorComponent)
  | ({
      attr: 'payer.billing_phone_number';
    } & TripsPartialUpdatePayerBillingPhoneNumberErrorComponent)
  | ({
      attr: 'payer.billing_email';
    } & TripsPartialUpdatePayerBillingEmailErrorComponent)
  | ({
      attr: 'payer.dispatcher_notes';
    } & TripsPartialUpdatePayerDispatcherNotesErrorComponent)
  | ({
      attr: 'payer.admin_notes';
    } & TripsPartialUpdatePayerAdminNotesErrorComponent)
  | ({
      attr: 'payer.deleted_at';
    } & TripsPartialUpdatePayerDeletedAtErrorComponent)
  | ({
      attr: 'payer.billing_address.non_field_errors';
    } & TripsPartialUpdatePayerBillingAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer.billing_address.location.non_field_errors';
    } & TripsPartialUpdatePayerBillingAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer.billing_address.location.place_id';
    } & TripsPartialUpdatePayerBillingAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'payer.billing_address.label';
    } & TripsPartialUpdatePayerBillingAddressLabelErrorComponent)
  | ({
      attr: 'payer.billing_address.label2';
    } & TripsPartialUpdatePayerBillingAddressLabel2ErrorComponent)
  | ({
      attr: 'payer.billing_address.address_notes';
    } & TripsPartialUpdatePayerBillingAddressAddressNotesErrorComponent)
  | ({
      attr: 'payer.billing_address.address_type';
    } & TripsPartialUpdatePayerBillingAddressAddressTypeErrorComponent)
  | ({
      attr: 'payer.default_trip_address.non_field_errors';
    } & TripsPartialUpdatePayerDefaultTripAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer.default_trip_address.location.non_field_errors';
    } & TripsPartialUpdatePayerDefaultTripAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer.default_trip_address.location.place_id';
    } & TripsPartialUpdatePayerDefaultTripAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'payer.default_trip_address.label';
    } & TripsPartialUpdatePayerDefaultTripAddressLabelErrorComponent)
  | ({
      attr: 'payer.default_trip_address.label2';
    } & TripsPartialUpdatePayerDefaultTripAddressLabel2ErrorComponent)
  | ({
      attr: 'payer.default_trip_address.address_notes';
    } & TripsPartialUpdatePayerDefaultTripAddressAddressNotesErrorComponent)
  | ({
      attr: 'payer.default_trip_address.address_type';
    } & TripsPartialUpdatePayerDefaultTripAddressAddressTypeErrorComponent)
  | ({
      attr: 'payer.multiloading_partners.non_field_errors';
    } & TripsPartialUpdatePayerMultiloadingPartnersNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer.multiloading_partners.INDEX';
    } & TripsPartialUpdatePayerMultiloadingPartnersIndexErrorComponent)
  | ({
      attr: 'payer_id';
    } & TripsPartialUpdatePayerIdErrorComponent)
  | ({
      attr: 'payer_passenger_external_id';
    } & TripsPartialUpdatePayerPassengerExternalIdErrorComponent)
  | ({
      attr: 'external_trip_id';
    } & TripsPartialUpdateExternalTripIdErrorComponent)
  | ({
      attr: 'input_price_cents';
    } & TripsPartialUpdateInputPriceCentsErrorComponent)
  | ({
      attr: 'payment_method';
    } & TripsPartialUpdatePaymentMethodErrorComponent)
  | ({
      attr: 'scheduled_pickup_at';
    } & TripsPartialUpdateScheduledPickupAtErrorComponent)
  | ({
      attr: 'pickup.non_field_errors';
    } & TripsPartialUpdatePickupNonFieldErrorsErrorComponent)
  | ({
      attr: 'pickup.address_details';
    } & TripsPartialUpdatePickupAddressDetailsErrorComponent)
  | ({
      attr: 'pickup.num_stairs';
    } & TripsPartialUpdatePickupNumStairsErrorComponent)
  | ({
      attr: 'pickup.stair_equipment';
    } & TripsPartialUpdatePickupStairEquipmentErrorComponent)
  | ({
      attr: 'pickup.contact_name';
    } & TripsPartialUpdatePickupContactNameErrorComponent)
  | ({
      attr: 'pickup.contact_phone_number';
    } & TripsPartialUpdatePickupContactPhoneNumberErrorComponent)
  | ({
      attr: 'pickup.driver_notes';
    } & TripsPartialUpdatePickupDriverNotesErrorComponent)
  | ({
      attr: 'pickup.place_id';
    } & TripsPartialUpdatePickupPlaceIdErrorComponent)
  | ({
      attr: 'dropoff.non_field_errors';
    } & TripsPartialUpdateDropoffNonFieldErrorsErrorComponent)
  | ({
      attr: 'dropoff.address_details';
    } & TripsPartialUpdateDropoffAddressDetailsErrorComponent)
  | ({
      attr: 'dropoff.num_stairs';
    } & TripsPartialUpdateDropoffNumStairsErrorComponent)
  | ({
      attr: 'dropoff.stair_equipment';
    } & TripsPartialUpdateDropoffStairEquipmentErrorComponent)
  | ({
      attr: 'dropoff.contact_name';
    } & TripsPartialUpdateDropoffContactNameErrorComponent)
  | ({
      attr: 'dropoff.contact_phone_number';
    } & TripsPartialUpdateDropoffContactPhoneNumberErrorComponent)
  | ({
      attr: 'dropoff.driver_notes';
    } & TripsPartialUpdateDropoffDriverNotesErrorComponent)
  | ({
      attr: 'dropoff.place_id';
    } & TripsPartialUpdateDropoffPlaceIdErrorComponent)
  | ({
      attr: 'appointment_at';
    } & TripsPartialUpdateAppointmentAtErrorComponent)
  | ({
      attr: 'is_will_call';
    } & TripsPartialUpdateIsWillCallErrorComponent)
  | ({
      attr: 'space_type';
    } & TripsPartialUpdateSpaceTypeErrorComponent)
  | ({
      attr: 'must_provide_wheelchair';
    } & TripsPartialUpdateMustProvideWheelchairErrorComponent)
  | ({
      attr: 'service_type';
    } & TripsPartialUpdateServiceTypeErrorComponent)
  | ({
      attr: 'dispatcher_notes';
    } & TripsPartialUpdateDispatcherNotesErrorComponent)
  | ({
      attr: 'billing_notes';
    } & TripsPartialUpdateBillingNotesErrorComponent)
  | ({
      attr: 'driver_entered_notes';
    } & TripsPartialUpdateDriverEnteredNotesErrorComponent)
  | ({
      attr: 'is_oxygen_required';
    } & TripsPartialUpdateIsOxygenRequiredErrorComponent)
  | ({
      attr: 'oxygen_liters_per_min';
    } & TripsPartialUpdateOxygenLitersPerMinErrorComponent)
  | ({
      attr: 'num_attendants_needed';
    } & TripsPartialUpdateNumAttendantsNeededErrorComponent)
  | ({
      attr: 'num_accompanying_passengers';
    } & TripsPartialUpdateNumAccompanyingPassengersErrorComponent)
  | ({
      attr: 'one_schema_template_id';
    } & TripsPartialUpdateOneSchemaTemplateIdErrorComponent)
  | ({
      attr: 'one_schema_template_multi_id';
    } & TripsPartialUpdateOneSchemaTemplateMultiIdErrorComponent)
  | ({
      attr: 'correlation_id';
    } & TripsPartialUpdateCorrelationIdErrorComponent)
  | ({
      attr: 'booked_by_name';
    } & TripsPartialUpdateBookedByNameErrorComponent)
  | ({
      attr: 'booked_by_phone_number';
    } & TripsPartialUpdateBookedByPhoneNumberErrorComponent)
  | ({
      attr: 'booked_by_phone_extension';
    } & TripsPartialUpdateBookedByPhoneExtensionErrorComponent)
  | ({
      attr: 'load_time_seconds';
    } & TripsPartialUpdateLoadTimeSecondsErrorComponent)
  | ({
      attr: 'unload_time_seconds';
    } & TripsPartialUpdateUnloadTimeSecondsErrorComponent)
  | ({
      attr: 'pickup_wait_time_seconds';
    } & TripsPartialUpdatePickupWaitTimeSecondsErrorComponent)
  | ({
      attr: 'tag_ids';
    } & TripsPartialUpdateTagIdsErrorComponent)
  | ({
      attr: 'tag_ids.INDEX';
    } & TripsPartialUpdateTagIdsIndexErrorComponent)
  | ({
      attr: 'tags.INDEX.tag_name';
    } & TripsPartialUpdateTagsIndexTagNameErrorComponent)
  | ({
      attr: 'tags.INDEX.color_hex';
    } & TripsPartialUpdateTagsIndexColorHexErrorComponent)
  | ({
      attr: 'added_tags';
    } & TripsPartialUpdateAddedTagsErrorComponent)
  | ({
      attr: 'added_tags.INDEX';
    } & TripsPartialUpdateAddedTagsIndexErrorComponent)
  | ({
      attr: 'is_wait_and_return_outbound';
    } & TripsPartialUpdateIsWaitAndReturnOutboundErrorComponent)
  | ({
      attr: 'is_wait_and_return_inbound';
    } & TripsPartialUpdateIsWaitAndReturnInboundErrorComponent)
  | ({
      attr: 'authorization_id';
    } & TripsPartialUpdateAuthorizationIdErrorComponent)
  | ({
      attr: 'insurance_policy_id';
    } & TripsPartialUpdateInsurancePolicyIdErrorComponent)
  | ({
      attr: 'is_price_locked';
    } & TripsPartialUpdateIsPriceLockedErrorComponent)
  | ({
      attr: 'link_to_payer';
    } & TripsPartialUpdateLinkToPayerErrorComponent)
  | ({
      attr: 'confirmation_code';
    } & TripsPartialUpdateConfirmationCodeErrorComponent)
  | ({
      attr: 'intermediary';
    } & TripsPartialUpdateIntermediaryErrorComponent)
  | ({
      attr: 'has_infectious_disease';
    } & TripsPartialUpdateHasInfectiousDiseaseErrorComponent)
  | ({
      attr: 'seat_equipment';
    } & TripsPartialUpdateSeatEquipmentErrorComponent)
  | ({
      attr: 'should_avoid_multiload';
    } & TripsPartialUpdateShouldAvoidMultiloadErrorComponent)
  | ({
      attr: 'import_batch_id';
    } & TripsPartialUpdateImportBatchIdErrorComponent);
export type TripsPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsPartialUpdateError[];
};
export type TripsPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedTrip = {
  passenger?: PatchedTripPassenger;
  /** The trip ID used by the trip originator, (e.g. payer or original broker) */
  external_trip_id?: string;
  /** The manually inputted price of the trip */
  input_price_cents?: number | null;
  payment_method?: PaymentMethodEnum | BlankEnum;
  scheduled_pickup_at?: string;
  pickup?: TripLocationDetail;
  dropoff?: TripLocationDetail;
  /** The time of the passenger's appointment */
  appointment_at?: string | null;
  /** Whether the passenger will call when it is time to be picked up */
  is_will_call?: boolean;
  /** The type of space in the vehicle this passenger will need */
  space_type?: SpaceTypeEnum;
  /** Whether the passenger will supply their own wheelchair or not */
  must_provide_wheelchair?: boolean;
  service_type?: ServiceTypeEnum;
  /** Notes only visible to the dispatcher */
  dispatcher_notes?: string;
  /** Notes about the trip for billing purposes */
  billing_notes?: string;
  /** Notes entered by the driver */
  driver_entered_notes?: string;
  is_oxygen_required?: boolean;
  oxygen_liters_per_min?: string;
  num_attendants_needed?: number;
  /** How many additional people will be accompanying the primary passenger */
  num_accompanying_passengers?: number;
  one_schema_template_id?: string;
  one_schema_template_multi_id?: string;
  correlation_id?: string;
  /** Who booked this trip, if not passenger */
  booked_by_name?: string;
  /** Phone number of who booked this trip, if not passenger */
  booked_by_phone_number?: string | null;
  /** Phone number extension of who booked this trip, if not passenger */
  booked_by_phone_extension?: string;
  load_time_seconds?: number | null;
  unload_time_seconds?: number | null;
  pickup_wait_time_seconds?: number | null;
  /** Whether this is the first leg of a wait and return trip */
  is_wait_and_return_outbound?: boolean;
  /** Whether this is the second leg of a wait and return trip */
  is_wait_and_return_inbound?: boolean;
  /** The authorization ID for this trip */
  authorization_id?: string;
  /** The insurance policy ID for this trip */
  insurance_policy_id?: string;
  /** Whether this trips pricing is locked (non-editable) */
  is_price_locked?: boolean;
  link_to_payer?: (LinkToPayerEnum | NullEnum) | null;
  confirmation_code?: string;
  intermediary?: IntermediaryEnum | BlankEnum;
  /** Whether the passenger has an infectious disease */
  has_infectious_disease?: boolean;
  /** The seat equipment needed for this trip */
  seat_equipment?: SeatEquipmentEnum | BlankEnum;
  /** Whether this trip should avoid being multiloaded with other passengers */
  should_avoid_multiload?: boolean;
  import_batch_id?: number | null;
};
export type PatchedTripRead = {
  id?: string;
  assignment?: AssignmentMiniRead | null;
  /** Current status of this trip */
  status?: OverrideStatusEnum;
  /** Locked assignment cannot be changed */
  is_locked?: boolean | null;
  passenger?: PatchedTripPassengerRead;
  payer?: PayerOrganizationRead;
  payer_passenger?: TripPayerPassengerRead | null;
  early_pickup_at?: string;
  late_pickup_at?: string;
  /** The trip ID used by the trip originator, (e.g. payer or original broker) */
  external_trip_id?: string;
  /** The initial price of the trip calculated using a pricing model */
  initial_calculated_price_cents?: number | null;
  /** The final price of the trip calculated using a pricing model */
  final_calculated_price_cents?: number | null;
  /** The manually inputted price of the trip */
  input_price_cents?: number | null;
  payment_method?: PaymentMethodEnum | BlankEnum;
  scheduled_pickup_at?: string;
  current_task?: PurposeEnum;
  current_task_at?: string;
  pickup?: TripLocationDetailRead;
  dropoff?: TripLocationDetailRead;
  /** The time of the passenger's appointment */
  appointment_at?: string | null;
  /** Whether the passenger will call when it is time to be picked up */
  is_will_call?: boolean;
  /** Whether the passenger has called in that they are ready to be picked up */
  is_will_call_activated?: boolean;
  /** The type of space in the vehicle this passenger will need */
  space_type?: SpaceTypeEnum;
  /** Whether the passenger will supply their own wheelchair or not */
  must_provide_wheelchair?: boolean;
  service_type?: ServiceTypeEnum;
  /** Notes only visible to the dispatcher */
  dispatcher_notes?: string;
  /** Notes about the trip for billing purposes */
  billing_notes?: string;
  /** Notes entered by the driver */
  driver_entered_notes?: string;
  is_oxygen_required?: boolean;
  oxygen_liters_per_min?: string;
  num_attendants_needed?: number;
  /** How many additional people will be accompanying the primary passenger */
  num_accompanying_passengers?: number;
  estimated_distance_miles?: number | null;
  /** The time the trip was canceled */
  canceled_at?: string | null;
  /** The main reason a trip was canceled */
  canceled_reason?: CanceledReasonEnum;
  one_schema_template_id?: string;
  one_schema_template_multi_id?: string;
  correlation_id?: string;
  /** Who booked this trip, if not passenger */
  booked_by_name?: string;
  /** Phone number of who booked this trip, if not passenger */
  booked_by_phone_number?: string | null;
  /** Phone number extension of who booked this trip, if not passenger */
  booked_by_phone_extension?: string;
  timing?: TripTimingRead | null;
  load_time_seconds?: number | null;
  unload_time_seconds?: number | null;
  pickup_wait_time_seconds?: number | null;
  tags?: TripTripTagRead[] | null;
  /** The suggested pickup time based off of run_bambi_run results */
  suggested_pickup_time?: string | null;
  /** Whether this is the first leg of a wait and return trip */
  is_wait_and_return_outbound?: boolean;
  /** Whether this is the second leg of a wait and return trip */
  is_wait_and_return_inbound?: boolean;
  /** The authorization ID for this trip */
  authorization_id?: string;
  /** The insurance policy ID for this trip */
  insurance_policy_id?: string;
  /** Whether this trips pricing is locked (non-editable) */
  is_price_locked?: boolean;
  link_to_payer?: (LinkToPayerEnum | NullEnum) | null;
  confirmation_code?: string;
  driver_name?: string;
  invoice_numbers?: string | null;
  invoice_id?: string | null;
  rejection_reason?: string | null;
  /** The trip ID used by an intermediary/broker, may or may not be the originator */
  intermediary_id?: string;
  intermediary?: IntermediaryEnum | BlankEnum;
  /** How this trip was created */
  source?: TripSourceEnum | BlankEnum;
  /** Whether the passenger has an infectious disease */
  has_infectious_disease?: boolean;
  completion_time?: string | null;
  vehicle_nickname?: string | null;
  /** Membership that caused a model creation */
  created_by?: string | null;
  created_at?: string;
  is_cancellation_requested?: boolean;
  /** The seat equipment needed for this trip */
  seat_equipment?: SeatEquipmentEnum | BlankEnum;
  /** Whether this trip should avoid being multiloaded with other passengers */
  should_avoid_multiload?: boolean;
  import_batch_id?: number | null;
};
export type PatchedTripWrite = {
  passenger?: PatchedTripPassenger;
  payer_id?: string;
  payer_passenger_external_id?: string;
  /** The trip ID used by the trip originator, (e.g. payer or original broker) */
  external_trip_id?: string;
  /** The manually inputted price of the trip */
  input_price_cents?: number | null;
  payment_method?: PaymentMethodEnum | BlankEnum;
  scheduled_pickup_at?: string;
  pickup?: TripLocationDetail;
  dropoff?: TripLocationDetail;
  /** The time of the passenger's appointment */
  appointment_at?: string | null;
  /** Whether the passenger will call when it is time to be picked up */
  is_will_call?: boolean;
  /** The type of space in the vehicle this passenger will need */
  space_type?: SpaceTypeEnum;
  /** Whether the passenger will supply their own wheelchair or not */
  must_provide_wheelchair?: boolean;
  service_type?: ServiceTypeEnum;
  /** Notes only visible to the dispatcher */
  dispatcher_notes?: string;
  /** Notes about the trip for billing purposes */
  billing_notes?: string;
  /** Notes entered by the driver */
  driver_entered_notes?: string;
  is_oxygen_required?: boolean;
  oxygen_liters_per_min?: string;
  num_attendants_needed?: number;
  /** How many additional people will be accompanying the primary passenger */
  num_accompanying_passengers?: number;
  one_schema_template_id?: string;
  one_schema_template_multi_id?: string;
  correlation_id?: string;
  /** Who booked this trip, if not passenger */
  booked_by_name?: string;
  /** Phone number of who booked this trip, if not passenger */
  booked_by_phone_number?: string | null;
  /** Phone number extension of who booked this trip, if not passenger */
  booked_by_phone_extension?: string;
  load_time_seconds?: number | null;
  unload_time_seconds?: number | null;
  pickup_wait_time_seconds?: number | null;
  tag_ids?: string[] | null;
  added_tags?: string[] | null;
  /** Whether this is the first leg of a wait and return trip */
  is_wait_and_return_outbound?: boolean;
  /** Whether this is the second leg of a wait and return trip */
  is_wait_and_return_inbound?: boolean;
  /** The authorization ID for this trip */
  authorization_id?: string;
  /** The insurance policy ID for this trip */
  insurance_policy_id?: string;
  /** Whether this trips pricing is locked (non-editable) */
  is_price_locked?: boolean;
  link_to_payer?: (LinkToPayerEnum | NullEnum) | null;
  confirmation_code?: string;
  intermediary?: IntermediaryEnum | BlankEnum;
  /** Whether the passenger has an infectious disease */
  has_infectious_disease?: boolean;
  /** The seat equipment needed for this trip */
  seat_equipment?: SeatEquipmentEnum | BlankEnum;
  /** Whether this trip should avoid being multiloaded with other passengers */
  should_avoid_multiload?: boolean;
  import_batch_id?: number | null;
};
export type TripsDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripAccept = {};
export type TripAcceptWrite = {
  override?: boolean;
};
export type TripsAcceptPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsAcceptPartialUpdateOverrideErrorComponent = {
  attr: 'override';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsAcceptPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & TripsAcceptPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'override';
    } & TripsAcceptPartialUpdateOverrideErrorComponent);
export type TripsAcceptPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsAcceptPartialUpdateError[];
};
export type TripsAcceptPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsAcceptPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedTripAccept = {};
export type PatchedTripAcceptWrite = {
  override?: boolean;
};
export type TripsAcceptCancellationRequestPartialUpdateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type TripsAcceptCancellationRequestPartialUpdateError = {
  attr: 'non_field_errors';
} & TripsAcceptCancellationRequestPartialUpdateNonFieldErrorsErrorComponent;
export type TripsAcceptCancellationRequestPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsAcceptCancellationRequestPartialUpdateError[];
};
export type TripsAcceptCancellationRequestPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsAcceptCancellationRequestPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TripActivateWillCall = {};
export type TripActivateWillCallWrite = {
  pickup_at: string;
};
export type TripsActivateWillCallPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsActivateWillCallPartialUpdatePickupAtErrorComponent = {
  attr: 'pickup_at';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type TripsActivateWillCallPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & TripsActivateWillCallPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'pickup_at';
    } & TripsActivateWillCallPartialUpdatePickupAtErrorComponent);
export type TripsActivateWillCallPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsActivateWillCallPartialUpdateError[];
};
export type TripsActivateWillCallPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsActivateWillCallPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedTripActivateWillCall = {};
export type PatchedTripActivateWillCallWrite = {
  pickup_at?: string;
};
export type TripAddTripLeg = {
  original_trip: PatchedTrip;
  return_trip: Trip;
};
export type TripAddTripLegRead = {
  original_trip: PatchedTripRead;
  return_trip: TripRead;
};
export type TripAddTripLegWrite = {
  original_trip: PatchedTripWrite;
  return_trip: TripWrite;
};
export type TripsAddTripLegPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsAddTripLegPartialUpdateOriginalTripNonFieldErrorsErrorComponent =
  {
    attr: 'original_trip.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripAssignmentStartErrorComponent =
  {
    attr: 'original_trip.assignment.start';
    code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripAssignmentEndErrorComponent =
  {
    attr: 'original_trip.assignment.end';
    code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPassengerNonFieldErrorsErrorComponent =
  {
    attr: 'original_trip.passenger.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPassengerIdErrorComponent =
  {
    attr: 'original_trip.passenger.id';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPassengerFirstNameErrorComponent =
  {
    attr: 'original_trip.passenger.first_name';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPassengerLastNameErrorComponent =
  {
    attr: 'original_trip.passenger.last_name';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPassengerPreferredNameErrorComponent =
  {
    attr: 'original_trip.passenger.preferred_name';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPassengerPronounErrorComponent =
  {
    attr: 'original_trip.passenger.pronoun';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPassengerGenderErrorComponent =
  {
    attr: 'original_trip.passenger.gender';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPassengerDobErrorComponent =
  {
    attr: 'original_trip.passenger.dob';
    code: 'datetime' | 'invalid';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPassengerWeightErrorComponent =
  {
    attr: 'original_trip.passenger.weight';
    code: 'invalid' | 'max_string_length' | 'min_value';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPassengerNeedsBariatricTransportErrorComponent =
  {
    attr: 'original_trip.passenger.needs_bariatric_transport';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPassengerPhoneNumberErrorComponent =
  {
    attr: 'original_trip.passenger.phone_number';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPassengerEmailErrorComponent =
  {
    attr: 'original_trip.passenger.email';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPassengerNotesErrorComponent =
  {
    attr: 'original_trip.passenger.notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPassengerDispatcherNotesErrorComponent =
  {
    attr: 'original_trip.passenger.dispatcher_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPassengerAllowSmsMessageErrorComponent =
  {
    attr: 'original_trip.passenger.allow_sms_message';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerPayerErrorComponent = {
  attr: 'original_trip.payer.payer';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type TripsAddTripLegPartialUpdateOriginalTripPayerDisplayNameErrorComponent =
  {
    attr: 'original_trip.payer.display_name';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerAlternateNameErrorComponent =
  {
    attr: 'original_trip.payer.alternate_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerTypeErrorComponent = {
  attr: 'original_trip.payer.type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsAddTripLegPartialUpdateOriginalTripPayerIsActiveErrorComponent =
  {
    attr: 'original_trip.payer.is_active';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerIsSelfPayErrorComponent =
  {
    attr: 'original_trip.payer.is_self_pay';
    code: 'invalid';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerCanMultiloadErrorComponent =
  {
    attr: 'original_trip.payer.can_multiload';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerExternalIdErrorComponent =
  {
    attr: 'original_trip.payer.external_id';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerWebsiteErrorComponent =
  {
    attr: 'original_trip.payer.website';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerEinErrorComponent = {
  attr: 'original_trip.payer.ein';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsAddTripLegPartialUpdateOriginalTripPayerEmailErrorComponent = {
  attr: 'original_trip.payer.email';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsAddTripLegPartialUpdateOriginalTripPayerPhoneNumberErrorComponent =
  {
    attr: 'original_trip.payer.phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerBillingNameErrorComponent =
  {
    attr: 'original_trip.payer.billing_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerBillingPhoneNumberErrorComponent =
  {
    attr: 'original_trip.payer.billing_phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerBillingEmailErrorComponent =
  {
    attr: 'original_trip.payer.billing_email';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerDispatcherNotesErrorComponent =
  {
    attr: 'original_trip.payer.dispatcher_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerAdminNotesErrorComponent =
  {
    attr: 'original_trip.payer.admin_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerDeletedAtErrorComponent =
  {
    attr: 'original_trip.payer.deleted_at';
    code: 'date' | 'invalid' | 'make_aware' | 'overflow';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerBillingAddressNonFieldErrorsErrorComponent =
  {
    attr: 'original_trip.payer.billing_address.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerBillingAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'original_trip.payer.billing_address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerBillingAddressLocationPlaceIdErrorComponent =
  {
    attr: 'original_trip.payer.billing_address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerBillingAddressLabelErrorComponent =
  {
    attr: 'original_trip.payer.billing_address.label';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerBillingAddressLabel2ErrorComponent =
  {
    attr: 'original_trip.payer.billing_address.label2';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerBillingAddressAddressNotesErrorComponent =
  {
    attr: 'original_trip.payer.billing_address.address_notes';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerBillingAddressAddressTypeErrorComponent =
  {
    attr: 'original_trip.payer.billing_address.address_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerDefaultTripAddressNonFieldErrorsErrorComponent =
  {
    attr: 'original_trip.payer.default_trip_address.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerDefaultTripAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'original_trip.payer.default_trip_address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerDefaultTripAddressLocationPlaceIdErrorComponent =
  {
    attr: 'original_trip.payer.default_trip_address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerDefaultTripAddressLabelErrorComponent =
  {
    attr: 'original_trip.payer.default_trip_address.label';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerDefaultTripAddressLabel2ErrorComponent =
  {
    attr: 'original_trip.payer.default_trip_address.label2';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerDefaultTripAddressAddressNotesErrorComponent =
  {
    attr: 'original_trip.payer.default_trip_address.address_notes';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerDefaultTripAddressAddressTypeErrorComponent =
  {
    attr: 'original_trip.payer.default_trip_address.address_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerMultiloadingPartnersNonFieldErrorsErrorComponent =
  {
    attr: 'original_trip.payer.multiloading_partners.non_field_errors';
    code: 'not_a_list';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerMultiloadingPartnersIndexErrorComponent =
  {
    attr: 'original_trip.payer.multiloading_partners.INDEX';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPayerIdErrorComponent = {
  attr: 'original_trip.payer_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsAddTripLegPartialUpdateOriginalTripPayerPassengerExternalIdErrorComponent =
  {
    attr: 'original_trip.payer_passenger_external_id';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripExternalTripIdErrorComponent =
  {
    attr: 'original_trip.external_trip_id';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripInputPriceCentsErrorComponent =
  {
    attr: 'original_trip.input_price_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPaymentMethodErrorComponent =
  {
    attr: 'original_trip.payment_method';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripScheduledPickupAtErrorComponent =
  {
    attr: 'original_trip.scheduled_pickup_at';
    code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPickupNonFieldErrorsErrorComponent =
  {
    attr: 'original_trip.pickup.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPickupAddressDetailsErrorComponent =
  {
    attr: 'original_trip.pickup.address_details';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPickupNumStairsErrorComponent =
  {
    attr: 'original_trip.pickup.num_stairs';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPickupStairEquipmentErrorComponent =
  {
    attr: 'original_trip.pickup.stair_equipment';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPickupContactNameErrorComponent =
  {
    attr: 'original_trip.pickup.contact_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPickupContactPhoneNumberErrorComponent =
  {
    attr: 'original_trip.pickup.contact_phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPickupDriverNotesErrorComponent =
  {
    attr: 'original_trip.pickup.driver_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPickupPlaceIdErrorComponent =
  {
    attr: 'original_trip.pickup.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripDropoffNonFieldErrorsErrorComponent =
  {
    attr: 'original_trip.dropoff.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripDropoffAddressDetailsErrorComponent =
  {
    attr: 'original_trip.dropoff.address_details';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripDropoffNumStairsErrorComponent =
  {
    attr: 'original_trip.dropoff.num_stairs';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripDropoffStairEquipmentErrorComponent =
  {
    attr: 'original_trip.dropoff.stair_equipment';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripDropoffContactNameErrorComponent =
  {
    attr: 'original_trip.dropoff.contact_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripDropoffContactPhoneNumberErrorComponent =
  {
    attr: 'original_trip.dropoff.contact_phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripDropoffDriverNotesErrorComponent =
  {
    attr: 'original_trip.dropoff.driver_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripDropoffPlaceIdErrorComponent =
  {
    attr: 'original_trip.dropoff.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripAppointmentAtErrorComponent =
  {
    attr: 'original_trip.appointment_at';
    code: 'date' | 'invalid' | 'make_aware' | 'overflow';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripIsWillCallErrorComponent = {
  attr: 'original_trip.is_will_call';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsAddTripLegPartialUpdateOriginalTripSpaceTypeErrorComponent = {
  attr: 'original_trip.space_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type TripsAddTripLegPartialUpdateOriginalTripMustProvideWheelchairErrorComponent =
  {
    attr: 'original_trip.must_provide_wheelchair';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripServiceTypeErrorComponent =
  {
    attr: 'original_trip.service_type';
    code: 'invalid_choice' | 'null' | 'required';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripDispatcherNotesErrorComponent =
  {
    attr: 'original_trip.dispatcher_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripBillingNotesErrorComponent =
  {
    attr: 'original_trip.billing_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripDriverEnteredNotesErrorComponent =
  {
    attr: 'original_trip.driver_entered_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripIsOxygenRequiredErrorComponent =
  {
    attr: 'original_trip.is_oxygen_required';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripOxygenLitersPerMinErrorComponent =
  {
    attr: 'original_trip.oxygen_liters_per_min';
    code:
      | 'invalid'
      | 'max_decimal_places'
      | 'max_digits'
      | 'max_string_length'
      | 'max_whole_digits'
      | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripNumAttendantsNeededErrorComponent =
  {
    attr: 'original_trip.num_attendants_needed';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripNumAccompanyingPassengersErrorComponent =
  {
    attr: 'original_trip.num_accompanying_passengers';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripOneSchemaTemplateIdErrorComponent =
  {
    attr: 'original_trip.one_schema_template_id';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripOneSchemaTemplateMultiIdErrorComponent =
  {
    attr: 'original_trip.one_schema_template_multi_id';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripCorrelationIdErrorComponent =
  {
    attr: 'original_trip.correlation_id';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripBookedByNameErrorComponent =
  {
    attr: 'original_trip.booked_by_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripBookedByPhoneNumberErrorComponent =
  {
    attr: 'original_trip.booked_by_phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripBookedByPhoneExtensionErrorComponent =
  {
    attr: 'original_trip.booked_by_phone_extension';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripLoadTimeSecondsErrorComponent =
  {
    attr: 'original_trip.load_time_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripUnloadTimeSecondsErrorComponent =
  {
    attr: 'original_trip.unload_time_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripPickupWaitTimeSecondsErrorComponent =
  {
    attr: 'original_trip.pickup_wait_time_seconds';
    code: 'invalid' | 'max_string_length' | 'min_value';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripTagIdsErrorComponent = {
  attr: 'original_trip.tag_ids';
  code: 'not_a_list';
  detail: string;
};
export type TripsAddTripLegPartialUpdateOriginalTripTagIdsIndexErrorComponent =
  {
    attr: 'original_trip.tag_ids.INDEX';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripTagsIndexTagNameErrorComponent =
  {
    attr: 'original_trip.tags.INDEX.tag_name';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripTagsIndexColorHexErrorComponent =
  {
    attr: 'original_trip.tags.INDEX.color_hex';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripAddedTagsErrorComponent = {
  attr: 'original_trip.added_tags';
  code: 'not_a_list';
  detail: string;
};
export type TripsAddTripLegPartialUpdateOriginalTripAddedTagsIndexErrorComponent =
  {
    attr: 'original_trip.added_tags.INDEX';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripIsWaitAndReturnOutboundErrorComponent =
  {
    attr: 'original_trip.is_wait_and_return_outbound';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripIsWaitAndReturnInboundErrorComponent =
  {
    attr: 'original_trip.is_wait_and_return_inbound';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripAuthorizationIdErrorComponent =
  {
    attr: 'original_trip.authorization_id';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripInsurancePolicyIdErrorComponent =
  {
    attr: 'original_trip.insurance_policy_id';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripIsPriceLockedErrorComponent =
  {
    attr: 'original_trip.is_price_locked';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripLinkToPayerErrorComponent =
  {
    attr: 'original_trip.link_to_payer';
    code: 'invalid_choice';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripConfirmationCodeErrorComponent =
  {
    attr: 'original_trip.confirmation_code';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripIntermediaryErrorComponent =
  {
    attr: 'original_trip.intermediary';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripHasInfectiousDiseaseErrorComponent =
  {
    attr: 'original_trip.has_infectious_disease';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripSeatEquipmentErrorComponent =
  {
    attr: 'original_trip.seat_equipment';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripShouldAvoidMultiloadErrorComponent =
  {
    attr: 'original_trip.should_avoid_multiload';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateOriginalTripImportBatchIdErrorComponent =
  {
    attr: 'original_trip.import_batch_id';
    code: 'invalid' | 'max_string_length';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripNonFieldErrorsErrorComponent =
  {
    attr: 'return_trip.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripAssignmentStartErrorComponent =
  {
    attr: 'return_trip.assignment.start';
    code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripAssignmentEndErrorComponent =
  {
    attr: 'return_trip.assignment.end';
    code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPassengerNonFieldErrorsErrorComponent =
  {
    attr: 'return_trip.passenger.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPassengerIdErrorComponent = {
  attr: 'return_trip.passenger.id';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsAddTripLegPartialUpdateReturnTripPassengerFirstNameErrorComponent =
  {
    attr: 'return_trip.passenger.first_name';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPassengerLastNameErrorComponent =
  {
    attr: 'return_trip.passenger.last_name';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPassengerPreferredNameErrorComponent =
  {
    attr: 'return_trip.passenger.preferred_name';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPassengerPronounErrorComponent =
  {
    attr: 'return_trip.passenger.pronoun';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPassengerGenderErrorComponent =
  {
    attr: 'return_trip.passenger.gender';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPassengerDobErrorComponent = {
  attr: 'return_trip.passenger.dob';
  code: 'datetime' | 'invalid';
  detail: string;
};
export type TripsAddTripLegPartialUpdateReturnTripPassengerWeightErrorComponent =
  {
    attr: 'return_trip.passenger.weight';
    code: 'invalid' | 'max_string_length' | 'min_value';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPassengerNeedsBariatricTransportErrorComponent =
  {
    attr: 'return_trip.passenger.needs_bariatric_transport';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPassengerPhoneNumberErrorComponent =
  {
    attr: 'return_trip.passenger.phone_number';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPassengerEmailErrorComponent =
  {
    attr: 'return_trip.passenger.email';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPassengerNotesErrorComponent =
  {
    attr: 'return_trip.passenger.notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPassengerDispatcherNotesErrorComponent =
  {
    attr: 'return_trip.passenger.dispatcher_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPassengerAllowSmsMessageErrorComponent =
  {
    attr: 'return_trip.passenger.allow_sms_message';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerPayerErrorComponent = {
  attr: 'return_trip.payer.payer';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type TripsAddTripLegPartialUpdateReturnTripPayerDisplayNameErrorComponent =
  {
    attr: 'return_trip.payer.display_name';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerAlternateNameErrorComponent =
  {
    attr: 'return_trip.payer.alternate_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerTypeErrorComponent = {
  attr: 'return_trip.payer.type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsAddTripLegPartialUpdateReturnTripPayerIsActiveErrorComponent =
  {
    attr: 'return_trip.payer.is_active';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerIsSelfPayErrorComponent =
  {
    attr: 'return_trip.payer.is_self_pay';
    code: 'invalid';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerCanMultiloadErrorComponent =
  {
    attr: 'return_trip.payer.can_multiload';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerExternalIdErrorComponent =
  {
    attr: 'return_trip.payer.external_id';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerWebsiteErrorComponent = {
  attr: 'return_trip.payer.website';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsAddTripLegPartialUpdateReturnTripPayerEinErrorComponent = {
  attr: 'return_trip.payer.ein';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsAddTripLegPartialUpdateReturnTripPayerEmailErrorComponent = {
  attr: 'return_trip.payer.email';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsAddTripLegPartialUpdateReturnTripPayerPhoneNumberErrorComponent =
  {
    attr: 'return_trip.payer.phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerBillingNameErrorComponent =
  {
    attr: 'return_trip.payer.billing_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerBillingPhoneNumberErrorComponent =
  {
    attr: 'return_trip.payer.billing_phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerBillingEmailErrorComponent =
  {
    attr: 'return_trip.payer.billing_email';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerDispatcherNotesErrorComponent =
  {
    attr: 'return_trip.payer.dispatcher_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerAdminNotesErrorComponent =
  {
    attr: 'return_trip.payer.admin_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerDeletedAtErrorComponent =
  {
    attr: 'return_trip.payer.deleted_at';
    code: 'date' | 'invalid' | 'make_aware' | 'overflow';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerBillingAddressNonFieldErrorsErrorComponent =
  {
    attr: 'return_trip.payer.billing_address.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerBillingAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'return_trip.payer.billing_address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerBillingAddressLocationPlaceIdErrorComponent =
  {
    attr: 'return_trip.payer.billing_address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerBillingAddressLabelErrorComponent =
  {
    attr: 'return_trip.payer.billing_address.label';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerBillingAddressLabel2ErrorComponent =
  {
    attr: 'return_trip.payer.billing_address.label2';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerBillingAddressAddressNotesErrorComponent =
  {
    attr: 'return_trip.payer.billing_address.address_notes';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerBillingAddressAddressTypeErrorComponent =
  {
    attr: 'return_trip.payer.billing_address.address_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerDefaultTripAddressNonFieldErrorsErrorComponent =
  {
    attr: 'return_trip.payer.default_trip_address.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerDefaultTripAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'return_trip.payer.default_trip_address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerDefaultTripAddressLocationPlaceIdErrorComponent =
  {
    attr: 'return_trip.payer.default_trip_address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerDefaultTripAddressLabelErrorComponent =
  {
    attr: 'return_trip.payer.default_trip_address.label';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerDefaultTripAddressLabel2ErrorComponent =
  {
    attr: 'return_trip.payer.default_trip_address.label2';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerDefaultTripAddressAddressNotesErrorComponent =
  {
    attr: 'return_trip.payer.default_trip_address.address_notes';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerDefaultTripAddressAddressTypeErrorComponent =
  {
    attr: 'return_trip.payer.default_trip_address.address_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerMultiloadingPartnersNonFieldErrorsErrorComponent =
  {
    attr: 'return_trip.payer.multiloading_partners.non_field_errors';
    code: 'not_a_list';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerMultiloadingPartnersIndexErrorComponent =
  {
    attr: 'return_trip.payer.multiloading_partners.INDEX';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPayerIdErrorComponent = {
  attr: 'return_trip.payer_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsAddTripLegPartialUpdateReturnTripPayerPassengerExternalIdErrorComponent =
  {
    attr: 'return_trip.payer_passenger_external_id';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripExternalTripIdErrorComponent =
  {
    attr: 'return_trip.external_trip_id';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripInputPriceCentsErrorComponent =
  {
    attr: 'return_trip.input_price_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPaymentMethodErrorComponent =
  {
    attr: 'return_trip.payment_method';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripScheduledPickupAtErrorComponent =
  {
    attr: 'return_trip.scheduled_pickup_at';
    code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPickupNonFieldErrorsErrorComponent =
  {
    attr: 'return_trip.pickup.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPickupAddressDetailsErrorComponent =
  {
    attr: 'return_trip.pickup.address_details';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPickupNumStairsErrorComponent =
  {
    attr: 'return_trip.pickup.num_stairs';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPickupStairEquipmentErrorComponent =
  {
    attr: 'return_trip.pickup.stair_equipment';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPickupContactNameErrorComponent =
  {
    attr: 'return_trip.pickup.contact_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPickupContactPhoneNumberErrorComponent =
  {
    attr: 'return_trip.pickup.contact_phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPickupDriverNotesErrorComponent =
  {
    attr: 'return_trip.pickup.driver_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPickupPlaceIdErrorComponent =
  {
    attr: 'return_trip.pickup.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripDropoffNonFieldErrorsErrorComponent =
  {
    attr: 'return_trip.dropoff.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripDropoffAddressDetailsErrorComponent =
  {
    attr: 'return_trip.dropoff.address_details';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripDropoffNumStairsErrorComponent =
  {
    attr: 'return_trip.dropoff.num_stairs';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripDropoffStairEquipmentErrorComponent =
  {
    attr: 'return_trip.dropoff.stair_equipment';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripDropoffContactNameErrorComponent =
  {
    attr: 'return_trip.dropoff.contact_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripDropoffContactPhoneNumberErrorComponent =
  {
    attr: 'return_trip.dropoff.contact_phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripDropoffDriverNotesErrorComponent =
  {
    attr: 'return_trip.dropoff.driver_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripDropoffPlaceIdErrorComponent =
  {
    attr: 'return_trip.dropoff.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripAppointmentAtErrorComponent =
  {
    attr: 'return_trip.appointment_at';
    code: 'date' | 'invalid' | 'make_aware' | 'overflow';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripIsWillCallErrorComponent = {
  attr: 'return_trip.is_will_call';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsAddTripLegPartialUpdateReturnTripSpaceTypeErrorComponent = {
  attr: 'return_trip.space_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type TripsAddTripLegPartialUpdateReturnTripMustProvideWheelchairErrorComponent =
  {
    attr: 'return_trip.must_provide_wheelchair';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripServiceTypeErrorComponent = {
  attr: 'return_trip.service_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type TripsAddTripLegPartialUpdateReturnTripDispatcherNotesErrorComponent =
  {
    attr: 'return_trip.dispatcher_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripBillingNotesErrorComponent = {
  attr: 'return_trip.billing_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsAddTripLegPartialUpdateReturnTripDriverEnteredNotesErrorComponent =
  {
    attr: 'return_trip.driver_entered_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripIsOxygenRequiredErrorComponent =
  {
    attr: 'return_trip.is_oxygen_required';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripOxygenLitersPerMinErrorComponent =
  {
    attr: 'return_trip.oxygen_liters_per_min';
    code:
      | 'invalid'
      | 'max_decimal_places'
      | 'max_digits'
      | 'max_string_length'
      | 'max_whole_digits'
      | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripNumAttendantsNeededErrorComponent =
  {
    attr: 'return_trip.num_attendants_needed';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripNumAccompanyingPassengersErrorComponent =
  {
    attr: 'return_trip.num_accompanying_passengers';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripOneSchemaTemplateIdErrorComponent =
  {
    attr: 'return_trip.one_schema_template_id';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripOneSchemaTemplateMultiIdErrorComponent =
  {
    attr: 'return_trip.one_schema_template_multi_id';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripCorrelationIdErrorComponent =
  {
    attr: 'return_trip.correlation_id';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripBookedByNameErrorComponent = {
  attr: 'return_trip.booked_by_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsAddTripLegPartialUpdateReturnTripBookedByPhoneNumberErrorComponent =
  {
    attr: 'return_trip.booked_by_phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripBookedByPhoneExtensionErrorComponent =
  {
    attr: 'return_trip.booked_by_phone_extension';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripLoadTimeSecondsErrorComponent =
  {
    attr: 'return_trip.load_time_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripUnloadTimeSecondsErrorComponent =
  {
    attr: 'return_trip.unload_time_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripPickupWaitTimeSecondsErrorComponent =
  {
    attr: 'return_trip.pickup_wait_time_seconds';
    code: 'invalid' | 'max_string_length' | 'min_value';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripTagIdsErrorComponent = {
  attr: 'return_trip.tag_ids';
  code: 'not_a_list';
  detail: string;
};
export type TripsAddTripLegPartialUpdateReturnTripTagIdsIndexErrorComponent = {
  attr: 'return_trip.tag_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsAddTripLegPartialUpdateReturnTripTagsIndexTagNameErrorComponent =
  {
    attr: 'return_trip.tags.INDEX.tag_name';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripTagsIndexColorHexErrorComponent =
  {
    attr: 'return_trip.tags.INDEX.color_hex';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripAddedTagsErrorComponent = {
  attr: 'return_trip.added_tags';
  code: 'not_a_list';
  detail: string;
};
export type TripsAddTripLegPartialUpdateReturnTripAddedTagsIndexErrorComponent =
  {
    attr: 'return_trip.added_tags.INDEX';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripIsWaitAndReturnOutboundErrorComponent =
  {
    attr: 'return_trip.is_wait_and_return_outbound';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripIsWaitAndReturnInboundErrorComponent =
  {
    attr: 'return_trip.is_wait_and_return_inbound';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripAuthorizationIdErrorComponent =
  {
    attr: 'return_trip.authorization_id';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripInsurancePolicyIdErrorComponent =
  {
    attr: 'return_trip.insurance_policy_id';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripIsPriceLockedErrorComponent =
  {
    attr: 'return_trip.is_price_locked';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripLinkToPayerErrorComponent = {
  attr: 'return_trip.link_to_payer';
  code: 'invalid_choice';
  detail: string;
};
export type TripsAddTripLegPartialUpdateReturnTripConfirmationCodeErrorComponent =
  {
    attr: 'return_trip.confirmation_code';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripIntermediaryErrorComponent = {
  attr: 'return_trip.intermediary';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsAddTripLegPartialUpdateReturnTripHasInfectiousDiseaseErrorComponent =
  {
    attr: 'return_trip.has_infectious_disease';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripSeatEquipmentErrorComponent =
  {
    attr: 'return_trip.seat_equipment';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripShouldAvoidMultiloadErrorComponent =
  {
    attr: 'return_trip.should_avoid_multiload';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateReturnTripImportBatchIdErrorComponent =
  {
    attr: 'return_trip.import_batch_id';
    code: 'invalid' | 'max_string_length';
    detail: string;
  };
export type TripsAddTripLegPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & TripsAddTripLegPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'original_trip.non_field_errors';
    } & TripsAddTripLegPartialUpdateOriginalTripNonFieldErrorsErrorComponent)
  | ({
      attr: 'original_trip.assignment.start';
    } & TripsAddTripLegPartialUpdateOriginalTripAssignmentStartErrorComponent)
  | ({
      attr: 'original_trip.assignment.end';
    } & TripsAddTripLegPartialUpdateOriginalTripAssignmentEndErrorComponent)
  | ({
      attr: 'original_trip.passenger.non_field_errors';
    } & TripsAddTripLegPartialUpdateOriginalTripPassengerNonFieldErrorsErrorComponent)
  | ({
      attr: 'original_trip.passenger.id';
    } & TripsAddTripLegPartialUpdateOriginalTripPassengerIdErrorComponent)
  | ({
      attr: 'original_trip.passenger.first_name';
    } & TripsAddTripLegPartialUpdateOriginalTripPassengerFirstNameErrorComponent)
  | ({
      attr: 'original_trip.passenger.last_name';
    } & TripsAddTripLegPartialUpdateOriginalTripPassengerLastNameErrorComponent)
  | ({
      attr: 'original_trip.passenger.preferred_name';
    } & TripsAddTripLegPartialUpdateOriginalTripPassengerPreferredNameErrorComponent)
  | ({
      attr: 'original_trip.passenger.pronoun';
    } & TripsAddTripLegPartialUpdateOriginalTripPassengerPronounErrorComponent)
  | ({
      attr: 'original_trip.passenger.gender';
    } & TripsAddTripLegPartialUpdateOriginalTripPassengerGenderErrorComponent)
  | ({
      attr: 'original_trip.passenger.dob';
    } & TripsAddTripLegPartialUpdateOriginalTripPassengerDobErrorComponent)
  | ({
      attr: 'original_trip.passenger.weight';
    } & TripsAddTripLegPartialUpdateOriginalTripPassengerWeightErrorComponent)
  | ({
      attr: 'original_trip.passenger.needs_bariatric_transport';
    } & TripsAddTripLegPartialUpdateOriginalTripPassengerNeedsBariatricTransportErrorComponent)
  | ({
      attr: 'original_trip.passenger.phone_number';
    } & TripsAddTripLegPartialUpdateOriginalTripPassengerPhoneNumberErrorComponent)
  | ({
      attr: 'original_trip.passenger.email';
    } & TripsAddTripLegPartialUpdateOriginalTripPassengerEmailErrorComponent)
  | ({
      attr: 'original_trip.passenger.notes';
    } & TripsAddTripLegPartialUpdateOriginalTripPassengerNotesErrorComponent)
  | ({
      attr: 'original_trip.passenger.dispatcher_notes';
    } & TripsAddTripLegPartialUpdateOriginalTripPassengerDispatcherNotesErrorComponent)
  | ({
      attr: 'original_trip.passenger.allow_sms_message';
    } & TripsAddTripLegPartialUpdateOriginalTripPassengerAllowSmsMessageErrorComponent)
  | ({
      attr: 'original_trip.payer.payer';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerPayerErrorComponent)
  | ({
      attr: 'original_trip.payer.display_name';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerDisplayNameErrorComponent)
  | ({
      attr: 'original_trip.payer.alternate_name';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerAlternateNameErrorComponent)
  | ({
      attr: 'original_trip.payer.type';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerTypeErrorComponent)
  | ({
      attr: 'original_trip.payer.is_active';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerIsActiveErrorComponent)
  | ({
      attr: 'original_trip.payer.is_self_pay';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerIsSelfPayErrorComponent)
  | ({
      attr: 'original_trip.payer.can_multiload';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerCanMultiloadErrorComponent)
  | ({
      attr: 'original_trip.payer.external_id';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerExternalIdErrorComponent)
  | ({
      attr: 'original_trip.payer.website';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerWebsiteErrorComponent)
  | ({
      attr: 'original_trip.payer.ein';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerEinErrorComponent)
  | ({
      attr: 'original_trip.payer.email';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerEmailErrorComponent)
  | ({
      attr: 'original_trip.payer.phone_number';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerPhoneNumberErrorComponent)
  | ({
      attr: 'original_trip.payer.billing_name';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerBillingNameErrorComponent)
  | ({
      attr: 'original_trip.payer.billing_phone_number';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerBillingPhoneNumberErrorComponent)
  | ({
      attr: 'original_trip.payer.billing_email';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerBillingEmailErrorComponent)
  | ({
      attr: 'original_trip.payer.dispatcher_notes';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerDispatcherNotesErrorComponent)
  | ({
      attr: 'original_trip.payer.admin_notes';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerAdminNotesErrorComponent)
  | ({
      attr: 'original_trip.payer.deleted_at';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerDeletedAtErrorComponent)
  | ({
      attr: 'original_trip.payer.billing_address.non_field_errors';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerBillingAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'original_trip.payer.billing_address.location.non_field_errors';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerBillingAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'original_trip.payer.billing_address.location.place_id';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerBillingAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'original_trip.payer.billing_address.label';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerBillingAddressLabelErrorComponent)
  | ({
      attr: 'original_trip.payer.billing_address.label2';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerBillingAddressLabel2ErrorComponent)
  | ({
      attr: 'original_trip.payer.billing_address.address_notes';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerBillingAddressAddressNotesErrorComponent)
  | ({
      attr: 'original_trip.payer.billing_address.address_type';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerBillingAddressAddressTypeErrorComponent)
  | ({
      attr: 'original_trip.payer.default_trip_address.non_field_errors';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerDefaultTripAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'original_trip.payer.default_trip_address.location.non_field_errors';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerDefaultTripAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'original_trip.payer.default_trip_address.location.place_id';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerDefaultTripAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'original_trip.payer.default_trip_address.label';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerDefaultTripAddressLabelErrorComponent)
  | ({
      attr: 'original_trip.payer.default_trip_address.label2';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerDefaultTripAddressLabel2ErrorComponent)
  | ({
      attr: 'original_trip.payer.default_trip_address.address_notes';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerDefaultTripAddressAddressNotesErrorComponent)
  | ({
      attr: 'original_trip.payer.default_trip_address.address_type';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerDefaultTripAddressAddressTypeErrorComponent)
  | ({
      attr: 'original_trip.payer.multiloading_partners.non_field_errors';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerMultiloadingPartnersNonFieldErrorsErrorComponent)
  | ({
      attr: 'original_trip.payer.multiloading_partners.INDEX';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerMultiloadingPartnersIndexErrorComponent)
  | ({
      attr: 'original_trip.payer_id';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerIdErrorComponent)
  | ({
      attr: 'original_trip.payer_passenger_external_id';
    } & TripsAddTripLegPartialUpdateOriginalTripPayerPassengerExternalIdErrorComponent)
  | ({
      attr: 'original_trip.external_trip_id';
    } & TripsAddTripLegPartialUpdateOriginalTripExternalTripIdErrorComponent)
  | ({
      attr: 'original_trip.input_price_cents';
    } & TripsAddTripLegPartialUpdateOriginalTripInputPriceCentsErrorComponent)
  | ({
      attr: 'original_trip.payment_method';
    } & TripsAddTripLegPartialUpdateOriginalTripPaymentMethodErrorComponent)
  | ({
      attr: 'original_trip.scheduled_pickup_at';
    } & TripsAddTripLegPartialUpdateOriginalTripScheduledPickupAtErrorComponent)
  | ({
      attr: 'original_trip.pickup.non_field_errors';
    } & TripsAddTripLegPartialUpdateOriginalTripPickupNonFieldErrorsErrorComponent)
  | ({
      attr: 'original_trip.pickup.address_details';
    } & TripsAddTripLegPartialUpdateOriginalTripPickupAddressDetailsErrorComponent)
  | ({
      attr: 'original_trip.pickup.num_stairs';
    } & TripsAddTripLegPartialUpdateOriginalTripPickupNumStairsErrorComponent)
  | ({
      attr: 'original_trip.pickup.stair_equipment';
    } & TripsAddTripLegPartialUpdateOriginalTripPickupStairEquipmentErrorComponent)
  | ({
      attr: 'original_trip.pickup.contact_name';
    } & TripsAddTripLegPartialUpdateOriginalTripPickupContactNameErrorComponent)
  | ({
      attr: 'original_trip.pickup.contact_phone_number';
    } & TripsAddTripLegPartialUpdateOriginalTripPickupContactPhoneNumberErrorComponent)
  | ({
      attr: 'original_trip.pickup.driver_notes';
    } & TripsAddTripLegPartialUpdateOriginalTripPickupDriverNotesErrorComponent)
  | ({
      attr: 'original_trip.pickup.place_id';
    } & TripsAddTripLegPartialUpdateOriginalTripPickupPlaceIdErrorComponent)
  | ({
      attr: 'original_trip.dropoff.non_field_errors';
    } & TripsAddTripLegPartialUpdateOriginalTripDropoffNonFieldErrorsErrorComponent)
  | ({
      attr: 'original_trip.dropoff.address_details';
    } & TripsAddTripLegPartialUpdateOriginalTripDropoffAddressDetailsErrorComponent)
  | ({
      attr: 'original_trip.dropoff.num_stairs';
    } & TripsAddTripLegPartialUpdateOriginalTripDropoffNumStairsErrorComponent)
  | ({
      attr: 'original_trip.dropoff.stair_equipment';
    } & TripsAddTripLegPartialUpdateOriginalTripDropoffStairEquipmentErrorComponent)
  | ({
      attr: 'original_trip.dropoff.contact_name';
    } & TripsAddTripLegPartialUpdateOriginalTripDropoffContactNameErrorComponent)
  | ({
      attr: 'original_trip.dropoff.contact_phone_number';
    } & TripsAddTripLegPartialUpdateOriginalTripDropoffContactPhoneNumberErrorComponent)
  | ({
      attr: 'original_trip.dropoff.driver_notes';
    } & TripsAddTripLegPartialUpdateOriginalTripDropoffDriverNotesErrorComponent)
  | ({
      attr: 'original_trip.dropoff.place_id';
    } & TripsAddTripLegPartialUpdateOriginalTripDropoffPlaceIdErrorComponent)
  | ({
      attr: 'original_trip.appointment_at';
    } & TripsAddTripLegPartialUpdateOriginalTripAppointmentAtErrorComponent)
  | ({
      attr: 'original_trip.is_will_call';
    } & TripsAddTripLegPartialUpdateOriginalTripIsWillCallErrorComponent)
  | ({
      attr: 'original_trip.space_type';
    } & TripsAddTripLegPartialUpdateOriginalTripSpaceTypeErrorComponent)
  | ({
      attr: 'original_trip.must_provide_wheelchair';
    } & TripsAddTripLegPartialUpdateOriginalTripMustProvideWheelchairErrorComponent)
  | ({
      attr: 'original_trip.service_type';
    } & TripsAddTripLegPartialUpdateOriginalTripServiceTypeErrorComponent)
  | ({
      attr: 'original_trip.dispatcher_notes';
    } & TripsAddTripLegPartialUpdateOriginalTripDispatcherNotesErrorComponent)
  | ({
      attr: 'original_trip.billing_notes';
    } & TripsAddTripLegPartialUpdateOriginalTripBillingNotesErrorComponent)
  | ({
      attr: 'original_trip.driver_entered_notes';
    } & TripsAddTripLegPartialUpdateOriginalTripDriverEnteredNotesErrorComponent)
  | ({
      attr: 'original_trip.is_oxygen_required';
    } & TripsAddTripLegPartialUpdateOriginalTripIsOxygenRequiredErrorComponent)
  | ({
      attr: 'original_trip.oxygen_liters_per_min';
    } & TripsAddTripLegPartialUpdateOriginalTripOxygenLitersPerMinErrorComponent)
  | ({
      attr: 'original_trip.num_attendants_needed';
    } & TripsAddTripLegPartialUpdateOriginalTripNumAttendantsNeededErrorComponent)
  | ({
      attr: 'original_trip.num_accompanying_passengers';
    } & TripsAddTripLegPartialUpdateOriginalTripNumAccompanyingPassengersErrorComponent)
  | ({
      attr: 'original_trip.one_schema_template_id';
    } & TripsAddTripLegPartialUpdateOriginalTripOneSchemaTemplateIdErrorComponent)
  | ({
      attr: 'original_trip.one_schema_template_multi_id';
    } & TripsAddTripLegPartialUpdateOriginalTripOneSchemaTemplateMultiIdErrorComponent)
  | ({
      attr: 'original_trip.correlation_id';
    } & TripsAddTripLegPartialUpdateOriginalTripCorrelationIdErrorComponent)
  | ({
      attr: 'original_trip.booked_by_name';
    } & TripsAddTripLegPartialUpdateOriginalTripBookedByNameErrorComponent)
  | ({
      attr: 'original_trip.booked_by_phone_number';
    } & TripsAddTripLegPartialUpdateOriginalTripBookedByPhoneNumberErrorComponent)
  | ({
      attr: 'original_trip.booked_by_phone_extension';
    } & TripsAddTripLegPartialUpdateOriginalTripBookedByPhoneExtensionErrorComponent)
  | ({
      attr: 'original_trip.load_time_seconds';
    } & TripsAddTripLegPartialUpdateOriginalTripLoadTimeSecondsErrorComponent)
  | ({
      attr: 'original_trip.unload_time_seconds';
    } & TripsAddTripLegPartialUpdateOriginalTripUnloadTimeSecondsErrorComponent)
  | ({
      attr: 'original_trip.pickup_wait_time_seconds';
    } & TripsAddTripLegPartialUpdateOriginalTripPickupWaitTimeSecondsErrorComponent)
  | ({
      attr: 'original_trip.tag_ids';
    } & TripsAddTripLegPartialUpdateOriginalTripTagIdsErrorComponent)
  | ({
      attr: 'original_trip.tag_ids.INDEX';
    } & TripsAddTripLegPartialUpdateOriginalTripTagIdsIndexErrorComponent)
  | ({
      attr: 'original_trip.tags.INDEX.tag_name';
    } & TripsAddTripLegPartialUpdateOriginalTripTagsIndexTagNameErrorComponent)
  | ({
      attr: 'original_trip.tags.INDEX.color_hex';
    } & TripsAddTripLegPartialUpdateOriginalTripTagsIndexColorHexErrorComponent)
  | ({
      attr: 'original_trip.added_tags';
    } & TripsAddTripLegPartialUpdateOriginalTripAddedTagsErrorComponent)
  | ({
      attr: 'original_trip.added_tags.INDEX';
    } & TripsAddTripLegPartialUpdateOriginalTripAddedTagsIndexErrorComponent)
  | ({
      attr: 'original_trip.is_wait_and_return_outbound';
    } & TripsAddTripLegPartialUpdateOriginalTripIsWaitAndReturnOutboundErrorComponent)
  | ({
      attr: 'original_trip.is_wait_and_return_inbound';
    } & TripsAddTripLegPartialUpdateOriginalTripIsWaitAndReturnInboundErrorComponent)
  | ({
      attr: 'original_trip.authorization_id';
    } & TripsAddTripLegPartialUpdateOriginalTripAuthorizationIdErrorComponent)
  | ({
      attr: 'original_trip.insurance_policy_id';
    } & TripsAddTripLegPartialUpdateOriginalTripInsurancePolicyIdErrorComponent)
  | ({
      attr: 'original_trip.is_price_locked';
    } & TripsAddTripLegPartialUpdateOriginalTripIsPriceLockedErrorComponent)
  | ({
      attr: 'original_trip.link_to_payer';
    } & TripsAddTripLegPartialUpdateOriginalTripLinkToPayerErrorComponent)
  | ({
      attr: 'original_trip.confirmation_code';
    } & TripsAddTripLegPartialUpdateOriginalTripConfirmationCodeErrorComponent)
  | ({
      attr: 'original_trip.intermediary';
    } & TripsAddTripLegPartialUpdateOriginalTripIntermediaryErrorComponent)
  | ({
      attr: 'original_trip.has_infectious_disease';
    } & TripsAddTripLegPartialUpdateOriginalTripHasInfectiousDiseaseErrorComponent)
  | ({
      attr: 'original_trip.seat_equipment';
    } & TripsAddTripLegPartialUpdateOriginalTripSeatEquipmentErrorComponent)
  | ({
      attr: 'original_trip.should_avoid_multiload';
    } & TripsAddTripLegPartialUpdateOriginalTripShouldAvoidMultiloadErrorComponent)
  | ({
      attr: 'original_trip.import_batch_id';
    } & TripsAddTripLegPartialUpdateOriginalTripImportBatchIdErrorComponent)
  | ({
      attr: 'return_trip.non_field_errors';
    } & TripsAddTripLegPartialUpdateReturnTripNonFieldErrorsErrorComponent)
  | ({
      attr: 'return_trip.assignment.start';
    } & TripsAddTripLegPartialUpdateReturnTripAssignmentStartErrorComponent)
  | ({
      attr: 'return_trip.assignment.end';
    } & TripsAddTripLegPartialUpdateReturnTripAssignmentEndErrorComponent)
  | ({
      attr: 'return_trip.passenger.non_field_errors';
    } & TripsAddTripLegPartialUpdateReturnTripPassengerNonFieldErrorsErrorComponent)
  | ({
      attr: 'return_trip.passenger.id';
    } & TripsAddTripLegPartialUpdateReturnTripPassengerIdErrorComponent)
  | ({
      attr: 'return_trip.passenger.first_name';
    } & TripsAddTripLegPartialUpdateReturnTripPassengerFirstNameErrorComponent)
  | ({
      attr: 'return_trip.passenger.last_name';
    } & TripsAddTripLegPartialUpdateReturnTripPassengerLastNameErrorComponent)
  | ({
      attr: 'return_trip.passenger.preferred_name';
    } & TripsAddTripLegPartialUpdateReturnTripPassengerPreferredNameErrorComponent)
  | ({
      attr: 'return_trip.passenger.pronoun';
    } & TripsAddTripLegPartialUpdateReturnTripPassengerPronounErrorComponent)
  | ({
      attr: 'return_trip.passenger.gender';
    } & TripsAddTripLegPartialUpdateReturnTripPassengerGenderErrorComponent)
  | ({
      attr: 'return_trip.passenger.dob';
    } & TripsAddTripLegPartialUpdateReturnTripPassengerDobErrorComponent)
  | ({
      attr: 'return_trip.passenger.weight';
    } & TripsAddTripLegPartialUpdateReturnTripPassengerWeightErrorComponent)
  | ({
      attr: 'return_trip.passenger.needs_bariatric_transport';
    } & TripsAddTripLegPartialUpdateReturnTripPassengerNeedsBariatricTransportErrorComponent)
  | ({
      attr: 'return_trip.passenger.phone_number';
    } & TripsAddTripLegPartialUpdateReturnTripPassengerPhoneNumberErrorComponent)
  | ({
      attr: 'return_trip.passenger.email';
    } & TripsAddTripLegPartialUpdateReturnTripPassengerEmailErrorComponent)
  | ({
      attr: 'return_trip.passenger.notes';
    } & TripsAddTripLegPartialUpdateReturnTripPassengerNotesErrorComponent)
  | ({
      attr: 'return_trip.passenger.dispatcher_notes';
    } & TripsAddTripLegPartialUpdateReturnTripPassengerDispatcherNotesErrorComponent)
  | ({
      attr: 'return_trip.passenger.allow_sms_message';
    } & TripsAddTripLegPartialUpdateReturnTripPassengerAllowSmsMessageErrorComponent)
  | ({
      attr: 'return_trip.payer.payer';
    } & TripsAddTripLegPartialUpdateReturnTripPayerPayerErrorComponent)
  | ({
      attr: 'return_trip.payer.display_name';
    } & TripsAddTripLegPartialUpdateReturnTripPayerDisplayNameErrorComponent)
  | ({
      attr: 'return_trip.payer.alternate_name';
    } & TripsAddTripLegPartialUpdateReturnTripPayerAlternateNameErrorComponent)
  | ({
      attr: 'return_trip.payer.type';
    } & TripsAddTripLegPartialUpdateReturnTripPayerTypeErrorComponent)
  | ({
      attr: 'return_trip.payer.is_active';
    } & TripsAddTripLegPartialUpdateReturnTripPayerIsActiveErrorComponent)
  | ({
      attr: 'return_trip.payer.is_self_pay';
    } & TripsAddTripLegPartialUpdateReturnTripPayerIsSelfPayErrorComponent)
  | ({
      attr: 'return_trip.payer.can_multiload';
    } & TripsAddTripLegPartialUpdateReturnTripPayerCanMultiloadErrorComponent)
  | ({
      attr: 'return_trip.payer.external_id';
    } & TripsAddTripLegPartialUpdateReturnTripPayerExternalIdErrorComponent)
  | ({
      attr: 'return_trip.payer.website';
    } & TripsAddTripLegPartialUpdateReturnTripPayerWebsiteErrorComponent)
  | ({
      attr: 'return_trip.payer.ein';
    } & TripsAddTripLegPartialUpdateReturnTripPayerEinErrorComponent)
  | ({
      attr: 'return_trip.payer.email';
    } & TripsAddTripLegPartialUpdateReturnTripPayerEmailErrorComponent)
  | ({
      attr: 'return_trip.payer.phone_number';
    } & TripsAddTripLegPartialUpdateReturnTripPayerPhoneNumberErrorComponent)
  | ({
      attr: 'return_trip.payer.billing_name';
    } & TripsAddTripLegPartialUpdateReturnTripPayerBillingNameErrorComponent)
  | ({
      attr: 'return_trip.payer.billing_phone_number';
    } & TripsAddTripLegPartialUpdateReturnTripPayerBillingPhoneNumberErrorComponent)
  | ({
      attr: 'return_trip.payer.billing_email';
    } & TripsAddTripLegPartialUpdateReturnTripPayerBillingEmailErrorComponent)
  | ({
      attr: 'return_trip.payer.dispatcher_notes';
    } & TripsAddTripLegPartialUpdateReturnTripPayerDispatcherNotesErrorComponent)
  | ({
      attr: 'return_trip.payer.admin_notes';
    } & TripsAddTripLegPartialUpdateReturnTripPayerAdminNotesErrorComponent)
  | ({
      attr: 'return_trip.payer.deleted_at';
    } & TripsAddTripLegPartialUpdateReturnTripPayerDeletedAtErrorComponent)
  | ({
      attr: 'return_trip.payer.billing_address.non_field_errors';
    } & TripsAddTripLegPartialUpdateReturnTripPayerBillingAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'return_trip.payer.billing_address.location.non_field_errors';
    } & TripsAddTripLegPartialUpdateReturnTripPayerBillingAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'return_trip.payer.billing_address.location.place_id';
    } & TripsAddTripLegPartialUpdateReturnTripPayerBillingAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'return_trip.payer.billing_address.label';
    } & TripsAddTripLegPartialUpdateReturnTripPayerBillingAddressLabelErrorComponent)
  | ({
      attr: 'return_trip.payer.billing_address.label2';
    } & TripsAddTripLegPartialUpdateReturnTripPayerBillingAddressLabel2ErrorComponent)
  | ({
      attr: 'return_trip.payer.billing_address.address_notes';
    } & TripsAddTripLegPartialUpdateReturnTripPayerBillingAddressAddressNotesErrorComponent)
  | ({
      attr: 'return_trip.payer.billing_address.address_type';
    } & TripsAddTripLegPartialUpdateReturnTripPayerBillingAddressAddressTypeErrorComponent)
  | ({
      attr: 'return_trip.payer.default_trip_address.non_field_errors';
    } & TripsAddTripLegPartialUpdateReturnTripPayerDefaultTripAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'return_trip.payer.default_trip_address.location.non_field_errors';
    } & TripsAddTripLegPartialUpdateReturnTripPayerDefaultTripAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'return_trip.payer.default_trip_address.location.place_id';
    } & TripsAddTripLegPartialUpdateReturnTripPayerDefaultTripAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'return_trip.payer.default_trip_address.label';
    } & TripsAddTripLegPartialUpdateReturnTripPayerDefaultTripAddressLabelErrorComponent)
  | ({
      attr: 'return_trip.payer.default_trip_address.label2';
    } & TripsAddTripLegPartialUpdateReturnTripPayerDefaultTripAddressLabel2ErrorComponent)
  | ({
      attr: 'return_trip.payer.default_trip_address.address_notes';
    } & TripsAddTripLegPartialUpdateReturnTripPayerDefaultTripAddressAddressNotesErrorComponent)
  | ({
      attr: 'return_trip.payer.default_trip_address.address_type';
    } & TripsAddTripLegPartialUpdateReturnTripPayerDefaultTripAddressAddressTypeErrorComponent)
  | ({
      attr: 'return_trip.payer.multiloading_partners.non_field_errors';
    } & TripsAddTripLegPartialUpdateReturnTripPayerMultiloadingPartnersNonFieldErrorsErrorComponent)
  | ({
      attr: 'return_trip.payer.multiloading_partners.INDEX';
    } & TripsAddTripLegPartialUpdateReturnTripPayerMultiloadingPartnersIndexErrorComponent)
  | ({
      attr: 'return_trip.payer_id';
    } & TripsAddTripLegPartialUpdateReturnTripPayerIdErrorComponent)
  | ({
      attr: 'return_trip.payer_passenger_external_id';
    } & TripsAddTripLegPartialUpdateReturnTripPayerPassengerExternalIdErrorComponent)
  | ({
      attr: 'return_trip.external_trip_id';
    } & TripsAddTripLegPartialUpdateReturnTripExternalTripIdErrorComponent)
  | ({
      attr: 'return_trip.input_price_cents';
    } & TripsAddTripLegPartialUpdateReturnTripInputPriceCentsErrorComponent)
  | ({
      attr: 'return_trip.payment_method';
    } & TripsAddTripLegPartialUpdateReturnTripPaymentMethodErrorComponent)
  | ({
      attr: 'return_trip.scheduled_pickup_at';
    } & TripsAddTripLegPartialUpdateReturnTripScheduledPickupAtErrorComponent)
  | ({
      attr: 'return_trip.pickup.non_field_errors';
    } & TripsAddTripLegPartialUpdateReturnTripPickupNonFieldErrorsErrorComponent)
  | ({
      attr: 'return_trip.pickup.address_details';
    } & TripsAddTripLegPartialUpdateReturnTripPickupAddressDetailsErrorComponent)
  | ({
      attr: 'return_trip.pickup.num_stairs';
    } & TripsAddTripLegPartialUpdateReturnTripPickupNumStairsErrorComponent)
  | ({
      attr: 'return_trip.pickup.stair_equipment';
    } & TripsAddTripLegPartialUpdateReturnTripPickupStairEquipmentErrorComponent)
  | ({
      attr: 'return_trip.pickup.contact_name';
    } & TripsAddTripLegPartialUpdateReturnTripPickupContactNameErrorComponent)
  | ({
      attr: 'return_trip.pickup.contact_phone_number';
    } & TripsAddTripLegPartialUpdateReturnTripPickupContactPhoneNumberErrorComponent)
  | ({
      attr: 'return_trip.pickup.driver_notes';
    } & TripsAddTripLegPartialUpdateReturnTripPickupDriverNotesErrorComponent)
  | ({
      attr: 'return_trip.pickup.place_id';
    } & TripsAddTripLegPartialUpdateReturnTripPickupPlaceIdErrorComponent)
  | ({
      attr: 'return_trip.dropoff.non_field_errors';
    } & TripsAddTripLegPartialUpdateReturnTripDropoffNonFieldErrorsErrorComponent)
  | ({
      attr: 'return_trip.dropoff.address_details';
    } & TripsAddTripLegPartialUpdateReturnTripDropoffAddressDetailsErrorComponent)
  | ({
      attr: 'return_trip.dropoff.num_stairs';
    } & TripsAddTripLegPartialUpdateReturnTripDropoffNumStairsErrorComponent)
  | ({
      attr: 'return_trip.dropoff.stair_equipment';
    } & TripsAddTripLegPartialUpdateReturnTripDropoffStairEquipmentErrorComponent)
  | ({
      attr: 'return_trip.dropoff.contact_name';
    } & TripsAddTripLegPartialUpdateReturnTripDropoffContactNameErrorComponent)
  | ({
      attr: 'return_trip.dropoff.contact_phone_number';
    } & TripsAddTripLegPartialUpdateReturnTripDropoffContactPhoneNumberErrorComponent)
  | ({
      attr: 'return_trip.dropoff.driver_notes';
    } & TripsAddTripLegPartialUpdateReturnTripDropoffDriverNotesErrorComponent)
  | ({
      attr: 'return_trip.dropoff.place_id';
    } & TripsAddTripLegPartialUpdateReturnTripDropoffPlaceIdErrorComponent)
  | ({
      attr: 'return_trip.appointment_at';
    } & TripsAddTripLegPartialUpdateReturnTripAppointmentAtErrorComponent)
  | ({
      attr: 'return_trip.is_will_call';
    } & TripsAddTripLegPartialUpdateReturnTripIsWillCallErrorComponent)
  | ({
      attr: 'return_trip.space_type';
    } & TripsAddTripLegPartialUpdateReturnTripSpaceTypeErrorComponent)
  | ({
      attr: 'return_trip.must_provide_wheelchair';
    } & TripsAddTripLegPartialUpdateReturnTripMustProvideWheelchairErrorComponent)
  | ({
      attr: 'return_trip.service_type';
    } & TripsAddTripLegPartialUpdateReturnTripServiceTypeErrorComponent)
  | ({
      attr: 'return_trip.dispatcher_notes';
    } & TripsAddTripLegPartialUpdateReturnTripDispatcherNotesErrorComponent)
  | ({
      attr: 'return_trip.billing_notes';
    } & TripsAddTripLegPartialUpdateReturnTripBillingNotesErrorComponent)
  | ({
      attr: 'return_trip.driver_entered_notes';
    } & TripsAddTripLegPartialUpdateReturnTripDriverEnteredNotesErrorComponent)
  | ({
      attr: 'return_trip.is_oxygen_required';
    } & TripsAddTripLegPartialUpdateReturnTripIsOxygenRequiredErrorComponent)
  | ({
      attr: 'return_trip.oxygen_liters_per_min';
    } & TripsAddTripLegPartialUpdateReturnTripOxygenLitersPerMinErrorComponent)
  | ({
      attr: 'return_trip.num_attendants_needed';
    } & TripsAddTripLegPartialUpdateReturnTripNumAttendantsNeededErrorComponent)
  | ({
      attr: 'return_trip.num_accompanying_passengers';
    } & TripsAddTripLegPartialUpdateReturnTripNumAccompanyingPassengersErrorComponent)
  | ({
      attr: 'return_trip.one_schema_template_id';
    } & TripsAddTripLegPartialUpdateReturnTripOneSchemaTemplateIdErrorComponent)
  | ({
      attr: 'return_trip.one_schema_template_multi_id';
    } & TripsAddTripLegPartialUpdateReturnTripOneSchemaTemplateMultiIdErrorComponent)
  | ({
      attr: 'return_trip.correlation_id';
    } & TripsAddTripLegPartialUpdateReturnTripCorrelationIdErrorComponent)
  | ({
      attr: 'return_trip.booked_by_name';
    } & TripsAddTripLegPartialUpdateReturnTripBookedByNameErrorComponent)
  | ({
      attr: 'return_trip.booked_by_phone_number';
    } & TripsAddTripLegPartialUpdateReturnTripBookedByPhoneNumberErrorComponent)
  | ({
      attr: 'return_trip.booked_by_phone_extension';
    } & TripsAddTripLegPartialUpdateReturnTripBookedByPhoneExtensionErrorComponent)
  | ({
      attr: 'return_trip.load_time_seconds';
    } & TripsAddTripLegPartialUpdateReturnTripLoadTimeSecondsErrorComponent)
  | ({
      attr: 'return_trip.unload_time_seconds';
    } & TripsAddTripLegPartialUpdateReturnTripUnloadTimeSecondsErrorComponent)
  | ({
      attr: 'return_trip.pickup_wait_time_seconds';
    } & TripsAddTripLegPartialUpdateReturnTripPickupWaitTimeSecondsErrorComponent)
  | ({
      attr: 'return_trip.tag_ids';
    } & TripsAddTripLegPartialUpdateReturnTripTagIdsErrorComponent)
  | ({
      attr: 'return_trip.tag_ids.INDEX';
    } & TripsAddTripLegPartialUpdateReturnTripTagIdsIndexErrorComponent)
  | ({
      attr: 'return_trip.tags.INDEX.tag_name';
    } & TripsAddTripLegPartialUpdateReturnTripTagsIndexTagNameErrorComponent)
  | ({
      attr: 'return_trip.tags.INDEX.color_hex';
    } & TripsAddTripLegPartialUpdateReturnTripTagsIndexColorHexErrorComponent)
  | ({
      attr: 'return_trip.added_tags';
    } & TripsAddTripLegPartialUpdateReturnTripAddedTagsErrorComponent)
  | ({
      attr: 'return_trip.added_tags.INDEX';
    } & TripsAddTripLegPartialUpdateReturnTripAddedTagsIndexErrorComponent)
  | ({
      attr: 'return_trip.is_wait_and_return_outbound';
    } & TripsAddTripLegPartialUpdateReturnTripIsWaitAndReturnOutboundErrorComponent)
  | ({
      attr: 'return_trip.is_wait_and_return_inbound';
    } & TripsAddTripLegPartialUpdateReturnTripIsWaitAndReturnInboundErrorComponent)
  | ({
      attr: 'return_trip.authorization_id';
    } & TripsAddTripLegPartialUpdateReturnTripAuthorizationIdErrorComponent)
  | ({
      attr: 'return_trip.insurance_policy_id';
    } & TripsAddTripLegPartialUpdateReturnTripInsurancePolicyIdErrorComponent)
  | ({
      attr: 'return_trip.is_price_locked';
    } & TripsAddTripLegPartialUpdateReturnTripIsPriceLockedErrorComponent)
  | ({
      attr: 'return_trip.link_to_payer';
    } & TripsAddTripLegPartialUpdateReturnTripLinkToPayerErrorComponent)
  | ({
      attr: 'return_trip.confirmation_code';
    } & TripsAddTripLegPartialUpdateReturnTripConfirmationCodeErrorComponent)
  | ({
      attr: 'return_trip.intermediary';
    } & TripsAddTripLegPartialUpdateReturnTripIntermediaryErrorComponent)
  | ({
      attr: 'return_trip.has_infectious_disease';
    } & TripsAddTripLegPartialUpdateReturnTripHasInfectiousDiseaseErrorComponent)
  | ({
      attr: 'return_trip.seat_equipment';
    } & TripsAddTripLegPartialUpdateReturnTripSeatEquipmentErrorComponent)
  | ({
      attr: 'return_trip.should_avoid_multiload';
    } & TripsAddTripLegPartialUpdateReturnTripShouldAvoidMultiloadErrorComponent)
  | ({
      attr: 'return_trip.import_batch_id';
    } & TripsAddTripLegPartialUpdateReturnTripImportBatchIdErrorComponent);
export type TripsAddTripLegPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsAddTripLegPartialUpdateError[];
};
export type TripsAddTripLegPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsAddTripLegPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedTripAddTripLeg = {
  original_trip?: PatchedTrip;
  return_trip?: Trip;
};
export type PatchedTripAddTripLegRead = {
  original_trip?: PatchedTripRead;
  return_trip?: TripRead;
};
export type PatchedTripAddTripLegWrite = {
  original_trip?: PatchedTripWrite;
  return_trip?: TripWrite;
};
export type TripAssign = {};
export type TripAssignWrite = {
  assignment_id: string;
};
export type TripsAssignPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsAssignPartialUpdateAssignmentIdErrorComponent = {
  attr: 'assignment_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsAssignPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & TripsAssignPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'assignment_id';
    } & TripsAssignPartialUpdateAssignmentIdErrorComponent);
export type TripsAssignPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsAssignPartialUpdateError[];
};
export type TripsAssignPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsAssignPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedTripAssign = {};
export type PatchedTripAssignWrite = {
  assignment_id?: string;
};
export type TripCancel = {};
export type TripCancelWrite = {
  concurrent_trips?: string[];
  canceled_reason: string;
  override?: boolean;
  /** Cancel code */
  canceled_reason_code?: number;
};
export type TripsCancelPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsCancelPartialUpdateConcurrentTripsErrorComponent = {
  attr: 'concurrent_trips';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type TripsCancelPartialUpdateConcurrentTripsIndexErrorComponent = {
  attr: 'concurrent_trips.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsCancelPartialUpdateCanceledReasonErrorComponent = {
  attr: 'canceled_reason';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsCancelPartialUpdateOverrideErrorComponent = {
  attr: 'override';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsCancelPartialUpdateCanceledReasonCodeErrorComponent = {
  attr: 'canceled_reason_code';
  code: 'invalid' | 'max_string_length' | 'null';
  detail: string;
};
export type TripsCancelPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & TripsCancelPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'concurrent_trips';
    } & TripsCancelPartialUpdateConcurrentTripsErrorComponent)
  | ({
      attr: 'concurrent_trips.INDEX';
    } & TripsCancelPartialUpdateConcurrentTripsIndexErrorComponent)
  | ({
      attr: 'canceled_reason';
    } & TripsCancelPartialUpdateCanceledReasonErrorComponent)
  | ({
      attr: 'override';
    } & TripsCancelPartialUpdateOverrideErrorComponent)
  | ({
      attr: 'canceled_reason_code';
    } & TripsCancelPartialUpdateCanceledReasonCodeErrorComponent);
export type TripsCancelPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsCancelPartialUpdateError[];
};
export type TripsCancelPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsCancelPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedTripCancel = {};
export type PatchedTripCancelWrite = {
  concurrent_trips?: string[];
  canceled_reason?: string;
  override?: boolean;
  /** Cancel code */
  canceled_reason_code?: number;
};
export type TripCancelReasonCode = {};
export type TripCancelReasonCodeRead = {
  /** Map of cancellation reasons as keys to their integer values */
  cancel_codes: {
    [key: string]: string;
  } | null;
};
export type TripsCancelCodesRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripCancelReasons = {};
export type TripCancelReason = {
  /** The reason for the cancellation to be shown to the user */
  label: string;
  /** The value of the reason for dropdowns, the cancel endpoint.  */
  value?: CanceledReasonEnum;
};
export type TripCancelReasonsRead = {
  /** A list of valid reasons for canceling the trip. */
  cancel_reasons: TripCancelReason[];
};
export type TripsCancelReasonsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripsCancellationRequestPartialUpdateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type TripsCancellationRequestPartialUpdateError = {
  attr: 'non_field_errors';
} & TripsCancellationRequestPartialUpdateNonFieldErrorsErrorComponent;
export type TripsCancellationRequestPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsCancellationRequestPartialUpdateError[];
};
export type TripsCancellationRequestPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsCancellationRequestPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TripComplete = {};
export type TripCompleteWrite = {
  concurrent_trips?: string[];
  override?: boolean;
};
export type TripsCompletePartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsCompletePartialUpdateConcurrentTripsErrorComponent = {
  attr: 'concurrent_trips';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type TripsCompletePartialUpdateConcurrentTripsIndexErrorComponent = {
  attr: 'concurrent_trips.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsCompletePartialUpdateOverrideErrorComponent = {
  attr: 'override';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsCompletePartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & TripsCompletePartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'concurrent_trips';
    } & TripsCompletePartialUpdateConcurrentTripsErrorComponent)
  | ({
      attr: 'concurrent_trips.INDEX';
    } & TripsCompletePartialUpdateConcurrentTripsIndexErrorComponent)
  | ({
      attr: 'override';
    } & TripsCompletePartialUpdateOverrideErrorComponent);
export type TripsCompletePartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsCompletePartialUpdateError[];
};
export type TripsCompletePartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsCompletePartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedTripComplete = {};
export type PatchedTripCompleteWrite = {
  concurrent_trips?: string[];
  override?: boolean;
};
export type PaginatedTripList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: Trip[];
};
export type PaginatedTripListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TripRead[];
};
export type PaginatedTripListWrite = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TripWrite[];
};
export type TripsCorrelatedListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripCreate = {};
export type TripCreateTripData = {};
export type TripCreateTripDataRead = {
  passenger_name: string | null;
  pickup: string | null;
  dropoff: string | null;
  /** The time of the passenger's appointment */
  appointment_at: string | null;
  /** The type of space in the vehicle this passenger will need */
  space_type: SpaceTypeEnum;
  service_type: ServiceTypeEnum;
  /** The manually inputted price of the trip */
  input_price_cents: number | null;
  scheduled_pickup_at: string | null;
  /** template used to create this trip, if uploaded via csv */
  one_schema_template_id: string | null;
  /** template used to create this trip, if backfilled via csv */
  one_schema_template_multi_id: string | null;
  created_at: string;
  person_name: string | null;
  payer_display_name: string | null;
  /** The trip ID used by an intermediary/broker, may or may not be the originator */
  intermediary_id: string;
};
export type TripCreateRead = {
  id: number;
  parsed_trip: TripCreateTripDataRead | null;
};
export type PaginatedTripCreateList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TripCreate[];
};
export type PaginatedTripCreateListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TripCreateRead[];
};
export type TripsCreatesListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripUpdateDriverEnteredNotes = {};
export type TripUpdateDriverEnteredNotesWrite = {
  driver_entered_notes: string;
};
export type TripsDriverEnteredNotesPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsDriverEnteredNotesPartialUpdateDriverEnteredNotesErrorComponent =
  {
    attr: 'driver_entered_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsDriverEnteredNotesPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & TripsDriverEnteredNotesPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'driver_entered_notes';
    } & TripsDriverEnteredNotesPartialUpdateDriverEnteredNotesErrorComponent);
export type TripsDriverEnteredNotesPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsDriverEnteredNotesPartialUpdateError[];
};
export type TripsDriverEnteredNotesPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsDriverEnteredNotesPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedTripUpdateDriverEnteredNotes = {};
export type PatchedTripUpdateDriverEnteredNotesWrite = {
  driver_entered_notes?: string;
};
export type TripManualUpdate = {};
export type TripEventEnum =
  | 'status_en_route'
  | 'status_at_pickup'
  | 'status_transporting'
  | 'status_at_dropoff'
  | 'completion'
  | 'uncompletion'
  | 'cancellation'
  | 'uncancellation'
  | 'accept'
  | 'assign'
  | 'unassign'
  | 'lock'
  | 'unlock'
  | 'rejection'
  | 'unrejection'
  | 'activate_will_call'
  | 'update_pickup_at'
  | 'push_needs_at_pickup'
  | 'push_needs_transporting'
  | 'push_needs_dropoff'
  | 'push_needs_completed'
  | 'enter_pickup_geofence'
  | 'exit_pickup_geofence'
  | 'enter_dropoff_geofence'
  | 'exit_dropoff_geofence'
  | 'cancel_will_call_activation'
  | 'cancellation_request'
  | 'accept_cancellation_request'
  | 'reject_cancellation_request'
  | 'remove_cancellation_request';
export type TripManualUpdateWrite = {
  event_type: TripEventEnum;
  date_time: string;
};
export type TripsEventManualCreatePartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsEventManualCreatePartialUpdateEventTypeErrorComponent = {
  attr: 'event_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type TripsEventManualCreatePartialUpdateDateTimeErrorComponent = {
  attr: 'date_time';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type TripsEventManualCreatePartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & TripsEventManualCreatePartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'event_type';
    } & TripsEventManualCreatePartialUpdateEventTypeErrorComponent)
  | ({
      attr: 'date_time';
    } & TripsEventManualCreatePartialUpdateDateTimeErrorComponent);
export type TripsEventManualCreatePartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsEventManualCreatePartialUpdateError[];
};
export type TripsEventManualCreatePartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsEventManualCreatePartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedTripManualUpdate = {};
export type PatchedTripManualUpdateWrite = {
  event_type?: TripEventEnum;
  date_time?: string;
};
export type TripEvent = {
  trip_id?: string | null;
};
export type TripEventData = {
  assignment_id?: string | null;
  status?: string | null;
  previous_status?: string | null;
  canceled_reason?: string | null;
};
export type TripEventRead = {
  id: string;
  longitude: number | null;
  latitude: number | null;
  event_type: TripEventEnum;
  occurred_at: string;
  person_name: string;
  data: TripEventData | null;
  raw_json_data: {
    [key: string]: any;
  } | null;
  assignment_id: string | null;
  vehicle: string | null;
  driver: string | null;
  attendants: string[] | null;
  trip_id?: string | null;
  created_at: string;
};
export type PaginatedTripEventList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TripEvent[];
};
export type PaginatedTripEventListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TripEventRead[];
};
export type TripsEventsListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type LocationLogEntryMinimalReadOnly = {};
export type LocationLogEntryMinimalReadOnlyRead = {
  /** ISO-8601 UTC datetime provided by the native location API. */
  device_timestamp: string;
  longitude: number;
  latitude: number;
  /** Device battery level when the location was recorded. 0.0=empty; 1.0=full. */
  battery_level: number;
  /** True when device is plugged in to power. */
  battery_is_charging: boolean;
};
export type PaginatedLocationLogEntryMinimalReadOnlyList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: LocationLogEntryMinimalReadOnly[];
};
export type PaginatedLocationLogEntryMinimalReadOnlyListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: LocationLogEntryMinimalReadOnlyRead[];
};
export type TripsLocationsListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripsLockPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsLockPartialUpdateError = {
  attr: 'non_field_errors';
} & TripsLockPartialUpdateNonFieldErrorsErrorComponent;
export type TripsLockPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsLockPartialUpdateError[];
};
export type TripsLockPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsLockPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TripOverrideStatusChange = {};
export type TripOverrideStatusChangeWrite = {
  concurrent_trips?: string[];
  override_status: OverrideStatusEnum;
};
export type TripsOverrideStatusPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsOverrideStatusPartialUpdateConcurrentTripsErrorComponent = {
  attr: 'concurrent_trips';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type TripsOverrideStatusPartialUpdateConcurrentTripsIndexErrorComponent =
  {
    attr: 'concurrent_trips.INDEX';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsOverrideStatusPartialUpdateOverrideStatusErrorComponent = {
  attr: 'override_status';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type TripsOverrideStatusPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & TripsOverrideStatusPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'concurrent_trips';
    } & TripsOverrideStatusPartialUpdateConcurrentTripsErrorComponent)
  | ({
      attr: 'concurrent_trips.INDEX';
    } & TripsOverrideStatusPartialUpdateConcurrentTripsIndexErrorComponent)
  | ({
      attr: 'override_status';
    } & TripsOverrideStatusPartialUpdateOverrideStatusErrorComponent);
export type TripsOverrideStatusPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsOverrideStatusPartialUpdateError[];
};
export type TripsOverrideStatusPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsOverrideStatusPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedTripOverrideStatusChange = {};
export type PatchedTripOverrideStatusChangeWrite = {
  concurrent_trips?: string[];
  override_status?: OverrideStatusEnum;
};
export type TripPriceSummary = {};
export type TripPriceSummaryRead = {
  /** - This class represents the summary of all fees that are calculated
    and the associated subtotals.
    - The fields are all optional because they will only be calculated
    if the relevant fees are present on the PricingScheme model. */
  price_summary: {
    name: string;
    base_fee_summary: {
      sub_total: number;
    } | null;
    loaded_mileage_fee_summary: {
      miles: number;
      free_miles: number;
      rate: number;
      sub_total: number;
    } | null;
    long_distance_loaded_mileage_fee_summary: {
      miles: number;
      free_miles: number;
      rate: number;
      sub_total: number;
    } | null;
    unloaded_mileage_fee_summary: {
      miles: number;
      free_miles: number;
      rate: number;
      sub_total: number;
    } | null;
    unloaded_return_mileage_fee_summary: {
      miles: number;
      free_miles: number;
      rate: number;
      sub_total: number;
    } | null;
    wait_time_fee_summary: {
      minutes: number;
      free_minutes: number;
      period: number;
      rate: number;
      sub_total: number;
    } | null;
    no_show_fee_summary: {
      sub_total: number;
      cancellation_reason: string;
      canceled_at: string;
      scheduled_pickup_at: string;
      minutes_before_pickup: number;
      no_show_fee_type: string;
    } | null;
    late_cancellation_fee_summary: {
      sub_total: number;
      canceled_at: string;
      scheduled_pickup_at: string;
      minutes_before_pickup: number;
      late_cancellation_fee_type: string;
    } | null;
    pickup_stair_fee_summary: {
      sub_total: number;
      steps: number;
      minimum_steps: number;
      fee_type: string;
      rate: number;
    } | null;
    dropoff_stair_fee_summary: {
      sub_total: number;
      steps: number;
      minimum_steps: number;
      fee_type: string;
      rate: number;
    } | null;
    additional_attendants_fee_summary: {
      sub_total: number;
      additional_attendants: number;
      rate: number;
    } | null;
    additional_passengers_fee_summary: {
      sub_total: number;
      additional_passengers: number;
      rate: number;
    } | null;
    bariatric_fee_summary: {
      sub_total: number;
      is_bariatric: boolean;
    } | null;
    wheelchair_rental_fee_summary: {
      sub_total: number;
      is_wheelchair_provided: boolean;
    } | null;
    oxygen_fee_summary: {
      sub_total: number;
      is_oxygen_provided: boolean;
    } | null;
    after_hours_fee_summary: {
      sub_total: number;
      pickup_time: string;
      business_hours_start: string | null;
      business_hours_end: string | null;
    } | null;
    weekend_fee_summary: {
      sub_total: number;
      day_of_week: string;
    } | null;
    holiday_fee_summary: {
      sub_total: number;
      holiday: string | null;
      date: string;
    } | null;
    minimum_price_cents: number | null;
    infectious_disease_fee_summary: {
      sub_total: number;
      has_infectious_disease: boolean;
    } | null;
    same_day_booking_fee_summary: {
      sub_total: number;
    } | null;
    car_seat_fee_summary: {
      sub_total: number;
      is_car_seat_required: boolean;
    } | null;
    booster_seat_fee_summary: {
      sub_total: number;
      is_booster_seat_required: boolean;
    } | null;
    ride_alone_fee_summary: {
      sub_total: number;
      is_ride_alone: boolean;
    } | null;
    price_rounding: string;
    price_rounding_interval: number | null;
    total: number;
  } | null;
};
export type TripsPriceSummaryRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripPublicTripTrackingLink = {};
export type TripPublicTripTrackingLinkRead = {
  link: string;
};
export type TripsPublicTripTrackingLinkRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripReassign = {};
export type TripReassignWrite = {
  assignment_id: string;
};
export type TripsReassignPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsReassignPartialUpdateAssignmentIdErrorComponent = {
  attr: 'assignment_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsReassignPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & TripsReassignPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'assignment_id';
    } & TripsReassignPartialUpdateAssignmentIdErrorComponent);
export type TripsReassignPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsReassignPartialUpdateError[];
};
export type TripsReassignPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsReassignPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedTripReassign = {};
export type PatchedTripReassignWrite = {
  assignment_id?: string;
};
export type TripReject = {};
export type TripRejectWrite = {
  override?: boolean;
  rejected_reason: string;
};
export type TripsRejectPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsRejectPartialUpdateOverrideErrorComponent = {
  attr: 'override';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsRejectPartialUpdateRejectedReasonErrorComponent = {
  attr: 'rejected_reason';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsRejectPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & TripsRejectPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'override';
    } & TripsRejectPartialUpdateOverrideErrorComponent)
  | ({
      attr: 'rejected_reason';
    } & TripsRejectPartialUpdateRejectedReasonErrorComponent);
export type TripsRejectPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsRejectPartialUpdateError[];
};
export type TripsRejectPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsRejectPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedTripReject = {};
export type PatchedTripRejectWrite = {
  override?: boolean;
  rejected_reason?: string;
};
export type TripsRejectCancellationRequestPartialUpdateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type TripsRejectCancellationRequestPartialUpdateError = {
  attr: 'non_field_errors';
} & TripsRejectCancellationRequestPartialUpdateNonFieldErrorsErrorComponent;
export type TripsRejectCancellationRequestPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsRejectCancellationRequestPartialUpdateError[];
};
export type TripsRejectCancellationRequestPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsRejectCancellationRequestPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TripRejectionReasons = {};
export type TripRejectionReasonsRead = {
  /** Map of rejection reasons as keys to their integer/database values */
  rejection_reasons: {
    [key: string]: string;
  } | null;
};
export type TripsRejectCodesRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripRejectReasons = {};
export type TripRejectReason = {
  /** The reason for the rejection to be shown to the user */
  label: string;
  /** The value of the reason for dropdowns, the rejection endpoint.  */
  value?: string;
};
export type TripRejectReasonsRead = {
  /** A list of valid reasons for rejecting the trip. */
  reject_reasons: TripRejectReason[];
};
export type TripsRejectReasonsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripsRelatedListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripsRemoveCancellationRequestPartialUpdateNonFieldErrorsErrorComponent =
  {
    attr: 'non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type TripsRemoveCancellationRequestPartialUpdateError = {
  attr: 'non_field_errors';
} & TripsRemoveCancellationRequestPartialUpdateNonFieldErrorsErrorComponent;
export type TripsRemoveCancellationRequestPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsRemoveCancellationRequestPartialUpdateError[];
};
export type TripsRemoveCancellationRequestPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsRemoveCancellationRequestPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type SignatureTypeEnum =
  | 'membership'
  | 'passenger'
  | 'guardian'
  | 'facility'
  | 'unable';
export type ContentTypeEnum = 'vehicleinspectionreport' | 'triplocationdetail';
export type SignedItem = {
  content_type: ContentTypeEnum;
  object_id: string;
};
export type Signature = {
  image: string;
  /** type of signature */
  signature_type?: SignatureTypeEnum | BlankEnum;
  signed_items: SignedItem[];
};
export type SignatureRead = {
  id: string;
  organization_id: string;
  membership: string;
  first_name: string;
  last_name: string;
  longitude: number;
  latitude: number;
  location_queried_at: string | null;
  device_requested_at: string | null;
  image: string;
  /** type of signature */
  signature_type?: SignatureTypeEnum | BlankEnum;
  signed_items: SignedItem[];
  created_at: string;
  updated_at: string;
};
export type PaginatedSignatureList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: Signature[];
};
export type PaginatedSignatureListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: SignatureRead[];
};
export type TripsSignaturesListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripStatusChange = {};
export type NewStatusEnum =
  | 'en route'
  | 'at pickup'
  | 'transporting'
  | 'at dropoff';
export type TripStatusChangeWrite = {
  concurrent_trips?: string[];
  new_status: NewStatusEnum;
};
export type TripsStatusPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsStatusPartialUpdateConcurrentTripsErrorComponent = {
  attr: 'concurrent_trips';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type TripsStatusPartialUpdateConcurrentTripsIndexErrorComponent = {
  attr: 'concurrent_trips.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsStatusPartialUpdateNewStatusErrorComponent = {
  attr: 'new_status';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type TripsStatusPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & TripsStatusPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'concurrent_trips';
    } & TripsStatusPartialUpdateConcurrentTripsErrorComponent)
  | ({
      attr: 'concurrent_trips.INDEX';
    } & TripsStatusPartialUpdateConcurrentTripsIndexErrorComponent)
  | ({
      attr: 'new_status';
    } & TripsStatusPartialUpdateNewStatusErrorComponent);
export type TripsStatusPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsStatusPartialUpdateError[];
};
export type TripsStatusPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsStatusPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedTripStatusChange = {};
export type PatchedTripStatusChangeWrite = {
  concurrent_trips?: string[];
  new_status?: NewStatusEnum;
};
export type TripSummary = {
  scheduled_pickup_at: string;
  actual_en_route_at: string;
  actual_at_pickup_at: string;
  actual_transporting_at: string;
  actual_at_dropoff_at: string;
  actual_completed_at: string;
  at_pickup_to_complete_duration_sec: number;
};
export type PassengerMinimalReadOnly = {};
export type PronounEnum = 'she' | 'he' | 'they';
export type PassengerMinimalReadOnlyRead = {
  id: string;
  first_name: string;
  last_name: string;
  full_name: string;
  preferred_name: string;
  pronoun: PronounEnum;
  /** Patient gender according to their primary insurance */
  gender: GenderEnum;
  dob: string | null;
  weight: number | null;
  phone_number: string | null;
  /** email address (unique in organization) */
  email: string | null;
  notes: string;
};
export type LocationLogEntryRead = {
  uuid?: string;
  location_log_entry: string;
  timestamp: string;
  latitude: number;
  longitude: number;
  odometer: number;
  heading: number;
};
export type TripSummaryRead = {
  id: string;
  /** The assignment that this trip belongs to (optional) */
  assignment: string | null;
  passenger: PassengerMinimalReadOnlyRead;
  pickup: TripLocationDetailRead;
  dropoff: TripLocationDetailRead;
  scheduled_pickup_at: string;
  actual_en_route_at: string;
  actual_at_pickup_at: string;
  actual_transporting_at: string;
  actual_at_dropoff_at: string;
  actual_completed_at: string;
  at_pickup_to_complete_duration_sec: number;
  location_log_entries: LocationLogEntryRead;
};
export type TripsSummaryRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripTurnbackReason = {};
export type TripTurnbackReasonRead = {
  /** Map of turnback reasons as keys to their integer values (maybe) */
  turnback_reasons: {
    [key: string]: string;
  } | null;
};
export type TripsTurnbackReasonsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripsUnassignPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsUnassignPartialUpdateError = {
  attr: 'non_field_errors';
} & TripsUnassignPartialUpdateNonFieldErrorsErrorComponent;
export type TripsUnassignPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsUnassignPartialUpdateError[];
};
export type TripsUnassignPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsUnassignPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TripUncancel = {};
export type TripUncancelWrite = {
  concurrent_trips?: string[];
  override?: boolean;
};
export type TripsUncancelPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsUncancelPartialUpdateConcurrentTripsErrorComponent = {
  attr: 'concurrent_trips';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type TripsUncancelPartialUpdateConcurrentTripsIndexErrorComponent = {
  attr: 'concurrent_trips.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsUncancelPartialUpdateOverrideErrorComponent = {
  attr: 'override';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsUncancelPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & TripsUncancelPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'concurrent_trips';
    } & TripsUncancelPartialUpdateConcurrentTripsErrorComponent)
  | ({
      attr: 'concurrent_trips.INDEX';
    } & TripsUncancelPartialUpdateConcurrentTripsIndexErrorComponent)
  | ({
      attr: 'override';
    } & TripsUncancelPartialUpdateOverrideErrorComponent);
export type TripsUncancelPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsUncancelPartialUpdateError[];
};
export type TripsUncancelPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsUncancelPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedTripUncancel = {};
export type PatchedTripUncancelWrite = {
  concurrent_trips?: string[];
  override?: boolean;
};
export type TripsUnlockPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsUnlockPartialUpdateError = {
  attr: 'non_field_errors';
} & TripsUnlockPartialUpdateNonFieldErrorsErrorComponent;
export type TripsUnlockPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsUnlockPartialUpdateError[];
};
export type TripsUnlockPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsUnlockPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TripUnreject = {};
export type TripUnrejectWrite = {
  override?: boolean;
};
export type TripsUnrejectPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsUnrejectPartialUpdateOverrideErrorComponent = {
  attr: 'override';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsUnrejectPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & TripsUnrejectPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'override';
    } & TripsUnrejectPartialUpdateOverrideErrorComponent);
export type TripsUnrejectPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsUnrejectPartialUpdateError[];
};
export type TripsUnrejectPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsUnrejectPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedTripUnreject = {};
export type PatchedTripUnrejectWrite = {
  override?: boolean;
};
export type TripUpdatePickupAt = {};
export type TripUpdatePickupAtWrite = {
  pickup_at: string;
};
export type TripsUpdatePickupAtPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsUpdatePickupAtPartialUpdatePickupAtErrorComponent = {
  attr: 'pickup_at';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type TripsUpdatePickupAtPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & TripsUpdatePickupAtPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'pickup_at';
    } & TripsUpdatePickupAtPartialUpdatePickupAtErrorComponent);
export type TripsUpdatePickupAtPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsUpdatePickupAtPartialUpdateError[];
};
export type TripsUpdatePickupAtPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsUpdatePickupAtPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedTripUpdatePickupAt = {};
export type PatchedTripUpdatePickupAtWrite = {
  pickup_at?: string;
};
export type TripUpdate = {};
export type TripUpdateRead = {
  id: number;
  raw_diff: {
    [key: string]: any;
  } | null;
  values_changed: {
    [key: string]: {
      old_value: string | null;
      new_value: string | null;
    };
  } | null;
  value_keys: string[] | null;
  person_name: string | null;
  created_at: string;
};
export type PaginatedTripUpdateList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TripUpdate[];
};
export type PaginatedTripUpdateListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TripUpdateRead[];
};
export type TripsUpdatesListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripValidate = {};
export type TripValidateRead = {
  explanation: string[];
  can_assign: boolean;
};
export type TripValidateWrite = {
  assignment_id: string;
};
export type TripsValidatePartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsValidatePartialUpdateAssignmentIdErrorComponent = {
  attr: 'assignment_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsValidatePartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & TripsValidatePartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'assignment_id';
    } & TripsValidatePartialUpdateAssignmentIdErrorComponent);
export type TripsValidatePartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsValidatePartialUpdateError[];
};
export type TripsValidatePartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsValidatePartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedTripValidate = {};
export type PatchedTripValidateRead = {
  explanation?: string[];
  can_assign?: boolean;
};
export type PatchedTripValidateWrite = {
  assignment_id?: string;
};
export type TripUnassignedActivatedWillCallCount = {
  count: number;
};
export type TripsActivatedWillCallCountRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripWithPriceSummary = {
  created_at: string;
  dropoff: TripLocationDetail;
  passenger: PatchedTripPassenger;
  pickup: TripLocationDetail;
  scheduled_pickup_at: string;
};
export type TripWithPriceSummaryRead = {
  id: string;
  completion_time: string | null;
  /** Searchable, sharable short code for this trip and/or subscription */
  confirmation_code: string;
  created_at: string;
  driver_name: string;
  dropoff: TripLocationDetailRead;
  estimated_distance_miles: number | null;
  /** The trip ID used by the trip originator, (e.g. payer or original broker) */
  external_trip_id: string;
  /** The manually inputted price of the trip */
  input_price_cents: number | null;
  invoice_id: string | null;
  invoice_numbers: string | null;
  passenger: PatchedTripPassengerRead;
  payer_passenger: TripPayerPassengerRead | null;
  payer: PayerOrganizationRead;
  pickup: TripLocationDetailRead;
  /** - This class represents the summary of all fees that are calculated
    and the associated subtotals.
    - The fields are all optional because they will only be calculated
    if the relevant fees are present on the PricingScheme model. */
  price_summary: {
    name: string;
    base_fee_summary: {
      sub_total: number;
    } | null;
    loaded_mileage_fee_summary: {
      miles: number;
      free_miles: number;
      rate: number;
      sub_total: number;
    } | null;
    long_distance_loaded_mileage_fee_summary: {
      miles: number;
      free_miles: number;
      rate: number;
      sub_total: number;
    } | null;
    unloaded_mileage_fee_summary: {
      miles: number;
      free_miles: number;
      rate: number;
      sub_total: number;
    } | null;
    unloaded_return_mileage_fee_summary: {
      miles: number;
      free_miles: number;
      rate: number;
      sub_total: number;
    } | null;
    wait_time_fee_summary: {
      minutes: number;
      free_minutes: number;
      period: number;
      rate: number;
      sub_total: number;
    } | null;
    no_show_fee_summary: {
      sub_total: number;
      cancellation_reason: string;
      canceled_at: string;
      scheduled_pickup_at: string;
      minutes_before_pickup: number;
      no_show_fee_type: string;
    } | null;
    late_cancellation_fee_summary: {
      sub_total: number;
      canceled_at: string;
      scheduled_pickup_at: string;
      minutes_before_pickup: number;
      late_cancellation_fee_type: string;
    } | null;
    pickup_stair_fee_summary: {
      sub_total: number;
      steps: number;
      minimum_steps: number;
      fee_type: string;
      rate: number;
    } | null;
    dropoff_stair_fee_summary: {
      sub_total: number;
      steps: number;
      minimum_steps: number;
      fee_type: string;
      rate: number;
    } | null;
    additional_attendants_fee_summary: {
      sub_total: number;
      additional_attendants: number;
      rate: number;
    } | null;
    additional_passengers_fee_summary: {
      sub_total: number;
      additional_passengers: number;
      rate: number;
    } | null;
    bariatric_fee_summary: {
      sub_total: number;
      is_bariatric: boolean;
    } | null;
    wheelchair_rental_fee_summary: {
      sub_total: number;
      is_wheelchair_provided: boolean;
    } | null;
    oxygen_fee_summary: {
      sub_total: number;
      is_oxygen_provided: boolean;
    } | null;
    after_hours_fee_summary: {
      sub_total: number;
      pickup_time: string;
      business_hours_start: string | null;
      business_hours_end: string | null;
    } | null;
    weekend_fee_summary: {
      sub_total: number;
      day_of_week: string;
    } | null;
    holiday_fee_summary: {
      sub_total: number;
      holiday: string | null;
      date: string;
    } | null;
    minimum_price_cents: number | null;
    infectious_disease_fee_summary: {
      sub_total: number;
      has_infectious_disease: boolean;
    } | null;
    same_day_booking_fee_summary: {
      sub_total: number;
    } | null;
    car_seat_fee_summary: {
      sub_total: number;
      is_car_seat_required: boolean;
    } | null;
    booster_seat_fee_summary: {
      sub_total: number;
      is_booster_seat_required: boolean;
    } | null;
    ride_alone_fee_summary: {
      sub_total: number;
      is_ride_alone: boolean;
    } | null;
    price_rounding: string;
    price_rounding_interval: number | null;
    total: number;
  } | null;
  scheduled_pickup_at: string;
  service_type: ServiceTypeEnum;
  /** The type of space in the vehicle this passenger will need */
  space_type: SpaceTypeEnum;
  /** Current status of this trip */
  status: OverrideStatusEnum;
  tags: TripTripTagRead[] | null;
  vehicle_nickname: string | null;
};
export type TripWithPriceSummaryWrite = {
  created_at: string;
  dropoff: TripLocationDetail;
  passenger: PatchedTripPassenger;
  payer_id: string;
  pickup: TripLocationDetail;
  scheduled_pickup_at: string;
};
export type PaginatedTripWithPriceSummaryList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TripWithPriceSummary[];
};
export type PaginatedTripWithPriceSummaryListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TripWithPriceSummaryRead[];
};
export type PaginatedTripWithPriceSummaryListWrite = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TripWithPriceSummaryWrite[];
};
export type TripsAllListRangeStartErrorComponent = {
  attr: 'range_start';
  code: 'invalid';
  detail: string;
};
export type TripsAllListRangeEndErrorComponent = {
  attr: 'range_end';
  code: 'invalid';
  detail: string;
};
export type TripsAllListPayersErrorComponent = {
  attr: 'payers';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type TripsAllListStatusErrorComponent = {
  attr: 'status';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type TripsAllListPassengersErrorComponent = {
  attr: 'passengers';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type TripsAllListTagsErrorComponent = {
  attr: 'tags';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type TripsAllListVehiclesErrorComponent = {
  attr: 'vehicles';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type TripsAllListSpaceTypeErrorComponent = {
  attr: 'space_type';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type TripsAllListPriceErrorComponent = {
  attr: 'price';
  code: 'invalid';
  detail: string;
};
export type TripsAllListCreatedAtRangeStartErrorComponent = {
  attr: 'created_at_range_start';
  code: 'invalid';
  detail: string;
};
export type TripsAllListCreatedAtRangeEndErrorComponent = {
  attr: 'created_at_range_end';
  code: 'invalid';
  detail: string;
};
export type TripsAllListError =
  | ({
      attr: 'range_start';
    } & TripsAllListRangeStartErrorComponent)
  | ({
      attr: 'range_end';
    } & TripsAllListRangeEndErrorComponent)
  | ({
      attr: 'payers';
    } & TripsAllListPayersErrorComponent)
  | ({
      attr: 'status';
    } & TripsAllListStatusErrorComponent)
  | ({
      attr: 'passengers';
    } & TripsAllListPassengersErrorComponent)
  | ({
      attr: 'tags';
    } & TripsAllListTagsErrorComponent)
  | ({
      attr: 'vehicles';
    } & TripsAllListVehiclesErrorComponent)
  | ({
      attr: 'space_type';
    } & TripsAllListSpaceTypeErrorComponent)
  | ({
      attr: 'price';
    } & TripsAllListPriceErrorComponent)
  | ({
      attr: 'created_at_range_start';
    } & TripsAllListCreatedAtRangeStartErrorComponent)
  | ({
      attr: 'created_at_range_end';
    } & TripsAllListCreatedAtRangeEndErrorComponent);
export type TripsAllListValidationError = {
  type: ValidationErrorEnum;
  errors: TripsAllListError[];
};
export type TripsAllListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsAllListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type BulkTripError = {
  trip_id: string;
  error: string;
};
export type BulkTripAcceptResults = {
  trips_accepted: string[];
  trips_not_accepted: string[];
  errors?: BulkTripError[] | null;
};
export type TripsBulkAcceptCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsBulkAcceptCreateTripIdsErrorComponent = {
  attr: 'trip_ids';
  code: 'min_length' | 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type TripsBulkAcceptCreateTripIdsIndexErrorComponent = {
  attr: 'trip_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsBulkAcceptCreateOverrideErrorComponent = {
  attr: 'override';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsBulkAcceptCreateError =
  | ({
      attr: 'non_field_errors';
    } & TripsBulkAcceptCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'trip_ids';
    } & TripsBulkAcceptCreateTripIdsErrorComponent)
  | ({
      attr: 'trip_ids.INDEX';
    } & TripsBulkAcceptCreateTripIdsIndexErrorComponent)
  | ({
      attr: 'override';
    } & TripsBulkAcceptCreateOverrideErrorComponent);
export type TripsBulkAcceptCreateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsBulkAcceptCreateError[];
};
export type TripsBulkAcceptCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsBulkAcceptCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type BulkTripAccept = {
  trip_ids: string[];
};
export type BulkTripAcceptWrite = {
  trip_ids: string[];
  override?: boolean;
};
export type BulkTripAssign = {};
export type BulkTripAssignWrite = {
  assignment_id: string;
  trip_ids: string[];
};
export type TripsBulkAssignCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsBulkAssignCreateAssignmentIdErrorComponent = {
  attr: 'assignment_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsBulkAssignCreateTripIdsErrorComponent = {
  attr: 'trip_ids';
  code: 'min_length' | 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type TripsBulkAssignCreateTripIdsIndexErrorComponent = {
  attr: 'trip_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsBulkAssignCreateError =
  | ({
      attr: 'non_field_errors';
    } & TripsBulkAssignCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'assignment_id';
    } & TripsBulkAssignCreateAssignmentIdErrorComponent)
  | ({
      attr: 'trip_ids';
    } & TripsBulkAssignCreateTripIdsErrorComponent)
  | ({
      attr: 'trip_ids.INDEX';
    } & TripsBulkAssignCreateTripIdsIndexErrorComponent);
export type TripsBulkAssignCreateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsBulkAssignCreateError[];
};
export type TripsBulkAssignCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsBulkAssignCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type BulkTripCancelResults = {
  trips_canceled: string[];
  trips_not_canceled: string[];
  errors?: BulkTripError[] | null;
};
export type TripsBulkCancelCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsBulkCancelCreateTripReasonsErrorComponent = {
  attr: 'trip_reasons';
  code: 'min_length' | 'not_a_list';
  detail: string;
};
export type TripsBulkCancelCreateTripReasonsIndexNonFieldErrorsErrorComponent =
  {
    attr: 'trip_reasons.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsBulkCancelCreateTripReasonsIndexTripIdErrorComponent = {
  attr: 'trip_reasons.INDEX.trip_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsBulkCancelCreateTripReasonsIndexCanceledReasonErrorComponent =
  {
    attr: 'trip_reasons.INDEX.canceled_reason';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsBulkCancelCreateTripIdsErrorComponent = {
  attr: 'trip_ids';
  code: 'min_length' | 'not_a_list';
  detail: string;
};
export type TripsBulkCancelCreateTripIdsIndexErrorComponent = {
  attr: 'trip_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsBulkCancelCreateCanceledReasonErrorComponent = {
  attr: 'canceled_reason';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsBulkCancelCreateOverrideErrorComponent = {
  attr: 'override';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsBulkCancelCreateError =
  | ({
      attr: 'non_field_errors';
    } & TripsBulkCancelCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'trip_reasons';
    } & TripsBulkCancelCreateTripReasonsErrorComponent)
  | ({
      attr: 'trip_reasons.INDEX.non_field_errors';
    } & TripsBulkCancelCreateTripReasonsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'trip_reasons.INDEX.trip_id';
    } & TripsBulkCancelCreateTripReasonsIndexTripIdErrorComponent)
  | ({
      attr: 'trip_reasons.INDEX.canceled_reason';
    } & TripsBulkCancelCreateTripReasonsIndexCanceledReasonErrorComponent)
  | ({
      attr: 'trip_ids';
    } & TripsBulkCancelCreateTripIdsErrorComponent)
  | ({
      attr: 'trip_ids.INDEX';
    } & TripsBulkCancelCreateTripIdsIndexErrorComponent)
  | ({
      attr: 'canceled_reason';
    } & TripsBulkCancelCreateCanceledReasonErrorComponent)
  | ({
      attr: 'override';
    } & TripsBulkCancelCreateOverrideErrorComponent);
export type TripsBulkCancelCreateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsBulkCancelCreateError[];
};
export type TripsBulkCancelCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsBulkCancelCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TripCanceledReason = {
  trip_id: string;
  canceled_reason: string;
};
export type BulkTripCancel = {
  trip_reasons?: TripCanceledReason[] | null;
  trip_ids?: string[] | null;
};
export type BulkTripCancelWrite = {
  trip_reasons?: TripCanceledReason[] | null;
  trip_ids?: string[] | null;
  canceled_reason?: CanceledReasonEnum;
  override?: boolean;
};
export type BulkTripCancelReasons = {};
export type BulkTripCancelReason = {};
export type BulkTripCancelReasonRead = {
  trip_id: string;
  cancel_reasons: TripCancelReason[];
};
export type BulkTripCancelReasonsRead = {
  results: BulkTripCancelReasonRead[];
};
export type BulkTripCancelReasonsWrite = {
  trip_ids: string[];
};
export type TripsBulkCancelReasonsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsBulkCancelReasonsCreateTripIdsErrorComponent = {
  attr: 'trip_ids';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type TripsBulkCancelReasonsCreateTripIdsIndexErrorComponent = {
  attr: 'trip_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsBulkCancelReasonsCreateResultsIndexCancelReasonsIndexLabelErrorComponent =
  {
    attr: 'results.INDEX.cancel_reasons.INDEX.label';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsBulkCancelReasonsCreateResultsIndexCancelReasonsIndexValueErrorComponent =
  {
    attr: 'results.INDEX.cancel_reasons.INDEX.value';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsBulkCancelReasonsCreateError =
  | ({
      attr: 'non_field_errors';
    } & TripsBulkCancelReasonsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'trip_ids';
    } & TripsBulkCancelReasonsCreateTripIdsErrorComponent)
  | ({
      attr: 'trip_ids.INDEX';
    } & TripsBulkCancelReasonsCreateTripIdsIndexErrorComponent)
  | ({
      attr: 'results.INDEX.cancel_reasons.INDEX.label';
    } & TripsBulkCancelReasonsCreateResultsIndexCancelReasonsIndexLabelErrorComponent)
  | ({
      attr: 'results.INDEX.cancel_reasons.INDEX.value';
    } & TripsBulkCancelReasonsCreateResultsIndexCancelReasonsIndexValueErrorComponent);
export type TripsBulkCancelReasonsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsBulkCancelReasonsCreateError[];
};
export type TripsBulkCancelReasonsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsBulkCancelReasonsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type BulkTripPriceChangeResults = {};
export type BulkTripPriceChangeItem = {};
export type BulkTripPriceChangeItemRead = {
  id: string;
  passenger: string;
  payer: string;
  scheduled_pickup_at: string;
  pickup: string;
  dropoff: string;
  input_price_cents: number;
  new_price_cents: number | null;
};
export type BulkTripPriceChangeResultsRead = {
  trips_outside_date_range: BulkTripPriceChangeItemRead[];
  trips_no_pricing_scheme: BulkTripPriceChangeItemRead[];
  trips_repriced: BulkTripPriceChangeItemRead[];
};
export type TripsBulkPriceCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsBulkPriceCreateTripIdsErrorComponent = {
  attr: 'trip_ids';
  code: 'min_length' | 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type TripsBulkPriceCreateTripIdsIndexErrorComponent = {
  attr: 'trip_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsBulkPriceCreateError =
  | ({
      attr: 'non_field_errors';
    } & TripsBulkPriceCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'trip_ids';
    } & TripsBulkPriceCreateTripIdsErrorComponent)
  | ({
      attr: 'trip_ids.INDEX';
    } & TripsBulkPriceCreateTripIdsIndexErrorComponent);
export type TripsBulkPriceCreateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsBulkPriceCreateError[];
};
export type TripsBulkPriceCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsBulkPriceCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type BulkTripPriceChange = {
  trip_ids: string[];
};
export type BulkTripPriceChangeRead = {
  trip_ids: string[];
  results: BulkTripPriceChangeResultsRead;
};
export type BulkTripPriceChangeConfirmResults = {};
export type BulkTripPriceChangeConfirmResultsRead = {
  trips_updated: number;
};
export type TripsBulkPriceConfirmCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsBulkPriceConfirmCreateConfirmedTripsNonFieldErrorsErrorComponent =
  {
    attr: 'confirmed_trips.non_field_errors';
    code: 'not_a_list' | 'null' | 'required';
    detail: string;
  };
export type TripsBulkPriceConfirmCreateConfirmedTripsIndexNonFieldErrorsErrorComponent =
  {
    attr: 'confirmed_trips.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsBulkPriceConfirmCreateConfirmedTripsIndexIdErrorComponent = {
  attr: 'confirmed_trips.INDEX.id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsBulkPriceConfirmCreateConfirmedTripsIndexNewPriceCentsErrorComponent =
  {
    attr: 'confirmed_trips.INDEX.new_price_cents';
    code: 'invalid' | 'max_string_length' | 'null' | 'required';
    detail: string;
  };
export type TripsBulkPriceConfirmCreateError =
  | ({
      attr: 'non_field_errors';
    } & TripsBulkPriceConfirmCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'confirmed_trips.non_field_errors';
    } & TripsBulkPriceConfirmCreateConfirmedTripsNonFieldErrorsErrorComponent)
  | ({
      attr: 'confirmed_trips.INDEX.non_field_errors';
    } & TripsBulkPriceConfirmCreateConfirmedTripsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'confirmed_trips.INDEX.id';
    } & TripsBulkPriceConfirmCreateConfirmedTripsIndexIdErrorComponent)
  | ({
      attr: 'confirmed_trips.INDEX.new_price_cents';
    } & TripsBulkPriceConfirmCreateConfirmedTripsIndexNewPriceCentsErrorComponent);
export type TripsBulkPriceConfirmCreateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsBulkPriceConfirmCreateError[];
};
export type TripsBulkPriceConfirmCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsBulkPriceConfirmCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type BulkTripPriceChangeConfirmItem = {
  id: string;
  new_price_cents: number;
};
export type BulkTripPriceChangeConfirm = {
  confirmed_trips: BulkTripPriceChangeConfirmItem[];
};
export type BulkTripRejectResults = {
  trips_rejected: string[];
  trips_not_rejected: string[];
  errors?: BulkTripError[] | null;
};
export type TripsBulkRejectCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsBulkRejectCreateTripReasonsErrorComponent = {
  attr: 'trip_reasons';
  code: 'min_length' | 'not_a_list';
  detail: string;
};
export type TripsBulkRejectCreateTripReasonsIndexNonFieldErrorsErrorComponent =
  {
    attr: 'trip_reasons.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsBulkRejectCreateTripReasonsIndexTripIdErrorComponent = {
  attr: 'trip_reasons.INDEX.trip_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsBulkRejectCreateTripReasonsIndexRejectedReasonErrorComponent =
  {
    attr: 'trip_reasons.INDEX.rejected_reason';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsBulkRejectCreateTripIdsErrorComponent = {
  attr: 'trip_ids';
  code: 'min_length' | 'not_a_list';
  detail: string;
};
export type TripsBulkRejectCreateTripIdsIndexErrorComponent = {
  attr: 'trip_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsBulkRejectCreateRejectedReasonErrorComponent = {
  attr: 'rejected_reason';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsBulkRejectCreateOverrideErrorComponent = {
  attr: 'override';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsBulkRejectCreateError =
  | ({
      attr: 'non_field_errors';
    } & TripsBulkRejectCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'trip_reasons';
    } & TripsBulkRejectCreateTripReasonsErrorComponent)
  | ({
      attr: 'trip_reasons.INDEX.non_field_errors';
    } & TripsBulkRejectCreateTripReasonsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'trip_reasons.INDEX.trip_id';
    } & TripsBulkRejectCreateTripReasonsIndexTripIdErrorComponent)
  | ({
      attr: 'trip_reasons.INDEX.rejected_reason';
    } & TripsBulkRejectCreateTripReasonsIndexRejectedReasonErrorComponent)
  | ({
      attr: 'trip_ids';
    } & TripsBulkRejectCreateTripIdsErrorComponent)
  | ({
      attr: 'trip_ids.INDEX';
    } & TripsBulkRejectCreateTripIdsIndexErrorComponent)
  | ({
      attr: 'rejected_reason';
    } & TripsBulkRejectCreateRejectedReasonErrorComponent)
  | ({
      attr: 'override';
    } & TripsBulkRejectCreateOverrideErrorComponent);
export type TripsBulkRejectCreateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsBulkRejectCreateError[];
};
export type TripsBulkRejectCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsBulkRejectCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TripRejectedReason = {
  trip_id: string;
  rejected_reason: string;
};
export type BulkTripReject = {
  trip_reasons?: TripRejectedReason[] | null;
  trip_ids?: string[] | null;
};
export type BulkTripRejectWrite = {
  trip_reasons?: TripRejectedReason[] | null;
  trip_ids?: string[] | null;
  rejected_reason?: string;
  override?: boolean;
};
export type TripsBulkTripEventsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsBulkTripEventsCreateTripIdsErrorComponent = {
  attr: 'trip_ids';
  code: 'empty' | 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type TripsBulkTripEventsCreateTripIdsIndexErrorComponent = {
  attr: 'trip_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsBulkTripEventsCreateError =
  | ({
      attr: 'non_field_errors';
    } & TripsBulkTripEventsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'trip_ids';
    } & TripsBulkTripEventsCreateTripIdsErrorComponent)
  | ({
      attr: 'trip_ids.INDEX';
    } & TripsBulkTripEventsCreateTripIdsIndexErrorComponent);
export type TripsBulkTripEventsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsBulkTripEventsCreateError[];
};
export type TripsBulkTripEventsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsBulkTripEventsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type BulkTripIdRequest = {
  trip_ids: string[];
};
export type BulkTripUnassignResults = {
  affected_trips: string[];
  unaffected_trips_locked: string[];
  unaffected_trips_status: string[];
};
export type TripsBulkUnassignCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsBulkUnassignCreateAssignmentIdErrorComponent = {
  attr: 'assignment_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsBulkUnassignCreateUnassignLockedTripsErrorComponent = {
  attr: 'unassign_locked_trips';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsBulkUnassignCreateError =
  | ({
      attr: 'non_field_errors';
    } & TripsBulkUnassignCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'assignment_id';
    } & TripsBulkUnassignCreateAssignmentIdErrorComponent)
  | ({
      attr: 'unassign_locked_trips';
    } & TripsBulkUnassignCreateUnassignLockedTripsErrorComponent);
export type TripsBulkUnassignCreateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsBulkUnassignCreateError[];
};
export type TripsBulkUnassignCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsBulkUnassignCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type BulkTripUnassign = {};
export type BulkTripUnassignWrite = {
  assignment_id: string;
  unassign_locked_trips?: boolean;
};
export type BulkInvalidTrip = {
  trip_id: string;
  explanation?: string[];
};
export type BulkTripValidateResults = {
  assignment_id: string;
  valid_trips: string[];
  invalid_trips?: BulkInvalidTrip[];
};
export type TripsBulkValidateCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsBulkValidateCreateAssignmentIdErrorComponent = {
  attr: 'assignment_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsBulkValidateCreateTripIdsErrorComponent = {
  attr: 'trip_ids';
  code: 'min_length' | 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type TripsBulkValidateCreateTripIdsIndexErrorComponent = {
  attr: 'trip_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsBulkValidateCreateIsMultiloadErrorComponent = {
  attr: 'is_multiload';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsBulkValidateCreateOrderedTripLocationDetailIdsErrorComponent =
  {
    attr: 'ordered_trip_location_detail_ids';
    code: 'min_length' | 'not_a_list';
    detail: string;
  };
export type TripsBulkValidateCreateOrderedTripLocationDetailIdsIndexErrorComponent =
  {
    attr: 'ordered_trip_location_detail_ids.INDEX';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsBulkValidateCreateResultsAssignmentIdErrorComponent = {
  attr: 'results.assignment_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsBulkValidateCreateResultsValidTripsErrorComponent = {
  attr: 'results.valid_trips';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type TripsBulkValidateCreateResultsValidTripsIndexErrorComponent = {
  attr: 'results.valid_trips.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsBulkValidateCreateResultsInvalidTripsErrorComponent = {
  attr: 'results.invalid_trips';
  code: 'not_a_list' | 'null';
  detail: string;
};
export type TripsBulkValidateCreateResultsInvalidTripsIndexNonFieldErrorsErrorComponent =
  {
    attr: 'results.invalid_trips.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsBulkValidateCreateResultsInvalidTripsIndexTripIdErrorComponent =
  {
    attr: 'results.invalid_trips.INDEX.trip_id';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsBulkValidateCreateResultsInvalidTripsIndexExplanationErrorComponent =
  {
    attr: 'results.invalid_trips.INDEX.explanation';
    code: 'not_a_list' | 'null';
    detail: string;
  };
export type TripsBulkValidateCreateResultsInvalidTripsIndexExplanationIndexErrorComponent =
  {
    attr: 'results.invalid_trips.INDEX.explanation.INDEX';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsBulkValidateCreateError =
  | ({
      attr: 'non_field_errors';
    } & TripsBulkValidateCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'assignment_id';
    } & TripsBulkValidateCreateAssignmentIdErrorComponent)
  | ({
      attr: 'trip_ids';
    } & TripsBulkValidateCreateTripIdsErrorComponent)
  | ({
      attr: 'trip_ids.INDEX';
    } & TripsBulkValidateCreateTripIdsIndexErrorComponent)
  | ({
      attr: 'is_multiload';
    } & TripsBulkValidateCreateIsMultiloadErrorComponent)
  | ({
      attr: 'ordered_trip_location_detail_ids';
    } & TripsBulkValidateCreateOrderedTripLocationDetailIdsErrorComponent)
  | ({
      attr: 'ordered_trip_location_detail_ids.INDEX';
    } & TripsBulkValidateCreateOrderedTripLocationDetailIdsIndexErrorComponent)
  | ({
      attr: 'results.assignment_id';
    } & TripsBulkValidateCreateResultsAssignmentIdErrorComponent)
  | ({
      attr: 'results.valid_trips';
    } & TripsBulkValidateCreateResultsValidTripsErrorComponent)
  | ({
      attr: 'results.valid_trips.INDEX';
    } & TripsBulkValidateCreateResultsValidTripsIndexErrorComponent)
  | ({
      attr: 'results.invalid_trips';
    } & TripsBulkValidateCreateResultsInvalidTripsErrorComponent)
  | ({
      attr: 'results.invalid_trips.INDEX.non_field_errors';
    } & TripsBulkValidateCreateResultsInvalidTripsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'results.invalid_trips.INDEX.trip_id';
    } & TripsBulkValidateCreateResultsInvalidTripsIndexTripIdErrorComponent)
  | ({
      attr: 'results.invalid_trips.INDEX.explanation';
    } & TripsBulkValidateCreateResultsInvalidTripsIndexExplanationErrorComponent)
  | ({
      attr: 'results.invalid_trips.INDEX.explanation.INDEX';
    } & TripsBulkValidateCreateResultsInvalidTripsIndexExplanationIndexErrorComponent);
export type TripsBulkValidateCreateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsBulkValidateCreateError[];
};
export type TripsBulkValidateCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsBulkValidateCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type BulkTripValidate = {};
export type BulkTripValidateRead = {
  results: BulkTripValidateResults;
};
export type BulkTripValidateWrite = {
  assignment_id: string;
  trip_ids: string[];
  is_multiload?: boolean;
  ordered_trip_location_detail_ids?: string[] | null;
};
export type TripImport = {
  trips: Trip[];
  import_batch_id?: number | null;
};
export type TripImportRead = {
  trips: TripRead[];
  import_batch_id?: number | null;
};
export type TripImportWrite = {
  trips: TripWrite[];
  import_batch_id?: number | null;
};
export type TripsImportCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsImportCreatePayerIdErrorComponent = {
  attr: 'payer_id';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsImportCreateTemplateKeyErrorComponent = {
  attr: 'template_key';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsImportCreateTripsFromCsvNonFieldErrorsErrorComponent = {
  attr: 'trips_from_csv.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsImportCreateTripsFromCsvRecordsNonFieldErrorsErrorComponent = {
  attr: 'trips_from_csv.records.non_field_errors';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type TripsImportCreateTripsFromCsvRecordsIndexNonFieldErrorsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexAssignmentStartErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.assignment.start';
    code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexAssignmentEndErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.assignment.end';
    code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPassengerNonFieldErrorsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPassengerIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.id';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPassengerFirstNameErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.first_name';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPassengerLastNameErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.last_name';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPassengerPreferredNameErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.preferred_name';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPassengerPronounErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.pronoun';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPassengerGenderErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.gender';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPassengerDobErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.dob';
    code: 'datetime' | 'invalid';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPassengerWeightErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.weight';
    code: 'invalid' | 'max_string_length' | 'min_value';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPassengerNeedsBariatricTransportErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.needs_bariatric_transport';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPassengerPhoneNumberErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.phone_number';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPassengerEmailErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.email';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPassengerNotesErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPassengerDispatcherNotesErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.dispatcher_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPassengerAllowSmsMessageErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.passenger.allow_sms_message';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerPayerErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.payer';
    code: 'does_not_exist' | 'incorrect_type';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerDisplayNameErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.display_name';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerAlternateNameErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.alternate_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerTypeErrorComponent = {
  attr: 'trips_from_csv.records.INDEX.payer.type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsImportCreateTripsFromCsvRecordsIndexPayerIsActiveErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.is_active';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerIsSelfPayErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.is_self_pay';
    code: 'invalid';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerCanMultiloadErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.can_multiload';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerExternalIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.external_id';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerWebsiteErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.website';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerEinErrorComponent = {
  attr: 'trips_from_csv.records.INDEX.payer.ein';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsImportCreateTripsFromCsvRecordsIndexPayerEmailErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.email';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerPhoneNumberErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerBillingNameErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.billing_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerBillingPhoneNumberErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.billing_phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerBillingEmailErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.billing_email';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerDispatcherNotesErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.dispatcher_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerAdminNotesErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.admin_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerDeletedAtErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.deleted_at';
    code: 'date' | 'invalid' | 'make_aware' | 'overflow';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerBillingAddressNonFieldErrorsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.billing_address.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerBillingAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.billing_address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerBillingAddressLocationPlaceIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.billing_address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerBillingAddressLabelErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.billing_address.label';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerBillingAddressLabel2ErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.billing_address.label2';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerBillingAddressAddressNotesErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.billing_address.address_notes';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerBillingAddressAddressTypeErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.billing_address.address_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressNonFieldErrorsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressLocationPlaceIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressLabelErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.label';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressLabel2ErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.label2';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressAddressNotesErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.address_notes';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressAddressTypeErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.address_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerMultiloadingPartnersNonFieldErrorsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.multiloading_partners.non_field_errors';
    code: 'not_a_list';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerMultiloadingPartnersIndexErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer.multiloading_partners.INDEX';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPayerIdErrorComponent = {
  attr: 'trips_from_csv.records.INDEX.payer_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsImportCreateTripsFromCsvRecordsIndexPayerPassengerExternalIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payer_passenger_external_id';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexExternalTripIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.external_trip_id';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexInputPriceCentsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.input_price_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPaymentMethodErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.payment_method';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexScheduledPickupAtErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.scheduled_pickup_at';
    code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPickupNonFieldErrorsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.pickup.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPickupAddressDetailsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.pickup.address_details';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPickupNumStairsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.pickup.num_stairs';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPickupStairEquipmentErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.pickup.stair_equipment';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPickupContactNameErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.pickup.contact_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPickupContactPhoneNumberErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.pickup.contact_phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPickupDriverNotesErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.pickup.driver_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPickupPlaceIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.pickup.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexDropoffNonFieldErrorsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.dropoff.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexDropoffAddressDetailsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.dropoff.address_details';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexDropoffNumStairsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.dropoff.num_stairs';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexDropoffStairEquipmentErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.dropoff.stair_equipment';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexDropoffContactNameErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.dropoff.contact_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexDropoffContactPhoneNumberErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.dropoff.contact_phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexDropoffDriverNotesErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.dropoff.driver_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexDropoffPlaceIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.dropoff.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexAppointmentAtErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.appointment_at';
    code: 'date' | 'invalid' | 'make_aware' | 'overflow';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexIsWillCallErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.is_will_call';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexSpaceTypeErrorComponent = {
  attr: 'trips_from_csv.records.INDEX.space_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type TripsImportCreateTripsFromCsvRecordsIndexMustProvideWheelchairErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.must_provide_wheelchair';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexServiceTypeErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.service_type';
    code: 'invalid_choice' | 'null' | 'required';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexDispatcherNotesErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.dispatcher_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexBillingNotesErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.billing_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexDriverEnteredNotesErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.driver_entered_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexIsOxygenRequiredErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.is_oxygen_required';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexOxygenLitersPerMinErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.oxygen_liters_per_min';
    code:
      | 'invalid'
      | 'max_decimal_places'
      | 'max_digits'
      | 'max_string_length'
      | 'max_whole_digits'
      | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexNumAttendantsNeededErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.num_attendants_needed';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexNumAccompanyingPassengersErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.num_accompanying_passengers';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexOneSchemaTemplateIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.one_schema_template_id';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexOneSchemaTemplateMultiIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.one_schema_template_multi_id';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexCorrelationIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.correlation_id';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexBookedByNameErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.booked_by_name';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexBookedByPhoneNumberErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.booked_by_phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexBookedByPhoneExtensionErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.booked_by_phone_extension';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexLoadTimeSecondsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.load_time_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexUnloadTimeSecondsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.unload_time_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexPickupWaitTimeSecondsErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.pickup_wait_time_seconds';
    code: 'invalid' | 'max_string_length' | 'min_value';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexTagIdsErrorComponent = {
  attr: 'trips_from_csv.records.INDEX.tag_ids';
  code: 'not_a_list';
  detail: string;
};
export type TripsImportCreateTripsFromCsvRecordsIndexTagIdsIndexErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.tag_ids.INDEX';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexTagsIndexTagNameErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.tags.INDEX.tag_name';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexTagsIndexColorHexErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.tags.INDEX.color_hex';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexAddedTagsErrorComponent = {
  attr: 'trips_from_csv.records.INDEX.added_tags';
  code: 'not_a_list';
  detail: string;
};
export type TripsImportCreateTripsFromCsvRecordsIndexAddedTagsIndexErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.added_tags.INDEX';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexIsWaitAndReturnOutboundErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.is_wait_and_return_outbound';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexIsWaitAndReturnInboundErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.is_wait_and_return_inbound';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexAuthorizationIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.authorization_id';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexInsurancePolicyIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.insurance_policy_id';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexIsPriceLockedErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.is_price_locked';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexLinkToPayerErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.link_to_payer';
    code: 'invalid_choice';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexConfirmationCodeErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.confirmation_code';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexIntermediaryErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.intermediary';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexHasInfectiousDiseaseErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.has_infectious_disease';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexSeatEquipmentErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.seat_equipment';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexShouldAvoidMultiloadErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.should_avoid_multiload';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsImportCreateTripsFromCsvRecordsIndexImportBatchIdErrorComponent =
  {
    attr: 'trips_from_csv.records.INDEX.import_batch_id';
    code: 'invalid' | 'max_string_length';
    detail: string;
  };
export type TripsImportCreateError =
  | ({
      attr: 'non_field_errors';
    } & TripsImportCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer_id';
    } & TripsImportCreatePayerIdErrorComponent)
  | ({
      attr: 'template_key';
    } & TripsImportCreateTemplateKeyErrorComponent)
  | ({
      attr: 'trips_from_csv.non_field_errors';
    } & TripsImportCreateTripsFromCsvNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.non_field_errors';
    } & TripsImportCreateTripsFromCsvRecordsNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.non_field_errors';
    } & TripsImportCreateTripsFromCsvRecordsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.assignment.start';
    } & TripsImportCreateTripsFromCsvRecordsIndexAssignmentStartErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.assignment.end';
    } & TripsImportCreateTripsFromCsvRecordsIndexAssignmentEndErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.non_field_errors';
    } & TripsImportCreateTripsFromCsvRecordsIndexPassengerNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.id';
    } & TripsImportCreateTripsFromCsvRecordsIndexPassengerIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.first_name';
    } & TripsImportCreateTripsFromCsvRecordsIndexPassengerFirstNameErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.last_name';
    } & TripsImportCreateTripsFromCsvRecordsIndexPassengerLastNameErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.preferred_name';
    } & TripsImportCreateTripsFromCsvRecordsIndexPassengerPreferredNameErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.pronoun';
    } & TripsImportCreateTripsFromCsvRecordsIndexPassengerPronounErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.gender';
    } & TripsImportCreateTripsFromCsvRecordsIndexPassengerGenderErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.dob';
    } & TripsImportCreateTripsFromCsvRecordsIndexPassengerDobErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.weight';
    } & TripsImportCreateTripsFromCsvRecordsIndexPassengerWeightErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.needs_bariatric_transport';
    } & TripsImportCreateTripsFromCsvRecordsIndexPassengerNeedsBariatricTransportErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.phone_number';
    } & TripsImportCreateTripsFromCsvRecordsIndexPassengerPhoneNumberErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.email';
    } & TripsImportCreateTripsFromCsvRecordsIndexPassengerEmailErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.notes';
    } & TripsImportCreateTripsFromCsvRecordsIndexPassengerNotesErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.dispatcher_notes';
    } & TripsImportCreateTripsFromCsvRecordsIndexPassengerDispatcherNotesErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.passenger.allow_sms_message';
    } & TripsImportCreateTripsFromCsvRecordsIndexPassengerAllowSmsMessageErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.payer';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerPayerErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.display_name';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerDisplayNameErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.alternate_name';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerAlternateNameErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.type';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerTypeErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.is_active';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerIsActiveErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.is_self_pay';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerIsSelfPayErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.can_multiload';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerCanMultiloadErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.external_id';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerExternalIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.website';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerWebsiteErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.ein';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerEinErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.email';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerEmailErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.phone_number';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerPhoneNumberErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.billing_name';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerBillingNameErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.billing_phone_number';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerBillingPhoneNumberErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.billing_email';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerBillingEmailErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.dispatcher_notes';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerDispatcherNotesErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.admin_notes';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerAdminNotesErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.deleted_at';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerDeletedAtErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.billing_address.non_field_errors';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerBillingAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.billing_address.location.non_field_errors';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerBillingAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.billing_address.location.place_id';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerBillingAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.billing_address.label';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerBillingAddressLabelErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.billing_address.label2';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerBillingAddressLabel2ErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.billing_address.address_notes';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerBillingAddressAddressNotesErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.billing_address.address_type';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerBillingAddressAddressTypeErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.non_field_errors';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.location.non_field_errors';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.location.place_id';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.label';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressLabelErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.label2';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressLabel2ErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.address_notes';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressAddressNotesErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.default_trip_address.address_type';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerDefaultTripAddressAddressTypeErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.multiloading_partners.non_field_errors';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerMultiloadingPartnersNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer.multiloading_partners.INDEX';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerMultiloadingPartnersIndexErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer_id';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payer_passenger_external_id';
    } & TripsImportCreateTripsFromCsvRecordsIndexPayerPassengerExternalIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.external_trip_id';
    } & TripsImportCreateTripsFromCsvRecordsIndexExternalTripIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.input_price_cents';
    } & TripsImportCreateTripsFromCsvRecordsIndexInputPriceCentsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.payment_method';
    } & TripsImportCreateTripsFromCsvRecordsIndexPaymentMethodErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.scheduled_pickup_at';
    } & TripsImportCreateTripsFromCsvRecordsIndexScheduledPickupAtErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.pickup.non_field_errors';
    } & TripsImportCreateTripsFromCsvRecordsIndexPickupNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.pickup.address_details';
    } & TripsImportCreateTripsFromCsvRecordsIndexPickupAddressDetailsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.pickup.num_stairs';
    } & TripsImportCreateTripsFromCsvRecordsIndexPickupNumStairsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.pickup.stair_equipment';
    } & TripsImportCreateTripsFromCsvRecordsIndexPickupStairEquipmentErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.pickup.contact_name';
    } & TripsImportCreateTripsFromCsvRecordsIndexPickupContactNameErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.pickup.contact_phone_number';
    } & TripsImportCreateTripsFromCsvRecordsIndexPickupContactPhoneNumberErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.pickup.driver_notes';
    } & TripsImportCreateTripsFromCsvRecordsIndexPickupDriverNotesErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.pickup.place_id';
    } & TripsImportCreateTripsFromCsvRecordsIndexPickupPlaceIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.dropoff.non_field_errors';
    } & TripsImportCreateTripsFromCsvRecordsIndexDropoffNonFieldErrorsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.dropoff.address_details';
    } & TripsImportCreateTripsFromCsvRecordsIndexDropoffAddressDetailsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.dropoff.num_stairs';
    } & TripsImportCreateTripsFromCsvRecordsIndexDropoffNumStairsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.dropoff.stair_equipment';
    } & TripsImportCreateTripsFromCsvRecordsIndexDropoffStairEquipmentErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.dropoff.contact_name';
    } & TripsImportCreateTripsFromCsvRecordsIndexDropoffContactNameErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.dropoff.contact_phone_number';
    } & TripsImportCreateTripsFromCsvRecordsIndexDropoffContactPhoneNumberErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.dropoff.driver_notes';
    } & TripsImportCreateTripsFromCsvRecordsIndexDropoffDriverNotesErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.dropoff.place_id';
    } & TripsImportCreateTripsFromCsvRecordsIndexDropoffPlaceIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.appointment_at';
    } & TripsImportCreateTripsFromCsvRecordsIndexAppointmentAtErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.is_will_call';
    } & TripsImportCreateTripsFromCsvRecordsIndexIsWillCallErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.space_type';
    } & TripsImportCreateTripsFromCsvRecordsIndexSpaceTypeErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.must_provide_wheelchair';
    } & TripsImportCreateTripsFromCsvRecordsIndexMustProvideWheelchairErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.service_type';
    } & TripsImportCreateTripsFromCsvRecordsIndexServiceTypeErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.dispatcher_notes';
    } & TripsImportCreateTripsFromCsvRecordsIndexDispatcherNotesErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.billing_notes';
    } & TripsImportCreateTripsFromCsvRecordsIndexBillingNotesErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.driver_entered_notes';
    } & TripsImportCreateTripsFromCsvRecordsIndexDriverEnteredNotesErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.is_oxygen_required';
    } & TripsImportCreateTripsFromCsvRecordsIndexIsOxygenRequiredErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.oxygen_liters_per_min';
    } & TripsImportCreateTripsFromCsvRecordsIndexOxygenLitersPerMinErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.num_attendants_needed';
    } & TripsImportCreateTripsFromCsvRecordsIndexNumAttendantsNeededErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.num_accompanying_passengers';
    } & TripsImportCreateTripsFromCsvRecordsIndexNumAccompanyingPassengersErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.one_schema_template_id';
    } & TripsImportCreateTripsFromCsvRecordsIndexOneSchemaTemplateIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.one_schema_template_multi_id';
    } & TripsImportCreateTripsFromCsvRecordsIndexOneSchemaTemplateMultiIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.correlation_id';
    } & TripsImportCreateTripsFromCsvRecordsIndexCorrelationIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.booked_by_name';
    } & TripsImportCreateTripsFromCsvRecordsIndexBookedByNameErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.booked_by_phone_number';
    } & TripsImportCreateTripsFromCsvRecordsIndexBookedByPhoneNumberErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.booked_by_phone_extension';
    } & TripsImportCreateTripsFromCsvRecordsIndexBookedByPhoneExtensionErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.load_time_seconds';
    } & TripsImportCreateTripsFromCsvRecordsIndexLoadTimeSecondsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.unload_time_seconds';
    } & TripsImportCreateTripsFromCsvRecordsIndexUnloadTimeSecondsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.pickup_wait_time_seconds';
    } & TripsImportCreateTripsFromCsvRecordsIndexPickupWaitTimeSecondsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.tag_ids';
    } & TripsImportCreateTripsFromCsvRecordsIndexTagIdsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.tag_ids.INDEX';
    } & TripsImportCreateTripsFromCsvRecordsIndexTagIdsIndexErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.tags.INDEX.tag_name';
    } & TripsImportCreateTripsFromCsvRecordsIndexTagsIndexTagNameErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.tags.INDEX.color_hex';
    } & TripsImportCreateTripsFromCsvRecordsIndexTagsIndexColorHexErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.added_tags';
    } & TripsImportCreateTripsFromCsvRecordsIndexAddedTagsErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.added_tags.INDEX';
    } & TripsImportCreateTripsFromCsvRecordsIndexAddedTagsIndexErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.is_wait_and_return_outbound';
    } & TripsImportCreateTripsFromCsvRecordsIndexIsWaitAndReturnOutboundErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.is_wait_and_return_inbound';
    } & TripsImportCreateTripsFromCsvRecordsIndexIsWaitAndReturnInboundErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.authorization_id';
    } & TripsImportCreateTripsFromCsvRecordsIndexAuthorizationIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.insurance_policy_id';
    } & TripsImportCreateTripsFromCsvRecordsIndexInsurancePolicyIdErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.is_price_locked';
    } & TripsImportCreateTripsFromCsvRecordsIndexIsPriceLockedErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.link_to_payer';
    } & TripsImportCreateTripsFromCsvRecordsIndexLinkToPayerErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.confirmation_code';
    } & TripsImportCreateTripsFromCsvRecordsIndexConfirmationCodeErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.intermediary';
    } & TripsImportCreateTripsFromCsvRecordsIndexIntermediaryErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.has_infectious_disease';
    } & TripsImportCreateTripsFromCsvRecordsIndexHasInfectiousDiseaseErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.seat_equipment';
    } & TripsImportCreateTripsFromCsvRecordsIndexSeatEquipmentErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.should_avoid_multiload';
    } & TripsImportCreateTripsFromCsvRecordsIndexShouldAvoidMultiloadErrorComponent)
  | ({
      attr: 'trips_from_csv.records.INDEX.import_batch_id';
    } & TripsImportCreateTripsFromCsvRecordsIndexImportBatchIdErrorComponent);
export type TripsImportCreateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsImportCreateError[];
};
export type TripsImportCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsImportCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type OneSchemaData = {
  records: Trip[];
};
export type OneSchemaDataRead = {
  records: TripRead[];
};
export type OneSchemaDataWrite = {
  records: TripWrite[];
};
export type TripImportViewSet = {
  payer_id?: string;
  template_key: string;
  trips_from_csv: OneSchemaData;
};
export type TripImportViewSetRead = {
  payer_id?: string;
  template_key: string;
  trips_from_csv: OneSchemaDataRead;
};
export type TripImportViewSetWrite = {
  payer_id?: string;
  template_key: string;
  trips_from_csv: OneSchemaDataWrite;
};
export type MtmDriverManifestTrip = {};
export type MtmDriverManifestTripRead = {
  trip_number: string;
  member_name: string;
  am_or_pm: string;
  scheduled_pickup_time: string;
  pickup_arrival_time: string;
  pickup_departure_time: string;
  dropoff_time: string;
  member_signature_url: string;
};
export type MtmDriverManifest = {
  transportation_provider: string;
  trips: MtmDriverManifestTrip[];
};
export type MtmDriverManifestRead = {
  transportation_provider: string;
  date_of_service: string;
  driver_license_number: string;
  vin_last_5_digits: string;
  driver_signature_url: string;
  driver_name: string;
  trips: MtmDriverManifestTripRead[];
};
export type PaginatedMtmDriverManifestList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: MtmDriverManifest[];
};
export type PaginatedMtmDriverManifestListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: MtmDriverManifestRead[];
};
export type TripsMtmDriverManifestListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type OrderedMultiloadTripLocationDetail = {
  trip_location_detail_id: string;
  order: number;
};
export type Multiload = {
  /** Notes about this multiload */
  notes?: string;
  multiload_trip_location_details: OrderedMultiloadTripLocationDetail[];
  deleted_at?: string | null;
};
export type MultiloadRead = {
  id: string;
  organization_id: string;
  /** Notes about this multiload */
  notes?: string;
  multiload_trip_location_details: OrderedMultiloadTripLocationDetail[];
  created_at: string;
  updated_at: string;
  deleted_at?: string | null;
};
export type PaginatedMultiloadList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: Multiload[];
};
export type PaginatedMultiloadListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: MultiloadRead[];
};
export type TripsMultiloadListErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripsMultiloadCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsMultiloadCreateNotesErrorComponent = {
  attr: 'notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsMultiloadCreateMultiloadTripLocationDetailsNonFieldErrorsErrorComponent =
  {
    attr: 'multiload_trip_location_details.non_field_errors';
    code: 'not_a_list' | 'null' | 'required';
    detail: string;
  };
export type TripsMultiloadCreateMultiloadTripLocationDetailsIndexNonFieldErrorsErrorComponent =
  {
    attr: 'multiload_trip_location_details.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsMultiloadCreateMultiloadTripLocationDetailsIndexTripLocationDetailIdErrorComponent =
  {
    attr: 'multiload_trip_location_details.INDEX.trip_location_detail_id';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsMultiloadCreateMultiloadTripLocationDetailsIndexOrderErrorComponent =
  {
    attr: 'multiload_trip_location_details.INDEX.order';
    code:
      | 'invalid'
      | 'max_string_length'
      | 'max_value'
      | 'min_value'
      | 'null'
      | 'required';
    detail: string;
  };
export type TripsMultiloadCreateDeletedAtErrorComponent = {
  attr: 'deleted_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type TripsMultiloadCreateError =
  | ({
      attr: 'non_field_errors';
    } & TripsMultiloadCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'notes';
    } & TripsMultiloadCreateNotesErrorComponent)
  | ({
      attr: 'multiload_trip_location_details.non_field_errors';
    } & TripsMultiloadCreateMultiloadTripLocationDetailsNonFieldErrorsErrorComponent)
  | ({
      attr: 'multiload_trip_location_details.INDEX.non_field_errors';
    } & TripsMultiloadCreateMultiloadTripLocationDetailsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'multiload_trip_location_details.INDEX.trip_location_detail_id';
    } & TripsMultiloadCreateMultiloadTripLocationDetailsIndexTripLocationDetailIdErrorComponent)
  | ({
      attr: 'multiload_trip_location_details.INDEX.order';
    } & TripsMultiloadCreateMultiloadTripLocationDetailsIndexOrderErrorComponent)
  | ({
      attr: 'deleted_at';
    } & TripsMultiloadCreateDeletedAtErrorComponent);
export type TripsMultiloadCreateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsMultiloadCreateError[];
};
export type TripsMultiloadCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsMultiloadCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TripsMultiloadRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripsMultiloadPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsMultiloadPartialUpdateNotesErrorComponent = {
  attr: 'notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsMultiloadPartialUpdateMultiloadTripLocationDetailsNonFieldErrorsErrorComponent =
  {
    attr: 'multiload_trip_location_details.non_field_errors';
    code: 'not_a_list' | 'null' | 'required';
    detail: string;
  };
export type TripsMultiloadPartialUpdateMultiloadTripLocationDetailsIndexNonFieldErrorsErrorComponent =
  {
    attr: 'multiload_trip_location_details.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsMultiloadPartialUpdateMultiloadTripLocationDetailsIndexTripLocationDetailIdErrorComponent =
  {
    attr: 'multiload_trip_location_details.INDEX.trip_location_detail_id';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsMultiloadPartialUpdateMultiloadTripLocationDetailsIndexOrderErrorComponent =
  {
    attr: 'multiload_trip_location_details.INDEX.order';
    code:
      | 'invalid'
      | 'max_string_length'
      | 'max_value'
      | 'min_value'
      | 'null'
      | 'required';
    detail: string;
  };
export type TripsMultiloadPartialUpdateDeletedAtErrorComponent = {
  attr: 'deleted_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type TripsMultiloadPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & TripsMultiloadPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'notes';
    } & TripsMultiloadPartialUpdateNotesErrorComponent)
  | ({
      attr: 'multiload_trip_location_details.non_field_errors';
    } & TripsMultiloadPartialUpdateMultiloadTripLocationDetailsNonFieldErrorsErrorComponent)
  | ({
      attr: 'multiload_trip_location_details.INDEX.non_field_errors';
    } & TripsMultiloadPartialUpdateMultiloadTripLocationDetailsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'multiload_trip_location_details.INDEX.trip_location_detail_id';
    } & TripsMultiloadPartialUpdateMultiloadTripLocationDetailsIndexTripLocationDetailIdErrorComponent)
  | ({
      attr: 'multiload_trip_location_details.INDEX.order';
    } & TripsMultiloadPartialUpdateMultiloadTripLocationDetailsIndexOrderErrorComponent)
  | ({
      attr: 'deleted_at';
    } & TripsMultiloadPartialUpdateDeletedAtErrorComponent);
export type TripsMultiloadPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsMultiloadPartialUpdateError[];
};
export type TripsMultiloadPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsMultiloadPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedMultiload = {
  /** Notes about this multiload */
  notes?: string;
  multiload_trip_location_details?: OrderedMultiloadTripLocationDetail[];
  deleted_at?: string | null;
};
export type PatchedMultiloadRead = {
  id?: string;
  organization_id?: string;
  /** Notes about this multiload */
  notes?: string;
  multiload_trip_location_details?: OrderedMultiloadTripLocationDetail[];
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;
};
export type TripsMultiloadDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type MultiloadMobile = {};
export type MultiloadPassengerMobile = {};
export type MultiloadPassengerMobileRead = {
  id: string;
  first_name: string;
  last_name: string;
};
export type AssignmentTripLocationDetail = {
  id?: string;
  /** Purpose of this location, pickup, dropoff, etc. */
  purpose: PurposeEnum;
  /** The number of stairs at this location */
  num_stairs?: number;
  /** Stair equipment required for this location */
  stair_equipment?: StairEquipmentEnum | BlankEnum;
  /** Name of contact for this location, if not passenger */
  contact_name?: string;
  /** Phone number of contact for this location, if not passenger */
  contact_phone_number?: string | null;
  /** Notes visible to the driver for this location */
  driver_notes?: string;
};
export type AssignmentTripLocation = {
  /** numerical portion of address, ex. 5C */
  address_number?: string;
  /** ISO 3166 3-digit country/region code, ex. CAN */
  country?: string;
  /** local area, ex. Toronto */
  municipality?: string;
  /** community/district, ex. downtown */
  neighborhood?: string;
  /** letters/numbers in country-specific format */
  postal_code?: string;
  region?: string;
  sub_region?: string;
  street?: string;
  unit_number?: string;
  /** ex., apartment */
  unit_type?: string;
  latitude: number;
  longitude: number;
};
export type AssignmentTripLocationRead = {
  /** numerical portion of address, ex. 5C */
  address_number?: string;
  /** ISO 3166 3-digit country/region code, ex. CAN */
  country?: string;
  /** The full address or geolocation label */
  label: string;
  detail: string;
  /** local area, ex. Toronto */
  municipality?: string;
  /** community/district, ex. downtown */
  neighborhood?: string;
  /** letters/numbers in country-specific format */
  postal_code?: string;
  region?: string;
  sub_region?: string;
  street?: string;
  unit_number?: string;
  /** ex., apartment */
  unit_type?: string;
  latitude: number;
  longitude: number;
  /** Whether or not the location is the result of an AWS geolookup operation. */
  is_geocoded: boolean;
};
export type AssignmentTripLocationDetailRead = {
  id?: string;
  /** Purpose of this location, pickup, dropoff, etc. */
  purpose: PurposeEnum;
  location: AssignmentTripLocationRead;
  /** The number of stairs at this location */
  num_stairs?: number;
  /** Stair equipment required for this location */
  stair_equipment?: StairEquipmentEnum | BlankEnum;
  /** Name of contact for this location, if not passenger */
  contact_name?: string;
  /** Phone number of contact for this location, if not passenger */
  contact_phone_number?: string | null;
  /** Notes visible to the driver for this location */
  driver_notes?: string;
};
export type MultiloadStepMobile = {
  trip_id: string;
  passenger: MultiloadPassengerMobile;
  location_detail: AssignmentTripLocationDetail;
};
export type MultiloadStepMobileRead = {
  order: number;
  trip_id: string;
  trip_status: OverrideStatusEnum;
  passenger: MultiloadPassengerMobileRead;
  location_detail: AssignmentTripLocationDetailRead;
};
export type MultiloadMobileRead = {
  id: string;
  /** Notes about this multiload */
  notes: string;
  steps: MultiloadStepMobileRead[];
};
export type TripsMultiloadMobileRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripRequestedCount = {
  count: number;
};
export type TripsRequestedCountRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripRecurrence = {
  is_round_trip?: boolean;
  is_will_call?: boolean;
  /** The rrule (RFC5545) */
  rrule: string;
  /** The manually inputted price of the trip */
  input_price_cents?: number | null;
  scheduled_pickup_time: string;
  appointment_time?: string;
};
export type TripSubscriptionList = {
  passenger: PatchedTripPassenger;
  /** Notes only visible to the dispatcher */
  dispatcher_notes?: string;
  recurrences: TripRecurrence[];
  /** When the recurrences start applying (inclusive) */
  start_date: string;
  /** When the recurrences stop applying (exclusive) */
  expires_at: string;
  pickup: TripLocationDetail;
  dropoff: TripLocationDetail;
};
export type TripSubscriptionListRead = {
  id: string;
  passenger: PatchedTripPassengerRead;
  /** Notes only visible to the dispatcher */
  dispatcher_notes?: string;
  recurrences: TripRecurrence[];
  /** When the recurrences start applying (inclusive) */
  start_date: string;
  /** When the recurrences stop applying (exclusive) */
  expires_at: string;
  pickup: TripLocationDetailRead;
  dropoff: TripLocationDetailRead;
};
export type PaginatedTripSubscriptionListList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TripSubscriptionList[];
};
export type PaginatedTripSubscriptionListListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: TripSubscriptionListRead[];
};
export type TripsSubscriptionsListRangeStartErrorComponent = {
  attr: 'range_start';
  code: 'invalid';
  detail: string;
};
export type TripsSubscriptionsListRangeEndErrorComponent = {
  attr: 'range_end';
  code: 'invalid';
  detail: string;
};
export type TripsSubscriptionsListPayersErrorComponent = {
  attr: 'payers';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsListError =
  | ({
      attr: 'range_start';
    } & TripsSubscriptionsListRangeStartErrorComponent)
  | ({
      attr: 'range_end';
    } & TripsSubscriptionsListRangeEndErrorComponent)
  | ({
      attr: 'payers';
    } & TripsSubscriptionsListPayersErrorComponent);
export type TripsSubscriptionsListValidationError = {
  type: ValidationErrorEnum;
  errors: TripsSubscriptionsListError[];
};
export type TripsSubscriptionsListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsSubscriptionsListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TripSubscription = {
  /** Notes only visible to the dispatcher */
  dispatcher_notes?: string;
  /** Notes about the trip for billing purposes */
  billing_notes?: string;
  dropoff: TripLocationDetail;
  estimated_distance_miles?: number | null;
  estimated_load_seconds?: number | null;
  estimated_unload_seconds?: number | null;
  /** When the recurrences stop applying (exclusive) */
  expires_at: string;
  is_oxygen_required?: boolean;
  load_time_seconds?: number;
  /** How many additional people will be accompanying the primary passenger */
  num_accompanying_passengers?: number;
  num_attendants_needed?: number;
  oxygen_liters_per_min?: string;
  passenger: PatchedTripPassenger;
  payment_method?: PaymentMethodEnum | BlankEnum;
  pickup: TripLocationDetail;
  pickup_wait_time_seconds?: number;
  recurrences: TripRecurrence[];
  /** Whether the passenger will supply their own wheelchair or not */
  must_provide_wheelchair?: boolean;
  service_type: ServiceTypeEnum;
  /** The type of space in the vehicle this passenger will need */
  space_type: SpaceTypeEnum;
  /** When the recurrences start applying (inclusive) */
  start_date: string;
  unload_time_seconds?: number;
  /** Whether the passenger has an infectious disease */
  has_infectious_disease?: boolean;
  /** Who booked this trip, if not passenger */
  booked_by_name?: string;
  /** Phone number of who booked this trip, if not passenger */
  booked_by_phone_number?: string | null;
  /** Phone number extension of who booked this trip, if not passenger */
  booked_by_phone_extension?: string;
  /** The authorization ID for this trip */
  authorization_id?: string;
  /** The insurance policy ID for this trip */
  insurance_policy_id?: string;
  /** The seat equipment needed for this trip */
  seat_equipment?: SeatEquipmentEnum | BlankEnum;
  /** Whether this trip should avoid being multiloaded with other passengers */
  should_avoid_multiload?: boolean;
};
export type TripSubscriptionTrip = {
  passenger_initials: string;
  pickup_datetime: string;
  from_address: string;
  to_address: string;
  key: string;
};
export type TripTripSubscriptionTag = {
  tag_name: string;
  color_hex: string;
};
export type TripTripSubscriptionTagRead = {
  id: string;
  tag: string;
  tag_name: string;
  color_hex: string;
  created_at: string;
  updated_at: string;
};
export type TripSubscriptionRead = {
  /** Notes only visible to the dispatcher */
  dispatcher_notes?: string;
  /** Notes about the trip for billing purposes */
  billing_notes?: string;
  dropoff: TripLocationDetailRead;
  estimated_distance_miles?: number | null;
  estimated_load_seconds?: number | null;
  estimated_unload_seconds?: number | null;
  /** When the recurrences stop applying (exclusive) */
  expires_at: string;
  id: string;
  is_oxygen_required?: boolean;
  load_time_seconds?: number;
  /** How many additional people will be accompanying the primary passenger */
  num_accompanying_passengers?: number;
  num_attendants_needed?: number;
  oxygen_liters_per_min?: string;
  passenger: PatchedTripPassengerRead;
  payer: PayerOrganizationRead;
  payer_passenger: TripPayerPassengerRead;
  payment_method?: PaymentMethodEnum | BlankEnum;
  pickup: TripLocationDetailRead;
  pickup_wait_time_seconds?: number;
  recurrences: TripRecurrence[];
  /** Whether the passenger will supply their own wheelchair or not */
  must_provide_wheelchair?: boolean;
  service_type: ServiceTypeEnum;
  /** The type of space in the vehicle this passenger will need */
  space_type: SpaceTypeEnum;
  /** When the recurrences start applying (inclusive) */
  start_date: string;
  unload_time_seconds?: number;
  old_trips: TripSubscriptionTrip[];
  new_trips: TripSubscriptionTrip[];
  /** Whether the passenger has an infectious disease */
  has_infectious_disease?: boolean;
  /** Who booked this trip, if not passenger */
  booked_by_name?: string;
  /** Phone number of who booked this trip, if not passenger */
  booked_by_phone_number?: string | null;
  /** Phone number extension of who booked this trip, if not passenger */
  booked_by_phone_extension?: string;
  tags: TripTripSubscriptionTagRead[] | null;
  /** The authorization ID for this trip */
  authorization_id?: string;
  /** The insurance policy ID for this trip */
  insurance_policy_id?: string;
  /** The seat equipment needed for this trip */
  seat_equipment?: SeatEquipmentEnum | BlankEnum;
  /** Whether this trip should avoid being multiloaded with other passengers */
  should_avoid_multiload?: boolean;
};
export type TripSubscriptionWrite = {
  /** Notes only visible to the dispatcher */
  dispatcher_notes?: string;
  /** Notes about the trip for billing purposes */
  billing_notes?: string;
  dropoff: TripLocationDetail;
  estimated_distance_miles?: number | null;
  estimated_load_seconds?: number | null;
  estimated_unload_seconds?: number | null;
  /** When the recurrences stop applying (exclusive) */
  expires_at: string;
  is_oxygen_required?: boolean;
  load_time_seconds?: number;
  /** How many additional people will be accompanying the primary passenger */
  num_accompanying_passengers?: number;
  num_attendants_needed?: number;
  oxygen_liters_per_min?: string;
  passenger: PatchedTripPassenger;
  payer_id: string;
  payer_passenger_external_id?: string;
  payment_method?: PaymentMethodEnum | BlankEnum;
  pickup: TripLocationDetail;
  pickup_wait_time_seconds?: number;
  recurrences: TripRecurrence[];
  /** Whether the passenger will supply their own wheelchair or not */
  must_provide_wheelchair?: boolean;
  service_type: ServiceTypeEnum;
  /** The type of space in the vehicle this passenger will need */
  space_type: SpaceTypeEnum;
  /** When the recurrences start applying (inclusive) */
  start_date: string;
  unload_time_seconds?: number;
  /** Whether the passenger has an infectious disease */
  has_infectious_disease?: boolean;
  /** Who booked this trip, if not passenger */
  booked_by_name?: string;
  /** Phone number of who booked this trip, if not passenger */
  booked_by_phone_number?: string | null;
  /** Phone number extension of who booked this trip, if not passenger */
  booked_by_phone_extension?: string;
  tag_ids?: string[] | null;
  /** The authorization ID for this trip */
  authorization_id?: string;
  /** The insurance policy ID for this trip */
  insurance_policy_id?: string;
  /** The seat equipment needed for this trip */
  seat_equipment?: SeatEquipmentEnum | BlankEnum;
  /** Whether this trip should avoid being multiloaded with other passengers */
  should_avoid_multiload?: boolean;
};
export type TripsSubscriptionsCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsSubscriptionsCreateDispatcherNotesErrorComponent = {
  attr: 'dispatcher_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreateBillingNotesErrorComponent = {
  attr: 'billing_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreateDropoffNonFieldErrorsErrorComponent = {
  attr: 'dropoff.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsSubscriptionsCreateDropoffAddressDetailsErrorComponent = {
  attr: 'dropoff.address_details';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreateDropoffNumStairsErrorComponent = {
  attr: 'dropoff.num_stairs';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
  detail: string;
};
export type TripsSubscriptionsCreateDropoffStairEquipmentErrorComponent = {
  attr: 'dropoff.stair_equipment';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsSubscriptionsCreateDropoffContactNameErrorComponent = {
  attr: 'dropoff.contact_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreateDropoffContactPhoneNumberErrorComponent = {
  attr: 'dropoff.contact_phone_number';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreateDropoffDriverNotesErrorComponent = {
  attr: 'dropoff.driver_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreateDropoffPlaceIdErrorComponent = {
  attr: 'dropoff.place_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreateEstimatedDistanceMilesErrorComponent = {
  attr: 'estimated_distance_miles';
  code: 'invalid' | 'max_string_length';
  detail: string;
};
export type TripsSubscriptionsCreateEstimatedLoadSecondsErrorComponent = {
  attr: 'estimated_load_seconds';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type TripsSubscriptionsCreateEstimatedUnloadSecondsErrorComponent = {
  attr: 'estimated_unload_seconds';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
  detail: string;
};
export type TripsSubscriptionsCreateExpiresAtErrorComponent = {
  attr: 'expires_at';
  code: 'datetime' | 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsSubscriptionsCreateIsOxygenRequiredErrorComponent = {
  attr: 'is_oxygen_required';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsSubscriptionsCreateLoadTimeSecondsErrorComponent = {
  attr: 'load_time_seconds';
  code: 'invalid' | 'max_string_length' | 'min_value' | 'null';
  detail: string;
};
export type TripsSubscriptionsCreateNumAccompanyingPassengersErrorComponent = {
  attr: 'num_accompanying_passengers';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
  detail: string;
};
export type TripsSubscriptionsCreateNumAttendantsNeededErrorComponent = {
  attr: 'num_attendants_needed';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
  detail: string;
};
export type TripsSubscriptionsCreateOxygenLitersPerMinErrorComponent = {
  attr: 'oxygen_liters_per_min';
  code:
    | 'invalid'
    | 'max_decimal_places'
    | 'max_digits'
    | 'max_string_length'
    | 'max_whole_digits'
    | 'null';
  detail: string;
};
export type TripsSubscriptionsCreatePassengerNonFieldErrorsErrorComponent = {
  attr: 'passenger.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsSubscriptionsCreatePassengerIdErrorComponent = {
  attr: 'passenger.id';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsSubscriptionsCreatePassengerFirstNameErrorComponent = {
  attr: 'passenger.first_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePassengerLastNameErrorComponent = {
  attr: 'passenger.last_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePassengerPreferredNameErrorComponent = {
  attr: 'passenger.preferred_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePassengerPronounErrorComponent = {
  attr: 'passenger.pronoun';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePassengerGenderErrorComponent = {
  attr: 'passenger.gender';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePassengerDobErrorComponent = {
  attr: 'passenger.dob';
  code: 'datetime' | 'invalid';
  detail: string;
};
export type TripsSubscriptionsCreatePassengerWeightErrorComponent = {
  attr: 'passenger.weight';
  code: 'invalid' | 'max_string_length' | 'min_value';
  detail: string;
};
export type TripsSubscriptionsCreatePassengerNeedsBariatricTransportErrorComponent =
  {
    attr: 'passenger.needs_bariatric_transport';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsSubscriptionsCreatePassengerPhoneNumberErrorComponent = {
  attr: 'passenger.phone_number';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePassengerEmailErrorComponent = {
  attr: 'passenger.email';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePassengerNotesErrorComponent = {
  attr: 'passenger.notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePassengerDispatcherNotesErrorComponent = {
  attr: 'passenger.dispatcher_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePassengerAllowSmsMessageErrorComponent = {
  attr: 'passenger.allow_sms_message';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsSubscriptionsCreatePayerPayerErrorComponent = {
  attr: 'payer.payer';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type TripsSubscriptionsCreatePayerDisplayNameErrorComponent = {
  attr: 'payer.display_name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePayerAlternateNameErrorComponent = {
  attr: 'payer.alternate_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePayerTypeErrorComponent = {
  attr: 'payer.type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsSubscriptionsCreatePayerIsActiveErrorComponent = {
  attr: 'payer.is_active';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsSubscriptionsCreatePayerIsSelfPayErrorComponent = {
  attr: 'payer.is_self_pay';
  code: 'invalid';
  detail: string;
};
export type TripsSubscriptionsCreatePayerCanMultiloadErrorComponent = {
  attr: 'payer.can_multiload';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsSubscriptionsCreatePayerExternalIdErrorComponent = {
  attr: 'payer.external_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePayerWebsiteErrorComponent = {
  attr: 'payer.website';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePayerEinErrorComponent = {
  attr: 'payer.ein';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePayerEmailErrorComponent = {
  attr: 'payer.email';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePayerPhoneNumberErrorComponent = {
  attr: 'payer.phone_number';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePayerBillingNameErrorComponent = {
  attr: 'payer.billing_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePayerBillingPhoneNumberErrorComponent = {
  attr: 'payer.billing_phone_number';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePayerBillingEmailErrorComponent = {
  attr: 'payer.billing_email';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePayerDispatcherNotesErrorComponent = {
  attr: 'payer.dispatcher_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePayerAdminNotesErrorComponent = {
  attr: 'payer.admin_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePayerDeletedAtErrorComponent = {
  attr: 'payer.deleted_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type TripsSubscriptionsCreatePayerBillingAddressNonFieldErrorsErrorComponent =
  {
    attr: 'payer.billing_address.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type TripsSubscriptionsCreatePayerBillingAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'payer.billing_address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsSubscriptionsCreatePayerBillingAddressLocationPlaceIdErrorComponent =
  {
    attr: 'payer.billing_address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsCreatePayerBillingAddressLabelErrorComponent = {
  attr: 'payer.billing_address.label';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePayerBillingAddressLabel2ErrorComponent = {
  attr: 'payer.billing_address.label2';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePayerBillingAddressAddressNotesErrorComponent =
  {
    attr: 'payer.billing_address.address_notes';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsCreatePayerBillingAddressAddressTypeErrorComponent =
  {
    attr: 'payer.billing_address.address_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsSubscriptionsCreatePayerDefaultTripAddressNonFieldErrorsErrorComponent =
  {
    attr: 'payer.default_trip_address.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type TripsSubscriptionsCreatePayerDefaultTripAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'payer.default_trip_address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsSubscriptionsCreatePayerDefaultTripAddressLocationPlaceIdErrorComponent =
  {
    attr: 'payer.default_trip_address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsCreatePayerDefaultTripAddressLabelErrorComponent =
  {
    attr: 'payer.default_trip_address.label';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsCreatePayerDefaultTripAddressLabel2ErrorComponent =
  {
    attr: 'payer.default_trip_address.label2';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsCreatePayerDefaultTripAddressAddressNotesErrorComponent =
  {
    attr: 'payer.default_trip_address.address_notes';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsCreatePayerDefaultTripAddressAddressTypeErrorComponent =
  {
    attr: 'payer.default_trip_address.address_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsSubscriptionsCreatePayerMultiloadingPartnersNonFieldErrorsErrorComponent =
  {
    attr: 'payer.multiloading_partners.non_field_errors';
    code: 'not_a_list';
    detail: string;
  };
export type TripsSubscriptionsCreatePayerMultiloadingPartnersIndexErrorComponent =
  {
    attr: 'payer.multiloading_partners.INDEX';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsSubscriptionsCreatePayerIdErrorComponent = {
  attr: 'payer_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsSubscriptionsCreatePayerPassengerExternalIdErrorComponent = {
  attr: 'payer_passenger_external_id';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePaymentMethodErrorComponent = {
  attr: 'payment_method';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsSubscriptionsCreatePickupNonFieldErrorsErrorComponent = {
  attr: 'pickup.non_field_errors';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsSubscriptionsCreatePickupAddressDetailsErrorComponent = {
  attr: 'pickup.address_details';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePickupNumStairsErrorComponent = {
  attr: 'pickup.num_stairs';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
  detail: string;
};
export type TripsSubscriptionsCreatePickupStairEquipmentErrorComponent = {
  attr: 'pickup.stair_equipment';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsSubscriptionsCreatePickupContactNameErrorComponent = {
  attr: 'pickup.contact_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePickupContactPhoneNumberErrorComponent = {
  attr: 'pickup.contact_phone_number';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePickupDriverNotesErrorComponent = {
  attr: 'pickup.driver_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePickupPlaceIdErrorComponent = {
  attr: 'pickup.place_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreatePickupWaitTimeSecondsErrorComponent = {
  attr: 'pickup_wait_time_seconds';
  code: 'invalid' | 'max_string_length' | 'min_value' | 'null';
  detail: string;
};
export type TripsSubscriptionsCreateRecurrencesNonFieldErrorsErrorComponent = {
  attr: 'recurrences.non_field_errors';
  code: 'not_a_list' | 'null' | 'required';
  detail: string;
};
export type TripsSubscriptionsCreateRecurrencesIndexNonFieldErrorsErrorComponent =
  {
    attr: 'recurrences.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsSubscriptionsCreateRecurrencesIndexIsRoundTripErrorComponent =
  {
    attr: 'recurrences.INDEX.is_round_trip';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsSubscriptionsCreateRecurrencesIndexIsWillCallErrorComponent = {
  attr: 'recurrences.INDEX.is_will_call';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsSubscriptionsCreateRecurrencesIndexRruleErrorComponent = {
  attr: 'recurrences.INDEX.rrule';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreateRecurrencesIndexInputPriceCentsErrorComponent =
  {
    attr: 'recurrences.INDEX.input_price_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type TripsSubscriptionsCreateRecurrencesIndexScheduledPickupTimeErrorComponent =
  {
    attr: 'recurrences.INDEX.scheduled_pickup_time';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsSubscriptionsCreateRecurrencesIndexAppointmentTimeErrorComponent =
  {
    attr: 'recurrences.INDEX.appointment_time';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsSubscriptionsCreateMustProvideWheelchairErrorComponent = {
  attr: 'must_provide_wheelchair';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsSubscriptionsCreateServiceTypeErrorComponent = {
  attr: 'service_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type TripsSubscriptionsCreateSpaceTypeErrorComponent = {
  attr: 'space_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type TripsSubscriptionsCreateStartDateErrorComponent = {
  attr: 'start_date';
  code: 'datetime' | 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsSubscriptionsCreateUnloadTimeSecondsErrorComponent = {
  attr: 'unload_time_seconds';
  code: 'invalid' | 'max_string_length' | 'min_value' | 'null';
  detail: string;
};
export type TripsSubscriptionsCreateOldTripsIndexNonFieldErrorsErrorComponent =
  {
    attr: 'old_trips.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsSubscriptionsCreateOldTripsIndexPassengerInitialsErrorComponent =
  {
    attr: 'old_trips.INDEX.passenger_initials';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsCreateOldTripsIndexPickupDatetimeErrorComponent =
  {
    attr: 'old_trips.INDEX.pickup_datetime';
    code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
    detail: string;
  };
export type TripsSubscriptionsCreateOldTripsIndexFromAddressErrorComponent = {
  attr: 'old_trips.INDEX.from_address';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreateOldTripsIndexToAddressErrorComponent = {
  attr: 'old_trips.INDEX.to_address';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreateOldTripsIndexKeyErrorComponent = {
  attr: 'old_trips.INDEX.key';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreateNewTripsIndexNonFieldErrorsErrorComponent =
  {
    attr: 'new_trips.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsSubscriptionsCreateNewTripsIndexPassengerInitialsErrorComponent =
  {
    attr: 'new_trips.INDEX.passenger_initials';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsCreateNewTripsIndexPickupDatetimeErrorComponent =
  {
    attr: 'new_trips.INDEX.pickup_datetime';
    code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
    detail: string;
  };
export type TripsSubscriptionsCreateNewTripsIndexFromAddressErrorComponent = {
  attr: 'new_trips.INDEX.from_address';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreateNewTripsIndexToAddressErrorComponent = {
  attr: 'new_trips.INDEX.to_address';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreateNewTripsIndexKeyErrorComponent = {
  attr: 'new_trips.INDEX.key';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreateHasInfectiousDiseaseErrorComponent = {
  attr: 'has_infectious_disease';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsSubscriptionsCreateBookedByNameErrorComponent = {
  attr: 'booked_by_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreateBookedByPhoneNumberErrorComponent = {
  attr: 'booked_by_phone_number';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreateBookedByPhoneExtensionErrorComponent = {
  attr: 'booked_by_phone_extension';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreateTagIdsErrorComponent = {
  attr: 'tag_ids';
  code: 'not_a_list';
  detail: string;
};
export type TripsSubscriptionsCreateTagIdsIndexErrorComponent = {
  attr: 'tag_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsSubscriptionsCreateTagsIndexTagNameErrorComponent = {
  attr: 'tags.INDEX.tag_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreateTagsIndexColorHexErrorComponent = {
  attr: 'tags.INDEX.color_hex';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreateAuthorizationIdErrorComponent = {
  attr: 'authorization_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreateInsurancePolicyIdErrorComponent = {
  attr: 'insurance_policy_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsCreateSeatEquipmentErrorComponent = {
  attr: 'seat_equipment';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsSubscriptionsCreateShouldAvoidMultiloadErrorComponent = {
  attr: 'should_avoid_multiload';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsSubscriptionsCreateError =
  | ({
      attr: 'non_field_errors';
    } & TripsSubscriptionsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'dispatcher_notes';
    } & TripsSubscriptionsCreateDispatcherNotesErrorComponent)
  | ({
      attr: 'billing_notes';
    } & TripsSubscriptionsCreateBillingNotesErrorComponent)
  | ({
      attr: 'dropoff.non_field_errors';
    } & TripsSubscriptionsCreateDropoffNonFieldErrorsErrorComponent)
  | ({
      attr: 'dropoff.address_details';
    } & TripsSubscriptionsCreateDropoffAddressDetailsErrorComponent)
  | ({
      attr: 'dropoff.num_stairs';
    } & TripsSubscriptionsCreateDropoffNumStairsErrorComponent)
  | ({
      attr: 'dropoff.stair_equipment';
    } & TripsSubscriptionsCreateDropoffStairEquipmentErrorComponent)
  | ({
      attr: 'dropoff.contact_name';
    } & TripsSubscriptionsCreateDropoffContactNameErrorComponent)
  | ({
      attr: 'dropoff.contact_phone_number';
    } & TripsSubscriptionsCreateDropoffContactPhoneNumberErrorComponent)
  | ({
      attr: 'dropoff.driver_notes';
    } & TripsSubscriptionsCreateDropoffDriverNotesErrorComponent)
  | ({
      attr: 'dropoff.place_id';
    } & TripsSubscriptionsCreateDropoffPlaceIdErrorComponent)
  | ({
      attr: 'estimated_distance_miles';
    } & TripsSubscriptionsCreateEstimatedDistanceMilesErrorComponent)
  | ({
      attr: 'estimated_load_seconds';
    } & TripsSubscriptionsCreateEstimatedLoadSecondsErrorComponent)
  | ({
      attr: 'estimated_unload_seconds';
    } & TripsSubscriptionsCreateEstimatedUnloadSecondsErrorComponent)
  | ({
      attr: 'expires_at';
    } & TripsSubscriptionsCreateExpiresAtErrorComponent)
  | ({
      attr: 'is_oxygen_required';
    } & TripsSubscriptionsCreateIsOxygenRequiredErrorComponent)
  | ({
      attr: 'load_time_seconds';
    } & TripsSubscriptionsCreateLoadTimeSecondsErrorComponent)
  | ({
      attr: 'num_accompanying_passengers';
    } & TripsSubscriptionsCreateNumAccompanyingPassengersErrorComponent)
  | ({
      attr: 'num_attendants_needed';
    } & TripsSubscriptionsCreateNumAttendantsNeededErrorComponent)
  | ({
      attr: 'oxygen_liters_per_min';
    } & TripsSubscriptionsCreateOxygenLitersPerMinErrorComponent)
  | ({
      attr: 'passenger.non_field_errors';
    } & TripsSubscriptionsCreatePassengerNonFieldErrorsErrorComponent)
  | ({
      attr: 'passenger.id';
    } & TripsSubscriptionsCreatePassengerIdErrorComponent)
  | ({
      attr: 'passenger.first_name';
    } & TripsSubscriptionsCreatePassengerFirstNameErrorComponent)
  | ({
      attr: 'passenger.last_name';
    } & TripsSubscriptionsCreatePassengerLastNameErrorComponent)
  | ({
      attr: 'passenger.preferred_name';
    } & TripsSubscriptionsCreatePassengerPreferredNameErrorComponent)
  | ({
      attr: 'passenger.pronoun';
    } & TripsSubscriptionsCreatePassengerPronounErrorComponent)
  | ({
      attr: 'passenger.gender';
    } & TripsSubscriptionsCreatePassengerGenderErrorComponent)
  | ({
      attr: 'passenger.dob';
    } & TripsSubscriptionsCreatePassengerDobErrorComponent)
  | ({
      attr: 'passenger.weight';
    } & TripsSubscriptionsCreatePassengerWeightErrorComponent)
  | ({
      attr: 'passenger.needs_bariatric_transport';
    } & TripsSubscriptionsCreatePassengerNeedsBariatricTransportErrorComponent)
  | ({
      attr: 'passenger.phone_number';
    } & TripsSubscriptionsCreatePassengerPhoneNumberErrorComponent)
  | ({
      attr: 'passenger.email';
    } & TripsSubscriptionsCreatePassengerEmailErrorComponent)
  | ({
      attr: 'passenger.notes';
    } & TripsSubscriptionsCreatePassengerNotesErrorComponent)
  | ({
      attr: 'passenger.dispatcher_notes';
    } & TripsSubscriptionsCreatePassengerDispatcherNotesErrorComponent)
  | ({
      attr: 'passenger.allow_sms_message';
    } & TripsSubscriptionsCreatePassengerAllowSmsMessageErrorComponent)
  | ({
      attr: 'payer.payer';
    } & TripsSubscriptionsCreatePayerPayerErrorComponent)
  | ({
      attr: 'payer.display_name';
    } & TripsSubscriptionsCreatePayerDisplayNameErrorComponent)
  | ({
      attr: 'payer.alternate_name';
    } & TripsSubscriptionsCreatePayerAlternateNameErrorComponent)
  | ({
      attr: 'payer.type';
    } & TripsSubscriptionsCreatePayerTypeErrorComponent)
  | ({
      attr: 'payer.is_active';
    } & TripsSubscriptionsCreatePayerIsActiveErrorComponent)
  | ({
      attr: 'payer.is_self_pay';
    } & TripsSubscriptionsCreatePayerIsSelfPayErrorComponent)
  | ({
      attr: 'payer.can_multiload';
    } & TripsSubscriptionsCreatePayerCanMultiloadErrorComponent)
  | ({
      attr: 'payer.external_id';
    } & TripsSubscriptionsCreatePayerExternalIdErrorComponent)
  | ({
      attr: 'payer.website';
    } & TripsSubscriptionsCreatePayerWebsiteErrorComponent)
  | ({
      attr: 'payer.ein';
    } & TripsSubscriptionsCreatePayerEinErrorComponent)
  | ({
      attr: 'payer.email';
    } & TripsSubscriptionsCreatePayerEmailErrorComponent)
  | ({
      attr: 'payer.phone_number';
    } & TripsSubscriptionsCreatePayerPhoneNumberErrorComponent)
  | ({
      attr: 'payer.billing_name';
    } & TripsSubscriptionsCreatePayerBillingNameErrorComponent)
  | ({
      attr: 'payer.billing_phone_number';
    } & TripsSubscriptionsCreatePayerBillingPhoneNumberErrorComponent)
  | ({
      attr: 'payer.billing_email';
    } & TripsSubscriptionsCreatePayerBillingEmailErrorComponent)
  | ({
      attr: 'payer.dispatcher_notes';
    } & TripsSubscriptionsCreatePayerDispatcherNotesErrorComponent)
  | ({
      attr: 'payer.admin_notes';
    } & TripsSubscriptionsCreatePayerAdminNotesErrorComponent)
  | ({
      attr: 'payer.deleted_at';
    } & TripsSubscriptionsCreatePayerDeletedAtErrorComponent)
  | ({
      attr: 'payer.billing_address.non_field_errors';
    } & TripsSubscriptionsCreatePayerBillingAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer.billing_address.location.non_field_errors';
    } & TripsSubscriptionsCreatePayerBillingAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer.billing_address.location.place_id';
    } & TripsSubscriptionsCreatePayerBillingAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'payer.billing_address.label';
    } & TripsSubscriptionsCreatePayerBillingAddressLabelErrorComponent)
  | ({
      attr: 'payer.billing_address.label2';
    } & TripsSubscriptionsCreatePayerBillingAddressLabel2ErrorComponent)
  | ({
      attr: 'payer.billing_address.address_notes';
    } & TripsSubscriptionsCreatePayerBillingAddressAddressNotesErrorComponent)
  | ({
      attr: 'payer.billing_address.address_type';
    } & TripsSubscriptionsCreatePayerBillingAddressAddressTypeErrorComponent)
  | ({
      attr: 'payer.default_trip_address.non_field_errors';
    } & TripsSubscriptionsCreatePayerDefaultTripAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer.default_trip_address.location.non_field_errors';
    } & TripsSubscriptionsCreatePayerDefaultTripAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer.default_trip_address.location.place_id';
    } & TripsSubscriptionsCreatePayerDefaultTripAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'payer.default_trip_address.label';
    } & TripsSubscriptionsCreatePayerDefaultTripAddressLabelErrorComponent)
  | ({
      attr: 'payer.default_trip_address.label2';
    } & TripsSubscriptionsCreatePayerDefaultTripAddressLabel2ErrorComponent)
  | ({
      attr: 'payer.default_trip_address.address_notes';
    } & TripsSubscriptionsCreatePayerDefaultTripAddressAddressNotesErrorComponent)
  | ({
      attr: 'payer.default_trip_address.address_type';
    } & TripsSubscriptionsCreatePayerDefaultTripAddressAddressTypeErrorComponent)
  | ({
      attr: 'payer.multiloading_partners.non_field_errors';
    } & TripsSubscriptionsCreatePayerMultiloadingPartnersNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer.multiloading_partners.INDEX';
    } & TripsSubscriptionsCreatePayerMultiloadingPartnersIndexErrorComponent)
  | ({
      attr: 'payer_id';
    } & TripsSubscriptionsCreatePayerIdErrorComponent)
  | ({
      attr: 'payer_passenger_external_id';
    } & TripsSubscriptionsCreatePayerPassengerExternalIdErrorComponent)
  | ({
      attr: 'payment_method';
    } & TripsSubscriptionsCreatePaymentMethodErrorComponent)
  | ({
      attr: 'pickup.non_field_errors';
    } & TripsSubscriptionsCreatePickupNonFieldErrorsErrorComponent)
  | ({
      attr: 'pickup.address_details';
    } & TripsSubscriptionsCreatePickupAddressDetailsErrorComponent)
  | ({
      attr: 'pickup.num_stairs';
    } & TripsSubscriptionsCreatePickupNumStairsErrorComponent)
  | ({
      attr: 'pickup.stair_equipment';
    } & TripsSubscriptionsCreatePickupStairEquipmentErrorComponent)
  | ({
      attr: 'pickup.contact_name';
    } & TripsSubscriptionsCreatePickupContactNameErrorComponent)
  | ({
      attr: 'pickup.contact_phone_number';
    } & TripsSubscriptionsCreatePickupContactPhoneNumberErrorComponent)
  | ({
      attr: 'pickup.driver_notes';
    } & TripsSubscriptionsCreatePickupDriverNotesErrorComponent)
  | ({
      attr: 'pickup.place_id';
    } & TripsSubscriptionsCreatePickupPlaceIdErrorComponent)
  | ({
      attr: 'pickup_wait_time_seconds';
    } & TripsSubscriptionsCreatePickupWaitTimeSecondsErrorComponent)
  | ({
      attr: 'recurrences.non_field_errors';
    } & TripsSubscriptionsCreateRecurrencesNonFieldErrorsErrorComponent)
  | ({
      attr: 'recurrences.INDEX.non_field_errors';
    } & TripsSubscriptionsCreateRecurrencesIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'recurrences.INDEX.is_round_trip';
    } & TripsSubscriptionsCreateRecurrencesIndexIsRoundTripErrorComponent)
  | ({
      attr: 'recurrences.INDEX.is_will_call';
    } & TripsSubscriptionsCreateRecurrencesIndexIsWillCallErrorComponent)
  | ({
      attr: 'recurrences.INDEX.rrule';
    } & TripsSubscriptionsCreateRecurrencesIndexRruleErrorComponent)
  | ({
      attr: 'recurrences.INDEX.input_price_cents';
    } & TripsSubscriptionsCreateRecurrencesIndexInputPriceCentsErrorComponent)
  | ({
      attr: 'recurrences.INDEX.scheduled_pickup_time';
    } & TripsSubscriptionsCreateRecurrencesIndexScheduledPickupTimeErrorComponent)
  | ({
      attr: 'recurrences.INDEX.appointment_time';
    } & TripsSubscriptionsCreateRecurrencesIndexAppointmentTimeErrorComponent)
  | ({
      attr: 'must_provide_wheelchair';
    } & TripsSubscriptionsCreateMustProvideWheelchairErrorComponent)
  | ({
      attr: 'service_type';
    } & TripsSubscriptionsCreateServiceTypeErrorComponent)
  | ({
      attr: 'space_type';
    } & TripsSubscriptionsCreateSpaceTypeErrorComponent)
  | ({
      attr: 'start_date';
    } & TripsSubscriptionsCreateStartDateErrorComponent)
  | ({
      attr: 'unload_time_seconds';
    } & TripsSubscriptionsCreateUnloadTimeSecondsErrorComponent)
  | ({
      attr: 'old_trips.INDEX.non_field_errors';
    } & TripsSubscriptionsCreateOldTripsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'old_trips.INDEX.passenger_initials';
    } & TripsSubscriptionsCreateOldTripsIndexPassengerInitialsErrorComponent)
  | ({
      attr: 'old_trips.INDEX.pickup_datetime';
    } & TripsSubscriptionsCreateOldTripsIndexPickupDatetimeErrorComponent)
  | ({
      attr: 'old_trips.INDEX.from_address';
    } & TripsSubscriptionsCreateOldTripsIndexFromAddressErrorComponent)
  | ({
      attr: 'old_trips.INDEX.to_address';
    } & TripsSubscriptionsCreateOldTripsIndexToAddressErrorComponent)
  | ({
      attr: 'old_trips.INDEX.key';
    } & TripsSubscriptionsCreateOldTripsIndexKeyErrorComponent)
  | ({
      attr: 'new_trips.INDEX.non_field_errors';
    } & TripsSubscriptionsCreateNewTripsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'new_trips.INDEX.passenger_initials';
    } & TripsSubscriptionsCreateNewTripsIndexPassengerInitialsErrorComponent)
  | ({
      attr: 'new_trips.INDEX.pickup_datetime';
    } & TripsSubscriptionsCreateNewTripsIndexPickupDatetimeErrorComponent)
  | ({
      attr: 'new_trips.INDEX.from_address';
    } & TripsSubscriptionsCreateNewTripsIndexFromAddressErrorComponent)
  | ({
      attr: 'new_trips.INDEX.to_address';
    } & TripsSubscriptionsCreateNewTripsIndexToAddressErrorComponent)
  | ({
      attr: 'new_trips.INDEX.key';
    } & TripsSubscriptionsCreateNewTripsIndexKeyErrorComponent)
  | ({
      attr: 'has_infectious_disease';
    } & TripsSubscriptionsCreateHasInfectiousDiseaseErrorComponent)
  | ({
      attr: 'booked_by_name';
    } & TripsSubscriptionsCreateBookedByNameErrorComponent)
  | ({
      attr: 'booked_by_phone_number';
    } & TripsSubscriptionsCreateBookedByPhoneNumberErrorComponent)
  | ({
      attr: 'booked_by_phone_extension';
    } & TripsSubscriptionsCreateBookedByPhoneExtensionErrorComponent)
  | ({
      attr: 'tag_ids';
    } & TripsSubscriptionsCreateTagIdsErrorComponent)
  | ({
      attr: 'tag_ids.INDEX';
    } & TripsSubscriptionsCreateTagIdsIndexErrorComponent)
  | ({
      attr: 'tags.INDEX.tag_name';
    } & TripsSubscriptionsCreateTagsIndexTagNameErrorComponent)
  | ({
      attr: 'tags.INDEX.color_hex';
    } & TripsSubscriptionsCreateTagsIndexColorHexErrorComponent)
  | ({
      attr: 'authorization_id';
    } & TripsSubscriptionsCreateAuthorizationIdErrorComponent)
  | ({
      attr: 'insurance_policy_id';
    } & TripsSubscriptionsCreateInsurancePolicyIdErrorComponent)
  | ({
      attr: 'seat_equipment';
    } & TripsSubscriptionsCreateSeatEquipmentErrorComponent)
  | ({
      attr: 'should_avoid_multiload';
    } & TripsSubscriptionsCreateShouldAvoidMultiloadErrorComponent);
export type TripsSubscriptionsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsSubscriptionsCreateError[];
};
export type TripsSubscriptionsCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsSubscriptionsCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TripsSubscriptionsRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripsSubscriptionsPartialUpdateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateDispatcherNotesErrorComponent = {
  attr: 'dispatcher_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateBillingNotesErrorComponent = {
  attr: 'billing_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateDropoffNonFieldErrorsErrorComponent =
  {
    attr: 'dropoff.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateDropoffAddressDetailsErrorComponent =
  {
    attr: 'dropoff.address_details';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateDropoffNumStairsErrorComponent = {
  attr: 'dropoff.num_stairs';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateDropoffStairEquipmentErrorComponent =
  {
    attr: 'dropoff.stair_equipment';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateDropoffContactNameErrorComponent = {
  attr: 'dropoff.contact_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateDropoffContactPhoneNumberErrorComponent =
  {
    attr: 'dropoff.contact_phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateDropoffDriverNotesErrorComponent = {
  attr: 'dropoff.driver_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateDropoffPlaceIdErrorComponent = {
  attr: 'dropoff.place_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateEstimatedDistanceMilesErrorComponent =
  {
    attr: 'estimated_distance_miles';
    code: 'invalid' | 'max_string_length';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateEstimatedLoadSecondsErrorComponent =
  {
    attr: 'estimated_load_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateEstimatedUnloadSecondsErrorComponent =
  {
    attr: 'estimated_unload_seconds';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateExpiresAtErrorComponent = {
  attr: 'expires_at';
  code: 'datetime' | 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateIsOxygenRequiredErrorComponent = {
  attr: 'is_oxygen_required';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateLoadTimeSecondsErrorComponent = {
  attr: 'load_time_seconds';
  code: 'invalid' | 'max_string_length' | 'min_value' | 'null';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateNumAccompanyingPassengersErrorComponent =
  {
    attr: 'num_accompanying_passengers';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateNumAttendantsNeededErrorComponent = {
  attr: 'num_attendants_needed';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateOxygenLitersPerMinErrorComponent = {
  attr: 'oxygen_liters_per_min';
  code:
    | 'invalid'
    | 'max_decimal_places'
    | 'max_digits'
    | 'max_string_length'
    | 'max_whole_digits'
    | 'null';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePassengerNonFieldErrorsErrorComponent =
  {
    attr: 'passenger.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePassengerIdErrorComponent = {
  attr: 'passenger.id';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePassengerFirstNameErrorComponent = {
  attr: 'passenger.first_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePassengerLastNameErrorComponent = {
  attr: 'passenger.last_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePassengerPreferredNameErrorComponent =
  {
    attr: 'passenger.preferred_name';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePassengerPronounErrorComponent = {
  attr: 'passenger.pronoun';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePassengerGenderErrorComponent = {
  attr: 'passenger.gender';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePassengerDobErrorComponent = {
  attr: 'passenger.dob';
  code: 'datetime' | 'invalid';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePassengerWeightErrorComponent = {
  attr: 'passenger.weight';
  code: 'invalid' | 'max_string_length' | 'min_value';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePassengerNeedsBariatricTransportErrorComponent =
  {
    attr: 'passenger.needs_bariatric_transport';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePassengerPhoneNumberErrorComponent =
  {
    attr: 'passenger.phone_number';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePassengerEmailErrorComponent = {
  attr: 'passenger.email';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePassengerNotesErrorComponent = {
  attr: 'passenger.notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePassengerDispatcherNotesErrorComponent =
  {
    attr: 'passenger.dispatcher_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePassengerAllowSmsMessageErrorComponent =
  {
    attr: 'passenger.allow_sms_message';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePayerPayerErrorComponent = {
  attr: 'payer.payer';
  code: 'does_not_exist' | 'incorrect_type';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePayerDisplayNameErrorComponent = {
  attr: 'payer.display_name';
  code:
    | 'blank'
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePayerAlternateNameErrorComponent = {
  attr: 'payer.alternate_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePayerTypeErrorComponent = {
  attr: 'payer.type';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePayerIsActiveErrorComponent = {
  attr: 'payer.is_active';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePayerIsSelfPayErrorComponent = {
  attr: 'payer.is_self_pay';
  code: 'invalid';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePayerCanMultiloadErrorComponent = {
  attr: 'payer.can_multiload';
  code: 'invalid' | 'null';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePayerExternalIdErrorComponent = {
  attr: 'payer.external_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePayerWebsiteErrorComponent = {
  attr: 'payer.website';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePayerEinErrorComponent = {
  attr: 'payer.ein';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePayerEmailErrorComponent = {
  attr: 'payer.email';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePayerPhoneNumberErrorComponent = {
  attr: 'payer.phone_number';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePayerBillingNameErrorComponent = {
  attr: 'payer.billing_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePayerBillingPhoneNumberErrorComponent =
  {
    attr: 'payer.billing_phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePayerBillingEmailErrorComponent = {
  attr: 'payer.billing_email';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePayerDispatcherNotesErrorComponent =
  {
    attr: 'payer.dispatcher_notes';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePayerAdminNotesErrorComponent = {
  attr: 'payer.admin_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePayerDeletedAtErrorComponent = {
  attr: 'payer.deleted_at';
  code: 'date' | 'invalid' | 'make_aware' | 'overflow';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePayerBillingAddressNonFieldErrorsErrorComponent =
  {
    attr: 'payer.billing_address.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePayerBillingAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'payer.billing_address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePayerBillingAddressLocationPlaceIdErrorComponent =
  {
    attr: 'payer.billing_address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePayerBillingAddressLabelErrorComponent =
  {
    attr: 'payer.billing_address.label';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePayerBillingAddressLabel2ErrorComponent =
  {
    attr: 'payer.billing_address.label2';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePayerBillingAddressAddressNotesErrorComponent =
  {
    attr: 'payer.billing_address.address_notes';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePayerBillingAddressAddressTypeErrorComponent =
  {
    attr: 'payer.billing_address.address_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePayerDefaultTripAddressNonFieldErrorsErrorComponent =
  {
    attr: 'payer.default_trip_address.non_field_errors';
    code: 'invalid';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePayerDefaultTripAddressLocationNonFieldErrorsErrorComponent =
  {
    attr: 'payer.default_trip_address.location.non_field_errors';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePayerDefaultTripAddressLocationPlaceIdErrorComponent =
  {
    attr: 'payer.default_trip_address.location.place_id';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePayerDefaultTripAddressLabelErrorComponent =
  {
    attr: 'payer.default_trip_address.label';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePayerDefaultTripAddressLabel2ErrorComponent =
  {
    attr: 'payer.default_trip_address.label2';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePayerDefaultTripAddressAddressNotesErrorComponent =
  {
    attr: 'payer.default_trip_address.address_notes';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePayerDefaultTripAddressAddressTypeErrorComponent =
  {
    attr: 'payer.default_trip_address.address_type';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePayerMultiloadingPartnersNonFieldErrorsErrorComponent =
  {
    attr: 'payer.multiloading_partners.non_field_errors';
    code: 'not_a_list';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePayerMultiloadingPartnersIndexErrorComponent =
  {
    attr: 'payer.multiloading_partners.INDEX';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePayerIdErrorComponent = {
  attr: 'payer_id';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePayerPassengerExternalIdErrorComponent =
  {
    attr: 'payer_passenger_external_id';
    code:
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePaymentMethodErrorComponent = {
  attr: 'payment_method';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePickupNonFieldErrorsErrorComponent =
  {
    attr: 'pickup.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePickupAddressDetailsErrorComponent =
  {
    attr: 'pickup.address_details';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePickupNumStairsErrorComponent = {
  attr: 'pickup.num_stairs';
  code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value' | 'null';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePickupStairEquipmentErrorComponent =
  {
    attr: 'pickup.stair_equipment';
    code: 'invalid_choice' | 'null';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePickupContactNameErrorComponent = {
  attr: 'pickup.contact_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePickupContactPhoneNumberErrorComponent =
  {
    attr: 'pickup.contact_phone_number';
    code:
      | 'invalid'
      | 'max_length'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdatePickupDriverNotesErrorComponent = {
  attr: 'pickup.driver_notes';
  code:
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePickupPlaceIdErrorComponent = {
  attr: 'pickup.place_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdatePickupWaitTimeSecondsErrorComponent =
  {
    attr: 'pickup_wait_time_seconds';
    code: 'invalid' | 'max_string_length' | 'min_value' | 'null';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateRecurrencesNonFieldErrorsErrorComponent =
  {
    attr: 'recurrences.non_field_errors';
    code: 'not_a_list' | 'null' | 'required';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateRecurrencesIndexNonFieldErrorsErrorComponent =
  {
    attr: 'recurrences.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateRecurrencesIndexIsRoundTripErrorComponent =
  {
    attr: 'recurrences.INDEX.is_round_trip';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateRecurrencesIndexIsWillCallErrorComponent =
  {
    attr: 'recurrences.INDEX.is_will_call';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateRecurrencesIndexRruleErrorComponent =
  {
    attr: 'recurrences.INDEX.rrule';
    code:
      | 'blank'
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateRecurrencesIndexInputPriceCentsErrorComponent =
  {
    attr: 'recurrences.INDEX.input_price_cents';
    code: 'invalid' | 'max_string_length' | 'max_value' | 'min_value';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateRecurrencesIndexScheduledPickupTimeErrorComponent =
  {
    attr: 'recurrences.INDEX.scheduled_pickup_time';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateRecurrencesIndexAppointmentTimeErrorComponent =
  {
    attr: 'recurrences.INDEX.appointment_time';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateMustProvideWheelchairErrorComponent =
  {
    attr: 'must_provide_wheelchair';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateServiceTypeErrorComponent = {
  attr: 'service_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateSpaceTypeErrorComponent = {
  attr: 'space_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateStartDateErrorComponent = {
  attr: 'start_date';
  code: 'datetime' | 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateUnloadTimeSecondsErrorComponent = {
  attr: 'unload_time_seconds';
  code: 'invalid' | 'max_string_length' | 'min_value' | 'null';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateOldTripsIndexNonFieldErrorsErrorComponent =
  {
    attr: 'old_trips.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateOldTripsIndexPassengerInitialsErrorComponent =
  {
    attr: 'old_trips.INDEX.passenger_initials';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateOldTripsIndexPickupDatetimeErrorComponent =
  {
    attr: 'old_trips.INDEX.pickup_datetime';
    code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateOldTripsIndexFromAddressErrorComponent =
  {
    attr: 'old_trips.INDEX.from_address';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateOldTripsIndexToAddressErrorComponent =
  {
    attr: 'old_trips.INDEX.to_address';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateOldTripsIndexKeyErrorComponent = {
  attr: 'old_trips.INDEX.key';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateNewTripsIndexNonFieldErrorsErrorComponent =
  {
    attr: 'new_trips.INDEX.non_field_errors';
    code: 'invalid' | 'null' | 'required';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateNewTripsIndexPassengerInitialsErrorComponent =
  {
    attr: 'new_trips.INDEX.passenger_initials';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateNewTripsIndexPickupDatetimeErrorComponent =
  {
    attr: 'new_trips.INDEX.pickup_datetime';
    code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateNewTripsIndexFromAddressErrorComponent =
  {
    attr: 'new_trips.INDEX.from_address';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateNewTripsIndexToAddressErrorComponent =
  {
    attr: 'new_trips.INDEX.to_address';
    code:
      | 'blank'
      | 'invalid'
      | 'null'
      | 'null_characters_not_allowed'
      | 'required'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateNewTripsIndexKeyErrorComponent = {
  attr: 'new_trips.INDEX.key';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateHasInfectiousDiseaseErrorComponent =
  {
    attr: 'has_infectious_disease';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateBookedByNameErrorComponent = {
  attr: 'booked_by_name';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateBookedByPhoneNumberErrorComponent = {
  attr: 'booked_by_phone_number';
  code:
    | 'invalid'
    | 'max_length'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateBookedByPhoneExtensionErrorComponent =
  {
    attr: 'booked_by_phone_extension';
    code:
      | 'invalid'
      | 'max_length'
      | 'null'
      | 'null_characters_not_allowed'
      | 'surrogate_characters_not_allowed';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateTagIdsErrorComponent = {
  attr: 'tag_ids';
  code: 'not_a_list';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateTagIdsIndexErrorComponent = {
  attr: 'tag_ids.INDEX';
  code: 'invalid' | 'null' | 'required';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateTagsIndexTagNameErrorComponent = {
  attr: 'tags.INDEX.tag_name';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateTagsIndexColorHexErrorComponent = {
  attr: 'tags.INDEX.color_hex';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateAuthorizationIdErrorComponent = {
  attr: 'authorization_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateInsurancePolicyIdErrorComponent = {
  attr: 'insurance_policy_id';
  code:
    | 'invalid'
    | 'max_length'
    | 'null'
    | 'null_characters_not_allowed'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateSeatEquipmentErrorComponent = {
  attr: 'seat_equipment';
  code: 'invalid_choice' | 'null';
  detail: string;
};
export type TripsSubscriptionsPartialUpdateShouldAvoidMultiloadErrorComponent =
  {
    attr: 'should_avoid_multiload';
    code: 'invalid' | 'null';
    detail: string;
  };
export type TripsSubscriptionsPartialUpdateError =
  | ({
      attr: 'non_field_errors';
    } & TripsSubscriptionsPartialUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: 'dispatcher_notes';
    } & TripsSubscriptionsPartialUpdateDispatcherNotesErrorComponent)
  | ({
      attr: 'billing_notes';
    } & TripsSubscriptionsPartialUpdateBillingNotesErrorComponent)
  | ({
      attr: 'dropoff.non_field_errors';
    } & TripsSubscriptionsPartialUpdateDropoffNonFieldErrorsErrorComponent)
  | ({
      attr: 'dropoff.address_details';
    } & TripsSubscriptionsPartialUpdateDropoffAddressDetailsErrorComponent)
  | ({
      attr: 'dropoff.num_stairs';
    } & TripsSubscriptionsPartialUpdateDropoffNumStairsErrorComponent)
  | ({
      attr: 'dropoff.stair_equipment';
    } & TripsSubscriptionsPartialUpdateDropoffStairEquipmentErrorComponent)
  | ({
      attr: 'dropoff.contact_name';
    } & TripsSubscriptionsPartialUpdateDropoffContactNameErrorComponent)
  | ({
      attr: 'dropoff.contact_phone_number';
    } & TripsSubscriptionsPartialUpdateDropoffContactPhoneNumberErrorComponent)
  | ({
      attr: 'dropoff.driver_notes';
    } & TripsSubscriptionsPartialUpdateDropoffDriverNotesErrorComponent)
  | ({
      attr: 'dropoff.place_id';
    } & TripsSubscriptionsPartialUpdateDropoffPlaceIdErrorComponent)
  | ({
      attr: 'estimated_distance_miles';
    } & TripsSubscriptionsPartialUpdateEstimatedDistanceMilesErrorComponent)
  | ({
      attr: 'estimated_load_seconds';
    } & TripsSubscriptionsPartialUpdateEstimatedLoadSecondsErrorComponent)
  | ({
      attr: 'estimated_unload_seconds';
    } & TripsSubscriptionsPartialUpdateEstimatedUnloadSecondsErrorComponent)
  | ({
      attr: 'expires_at';
    } & TripsSubscriptionsPartialUpdateExpiresAtErrorComponent)
  | ({
      attr: 'is_oxygen_required';
    } & TripsSubscriptionsPartialUpdateIsOxygenRequiredErrorComponent)
  | ({
      attr: 'load_time_seconds';
    } & TripsSubscriptionsPartialUpdateLoadTimeSecondsErrorComponent)
  | ({
      attr: 'num_accompanying_passengers';
    } & TripsSubscriptionsPartialUpdateNumAccompanyingPassengersErrorComponent)
  | ({
      attr: 'num_attendants_needed';
    } & TripsSubscriptionsPartialUpdateNumAttendantsNeededErrorComponent)
  | ({
      attr: 'oxygen_liters_per_min';
    } & TripsSubscriptionsPartialUpdateOxygenLitersPerMinErrorComponent)
  | ({
      attr: 'passenger.non_field_errors';
    } & TripsSubscriptionsPartialUpdatePassengerNonFieldErrorsErrorComponent)
  | ({
      attr: 'passenger.id';
    } & TripsSubscriptionsPartialUpdatePassengerIdErrorComponent)
  | ({
      attr: 'passenger.first_name';
    } & TripsSubscriptionsPartialUpdatePassengerFirstNameErrorComponent)
  | ({
      attr: 'passenger.last_name';
    } & TripsSubscriptionsPartialUpdatePassengerLastNameErrorComponent)
  | ({
      attr: 'passenger.preferred_name';
    } & TripsSubscriptionsPartialUpdatePassengerPreferredNameErrorComponent)
  | ({
      attr: 'passenger.pronoun';
    } & TripsSubscriptionsPartialUpdatePassengerPronounErrorComponent)
  | ({
      attr: 'passenger.gender';
    } & TripsSubscriptionsPartialUpdatePassengerGenderErrorComponent)
  | ({
      attr: 'passenger.dob';
    } & TripsSubscriptionsPartialUpdatePassengerDobErrorComponent)
  | ({
      attr: 'passenger.weight';
    } & TripsSubscriptionsPartialUpdatePassengerWeightErrorComponent)
  | ({
      attr: 'passenger.needs_bariatric_transport';
    } & TripsSubscriptionsPartialUpdatePassengerNeedsBariatricTransportErrorComponent)
  | ({
      attr: 'passenger.phone_number';
    } & TripsSubscriptionsPartialUpdatePassengerPhoneNumberErrorComponent)
  | ({
      attr: 'passenger.email';
    } & TripsSubscriptionsPartialUpdatePassengerEmailErrorComponent)
  | ({
      attr: 'passenger.notes';
    } & TripsSubscriptionsPartialUpdatePassengerNotesErrorComponent)
  | ({
      attr: 'passenger.dispatcher_notes';
    } & TripsSubscriptionsPartialUpdatePassengerDispatcherNotesErrorComponent)
  | ({
      attr: 'passenger.allow_sms_message';
    } & TripsSubscriptionsPartialUpdatePassengerAllowSmsMessageErrorComponent)
  | ({
      attr: 'payer.payer';
    } & TripsSubscriptionsPartialUpdatePayerPayerErrorComponent)
  | ({
      attr: 'payer.display_name';
    } & TripsSubscriptionsPartialUpdatePayerDisplayNameErrorComponent)
  | ({
      attr: 'payer.alternate_name';
    } & TripsSubscriptionsPartialUpdatePayerAlternateNameErrorComponent)
  | ({
      attr: 'payer.type';
    } & TripsSubscriptionsPartialUpdatePayerTypeErrorComponent)
  | ({
      attr: 'payer.is_active';
    } & TripsSubscriptionsPartialUpdatePayerIsActiveErrorComponent)
  | ({
      attr: 'payer.is_self_pay';
    } & TripsSubscriptionsPartialUpdatePayerIsSelfPayErrorComponent)
  | ({
      attr: 'payer.can_multiload';
    } & TripsSubscriptionsPartialUpdatePayerCanMultiloadErrorComponent)
  | ({
      attr: 'payer.external_id';
    } & TripsSubscriptionsPartialUpdatePayerExternalIdErrorComponent)
  | ({
      attr: 'payer.website';
    } & TripsSubscriptionsPartialUpdatePayerWebsiteErrorComponent)
  | ({
      attr: 'payer.ein';
    } & TripsSubscriptionsPartialUpdatePayerEinErrorComponent)
  | ({
      attr: 'payer.email';
    } & TripsSubscriptionsPartialUpdatePayerEmailErrorComponent)
  | ({
      attr: 'payer.phone_number';
    } & TripsSubscriptionsPartialUpdatePayerPhoneNumberErrorComponent)
  | ({
      attr: 'payer.billing_name';
    } & TripsSubscriptionsPartialUpdatePayerBillingNameErrorComponent)
  | ({
      attr: 'payer.billing_phone_number';
    } & TripsSubscriptionsPartialUpdatePayerBillingPhoneNumberErrorComponent)
  | ({
      attr: 'payer.billing_email';
    } & TripsSubscriptionsPartialUpdatePayerBillingEmailErrorComponent)
  | ({
      attr: 'payer.dispatcher_notes';
    } & TripsSubscriptionsPartialUpdatePayerDispatcherNotesErrorComponent)
  | ({
      attr: 'payer.admin_notes';
    } & TripsSubscriptionsPartialUpdatePayerAdminNotesErrorComponent)
  | ({
      attr: 'payer.deleted_at';
    } & TripsSubscriptionsPartialUpdatePayerDeletedAtErrorComponent)
  | ({
      attr: 'payer.billing_address.non_field_errors';
    } & TripsSubscriptionsPartialUpdatePayerBillingAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer.billing_address.location.non_field_errors';
    } & TripsSubscriptionsPartialUpdatePayerBillingAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer.billing_address.location.place_id';
    } & TripsSubscriptionsPartialUpdatePayerBillingAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'payer.billing_address.label';
    } & TripsSubscriptionsPartialUpdatePayerBillingAddressLabelErrorComponent)
  | ({
      attr: 'payer.billing_address.label2';
    } & TripsSubscriptionsPartialUpdatePayerBillingAddressLabel2ErrorComponent)
  | ({
      attr: 'payer.billing_address.address_notes';
    } & TripsSubscriptionsPartialUpdatePayerBillingAddressAddressNotesErrorComponent)
  | ({
      attr: 'payer.billing_address.address_type';
    } & TripsSubscriptionsPartialUpdatePayerBillingAddressAddressTypeErrorComponent)
  | ({
      attr: 'payer.default_trip_address.non_field_errors';
    } & TripsSubscriptionsPartialUpdatePayerDefaultTripAddressNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer.default_trip_address.location.non_field_errors';
    } & TripsSubscriptionsPartialUpdatePayerDefaultTripAddressLocationNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer.default_trip_address.location.place_id';
    } & TripsSubscriptionsPartialUpdatePayerDefaultTripAddressLocationPlaceIdErrorComponent)
  | ({
      attr: 'payer.default_trip_address.label';
    } & TripsSubscriptionsPartialUpdatePayerDefaultTripAddressLabelErrorComponent)
  | ({
      attr: 'payer.default_trip_address.label2';
    } & TripsSubscriptionsPartialUpdatePayerDefaultTripAddressLabel2ErrorComponent)
  | ({
      attr: 'payer.default_trip_address.address_notes';
    } & TripsSubscriptionsPartialUpdatePayerDefaultTripAddressAddressNotesErrorComponent)
  | ({
      attr: 'payer.default_trip_address.address_type';
    } & TripsSubscriptionsPartialUpdatePayerDefaultTripAddressAddressTypeErrorComponent)
  | ({
      attr: 'payer.multiloading_partners.non_field_errors';
    } & TripsSubscriptionsPartialUpdatePayerMultiloadingPartnersNonFieldErrorsErrorComponent)
  | ({
      attr: 'payer.multiloading_partners.INDEX';
    } & TripsSubscriptionsPartialUpdatePayerMultiloadingPartnersIndexErrorComponent)
  | ({
      attr: 'payer_id';
    } & TripsSubscriptionsPartialUpdatePayerIdErrorComponent)
  | ({
      attr: 'payer_passenger_external_id';
    } & TripsSubscriptionsPartialUpdatePayerPassengerExternalIdErrorComponent)
  | ({
      attr: 'payment_method';
    } & TripsSubscriptionsPartialUpdatePaymentMethodErrorComponent)
  | ({
      attr: 'pickup.non_field_errors';
    } & TripsSubscriptionsPartialUpdatePickupNonFieldErrorsErrorComponent)
  | ({
      attr: 'pickup.address_details';
    } & TripsSubscriptionsPartialUpdatePickupAddressDetailsErrorComponent)
  | ({
      attr: 'pickup.num_stairs';
    } & TripsSubscriptionsPartialUpdatePickupNumStairsErrorComponent)
  | ({
      attr: 'pickup.stair_equipment';
    } & TripsSubscriptionsPartialUpdatePickupStairEquipmentErrorComponent)
  | ({
      attr: 'pickup.contact_name';
    } & TripsSubscriptionsPartialUpdatePickupContactNameErrorComponent)
  | ({
      attr: 'pickup.contact_phone_number';
    } & TripsSubscriptionsPartialUpdatePickupContactPhoneNumberErrorComponent)
  | ({
      attr: 'pickup.driver_notes';
    } & TripsSubscriptionsPartialUpdatePickupDriverNotesErrorComponent)
  | ({
      attr: 'pickup.place_id';
    } & TripsSubscriptionsPartialUpdatePickupPlaceIdErrorComponent)
  | ({
      attr: 'pickup_wait_time_seconds';
    } & TripsSubscriptionsPartialUpdatePickupWaitTimeSecondsErrorComponent)
  | ({
      attr: 'recurrences.non_field_errors';
    } & TripsSubscriptionsPartialUpdateRecurrencesNonFieldErrorsErrorComponent)
  | ({
      attr: 'recurrences.INDEX.non_field_errors';
    } & TripsSubscriptionsPartialUpdateRecurrencesIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'recurrences.INDEX.is_round_trip';
    } & TripsSubscriptionsPartialUpdateRecurrencesIndexIsRoundTripErrorComponent)
  | ({
      attr: 'recurrences.INDEX.is_will_call';
    } & TripsSubscriptionsPartialUpdateRecurrencesIndexIsWillCallErrorComponent)
  | ({
      attr: 'recurrences.INDEX.rrule';
    } & TripsSubscriptionsPartialUpdateRecurrencesIndexRruleErrorComponent)
  | ({
      attr: 'recurrences.INDEX.input_price_cents';
    } & TripsSubscriptionsPartialUpdateRecurrencesIndexInputPriceCentsErrorComponent)
  | ({
      attr: 'recurrences.INDEX.scheduled_pickup_time';
    } & TripsSubscriptionsPartialUpdateRecurrencesIndexScheduledPickupTimeErrorComponent)
  | ({
      attr: 'recurrences.INDEX.appointment_time';
    } & TripsSubscriptionsPartialUpdateRecurrencesIndexAppointmentTimeErrorComponent)
  | ({
      attr: 'must_provide_wheelchair';
    } & TripsSubscriptionsPartialUpdateMustProvideWheelchairErrorComponent)
  | ({
      attr: 'service_type';
    } & TripsSubscriptionsPartialUpdateServiceTypeErrorComponent)
  | ({
      attr: 'space_type';
    } & TripsSubscriptionsPartialUpdateSpaceTypeErrorComponent)
  | ({
      attr: 'start_date';
    } & TripsSubscriptionsPartialUpdateStartDateErrorComponent)
  | ({
      attr: 'unload_time_seconds';
    } & TripsSubscriptionsPartialUpdateUnloadTimeSecondsErrorComponent)
  | ({
      attr: 'old_trips.INDEX.non_field_errors';
    } & TripsSubscriptionsPartialUpdateOldTripsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'old_trips.INDEX.passenger_initials';
    } & TripsSubscriptionsPartialUpdateOldTripsIndexPassengerInitialsErrorComponent)
  | ({
      attr: 'old_trips.INDEX.pickup_datetime';
    } & TripsSubscriptionsPartialUpdateOldTripsIndexPickupDatetimeErrorComponent)
  | ({
      attr: 'old_trips.INDEX.from_address';
    } & TripsSubscriptionsPartialUpdateOldTripsIndexFromAddressErrorComponent)
  | ({
      attr: 'old_trips.INDEX.to_address';
    } & TripsSubscriptionsPartialUpdateOldTripsIndexToAddressErrorComponent)
  | ({
      attr: 'old_trips.INDEX.key';
    } & TripsSubscriptionsPartialUpdateOldTripsIndexKeyErrorComponent)
  | ({
      attr: 'new_trips.INDEX.non_field_errors';
    } & TripsSubscriptionsPartialUpdateNewTripsIndexNonFieldErrorsErrorComponent)
  | ({
      attr: 'new_trips.INDEX.passenger_initials';
    } & TripsSubscriptionsPartialUpdateNewTripsIndexPassengerInitialsErrorComponent)
  | ({
      attr: 'new_trips.INDEX.pickup_datetime';
    } & TripsSubscriptionsPartialUpdateNewTripsIndexPickupDatetimeErrorComponent)
  | ({
      attr: 'new_trips.INDEX.from_address';
    } & TripsSubscriptionsPartialUpdateNewTripsIndexFromAddressErrorComponent)
  | ({
      attr: 'new_trips.INDEX.to_address';
    } & TripsSubscriptionsPartialUpdateNewTripsIndexToAddressErrorComponent)
  | ({
      attr: 'new_trips.INDEX.key';
    } & TripsSubscriptionsPartialUpdateNewTripsIndexKeyErrorComponent)
  | ({
      attr: 'has_infectious_disease';
    } & TripsSubscriptionsPartialUpdateHasInfectiousDiseaseErrorComponent)
  | ({
      attr: 'booked_by_name';
    } & TripsSubscriptionsPartialUpdateBookedByNameErrorComponent)
  | ({
      attr: 'booked_by_phone_number';
    } & TripsSubscriptionsPartialUpdateBookedByPhoneNumberErrorComponent)
  | ({
      attr: 'booked_by_phone_extension';
    } & TripsSubscriptionsPartialUpdateBookedByPhoneExtensionErrorComponent)
  | ({
      attr: 'tag_ids';
    } & TripsSubscriptionsPartialUpdateTagIdsErrorComponent)
  | ({
      attr: 'tag_ids.INDEX';
    } & TripsSubscriptionsPartialUpdateTagIdsIndexErrorComponent)
  | ({
      attr: 'tags.INDEX.tag_name';
    } & TripsSubscriptionsPartialUpdateTagsIndexTagNameErrorComponent)
  | ({
      attr: 'tags.INDEX.color_hex';
    } & TripsSubscriptionsPartialUpdateTagsIndexColorHexErrorComponent)
  | ({
      attr: 'authorization_id';
    } & TripsSubscriptionsPartialUpdateAuthorizationIdErrorComponent)
  | ({
      attr: 'insurance_policy_id';
    } & TripsSubscriptionsPartialUpdateInsurancePolicyIdErrorComponent)
  | ({
      attr: 'seat_equipment';
    } & TripsSubscriptionsPartialUpdateSeatEquipmentErrorComponent)
  | ({
      attr: 'should_avoid_multiload';
    } & TripsSubscriptionsPartialUpdateShouldAvoidMultiloadErrorComponent);
export type TripsSubscriptionsPartialUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsSubscriptionsPartialUpdateError[];
};
export type TripsSubscriptionsPartialUpdateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsSubscriptionsPartialUpdateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type PatchedTripSubscription = {
  /** Notes only visible to the dispatcher */
  dispatcher_notes?: string;
  /** Notes about the trip for billing purposes */
  billing_notes?: string;
  dropoff?: TripLocationDetail;
  estimated_distance_miles?: number | null;
  estimated_load_seconds?: number | null;
  estimated_unload_seconds?: number | null;
  /** When the recurrences stop applying (exclusive) */
  expires_at?: string;
  is_oxygen_required?: boolean;
  load_time_seconds?: number;
  /** How many additional people will be accompanying the primary passenger */
  num_accompanying_passengers?: number;
  num_attendants_needed?: number;
  oxygen_liters_per_min?: string;
  passenger?: PatchedTripPassenger;
  payment_method?: PaymentMethodEnum | BlankEnum;
  pickup?: TripLocationDetail;
  pickup_wait_time_seconds?: number;
  recurrences?: TripRecurrence[];
  /** Whether the passenger will supply their own wheelchair or not */
  must_provide_wheelchair?: boolean;
  service_type?: ServiceTypeEnum;
  /** The type of space in the vehicle this passenger will need */
  space_type?: SpaceTypeEnum;
  /** When the recurrences start applying (inclusive) */
  start_date?: string;
  unload_time_seconds?: number;
  /** Whether the passenger has an infectious disease */
  has_infectious_disease?: boolean;
  /** Who booked this trip, if not passenger */
  booked_by_name?: string;
  /** Phone number of who booked this trip, if not passenger */
  booked_by_phone_number?: string | null;
  /** Phone number extension of who booked this trip, if not passenger */
  booked_by_phone_extension?: string;
  /** The authorization ID for this trip */
  authorization_id?: string;
  /** The insurance policy ID for this trip */
  insurance_policy_id?: string;
  /** The seat equipment needed for this trip */
  seat_equipment?: SeatEquipmentEnum | BlankEnum;
  /** Whether this trip should avoid being multiloaded with other passengers */
  should_avoid_multiload?: boolean;
};
export type PatchedTripSubscriptionRead = {
  /** Notes only visible to the dispatcher */
  dispatcher_notes?: string;
  /** Notes about the trip for billing purposes */
  billing_notes?: string;
  dropoff?: TripLocationDetailRead;
  estimated_distance_miles?: number | null;
  estimated_load_seconds?: number | null;
  estimated_unload_seconds?: number | null;
  /** When the recurrences stop applying (exclusive) */
  expires_at?: string;
  id?: string;
  is_oxygen_required?: boolean;
  load_time_seconds?: number;
  /** How many additional people will be accompanying the primary passenger */
  num_accompanying_passengers?: number;
  num_attendants_needed?: number;
  oxygen_liters_per_min?: string;
  passenger?: PatchedTripPassengerRead;
  payer?: PayerOrganizationRead;
  payer_passenger?: TripPayerPassengerRead;
  payment_method?: PaymentMethodEnum | BlankEnum;
  pickup?: TripLocationDetailRead;
  pickup_wait_time_seconds?: number;
  recurrences?: TripRecurrence[];
  /** Whether the passenger will supply their own wheelchair or not */
  must_provide_wheelchair?: boolean;
  service_type?: ServiceTypeEnum;
  /** The type of space in the vehicle this passenger will need */
  space_type?: SpaceTypeEnum;
  /** When the recurrences start applying (inclusive) */
  start_date?: string;
  unload_time_seconds?: number;
  old_trips?: TripSubscriptionTrip[];
  new_trips?: TripSubscriptionTrip[];
  /** Whether the passenger has an infectious disease */
  has_infectious_disease?: boolean;
  /** Who booked this trip, if not passenger */
  booked_by_name?: string;
  /** Phone number of who booked this trip, if not passenger */
  booked_by_phone_number?: string | null;
  /** Phone number extension of who booked this trip, if not passenger */
  booked_by_phone_extension?: string;
  tags?: TripTripSubscriptionTagRead[] | null;
  /** The authorization ID for this trip */
  authorization_id?: string;
  /** The insurance policy ID for this trip */
  insurance_policy_id?: string;
  /** The seat equipment needed for this trip */
  seat_equipment?: SeatEquipmentEnum | BlankEnum;
  /** Whether this trip should avoid being multiloaded with other passengers */
  should_avoid_multiload?: boolean;
};
export type PatchedTripSubscriptionWrite = {
  /** Notes only visible to the dispatcher */
  dispatcher_notes?: string;
  /** Notes about the trip for billing purposes */
  billing_notes?: string;
  dropoff?: TripLocationDetail;
  estimated_distance_miles?: number | null;
  estimated_load_seconds?: number | null;
  estimated_unload_seconds?: number | null;
  /** When the recurrences stop applying (exclusive) */
  expires_at?: string;
  is_oxygen_required?: boolean;
  load_time_seconds?: number;
  /** How many additional people will be accompanying the primary passenger */
  num_accompanying_passengers?: number;
  num_attendants_needed?: number;
  oxygen_liters_per_min?: string;
  passenger?: PatchedTripPassenger;
  payer_id?: string;
  payer_passenger_external_id?: string;
  payment_method?: PaymentMethodEnum | BlankEnum;
  pickup?: TripLocationDetail;
  pickup_wait_time_seconds?: number;
  recurrences?: TripRecurrence[];
  /** Whether the passenger will supply their own wheelchair or not */
  must_provide_wheelchair?: boolean;
  service_type?: ServiceTypeEnum;
  /** The type of space in the vehicle this passenger will need */
  space_type?: SpaceTypeEnum;
  /** When the recurrences start applying (inclusive) */
  start_date?: string;
  unload_time_seconds?: number;
  /** Whether the passenger has an infectious disease */
  has_infectious_disease?: boolean;
  /** Who booked this trip, if not passenger */
  booked_by_name?: string;
  /** Phone number of who booked this trip, if not passenger */
  booked_by_phone_number?: string | null;
  /** Phone number extension of who booked this trip, if not passenger */
  booked_by_phone_extension?: string;
  tag_ids?: string[] | null;
  /** The authorization ID for this trip */
  authorization_id?: string;
  /** The insurance policy ID for this trip */
  insurance_policy_id?: string;
  /** The seat equipment needed for this trip */
  seat_equipment?: SeatEquipmentEnum | BlankEnum;
  /** Whether this trip should avoid being multiloaded with other passengers */
  should_avoid_multiload?: boolean;
};
export type TripsSubscriptionsDestroyErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripSuggestedPickupTime = {};
export type TripSuggestedPickupTimeRead = {
  pickup_at: string | null;
};
export type TripSuggestedPickupTimeWrite = {
  appointment_at: string;
  pickup_aws_place_id: string;
  dropoff_aws_place_id: string;
  space_type: SpaceTypeEnum;
  load_time_seconds?: number | null;
  unload_time_seconds?: number | null;
};
export type TripsSuggestedPickupAtCreateNonFieldErrorsErrorComponent = {
  attr: 'non_field_errors';
  code: 'invalid';
  detail: string;
};
export type TripsSuggestedPickupAtCreateAppointmentAtErrorComponent = {
  attr: 'appointment_at';
  code: 'date' | 'invalid' | 'make_aware' | 'null' | 'overflow' | 'required';
  detail: string;
};
export type TripsSuggestedPickupAtCreatePickupAwsPlaceIdErrorComponent = {
  attr: 'pickup_aws_place_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSuggestedPickupAtCreateDropoffAwsPlaceIdErrorComponent = {
  attr: 'dropoff_aws_place_id';
  code:
    | 'blank'
    | 'invalid'
    | 'null'
    | 'null_characters_not_allowed'
    | 'required'
    | 'surrogate_characters_not_allowed';
  detail: string;
};
export type TripsSuggestedPickupAtCreateSpaceTypeErrorComponent = {
  attr: 'space_type';
  code: 'invalid_choice' | 'null' | 'required';
  detail: string;
};
export type TripsSuggestedPickupAtCreateLoadTimeSecondsErrorComponent = {
  attr: 'load_time_seconds';
  code: 'invalid' | 'max_string_length';
  detail: string;
};
export type TripsSuggestedPickupAtCreateUnloadTimeSecondsErrorComponent = {
  attr: 'unload_time_seconds';
  code: 'invalid' | 'max_string_length';
  detail: string;
};
export type TripsSuggestedPickupAtCreateError =
  | ({
      attr: 'non_field_errors';
    } & TripsSuggestedPickupAtCreateNonFieldErrorsErrorComponent)
  | ({
      attr: 'appointment_at';
    } & TripsSuggestedPickupAtCreateAppointmentAtErrorComponent)
  | ({
      attr: 'pickup_aws_place_id';
    } & TripsSuggestedPickupAtCreatePickupAwsPlaceIdErrorComponent)
  | ({
      attr: 'dropoff_aws_place_id';
    } & TripsSuggestedPickupAtCreateDropoffAwsPlaceIdErrorComponent)
  | ({
      attr: 'space_type';
    } & TripsSuggestedPickupAtCreateSpaceTypeErrorComponent)
  | ({
      attr: 'load_time_seconds';
    } & TripsSuggestedPickupAtCreateLoadTimeSecondsErrorComponent)
  | ({
      attr: 'unload_time_seconds';
    } & TripsSuggestedPickupAtCreateUnloadTimeSecondsErrorComponent);
export type TripsSuggestedPickupAtCreateValidationError = {
  type: ValidationErrorEnum;
  errors: TripsSuggestedPickupAtCreateError[];
};
export type TripsSuggestedPickupAtCreateErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsSuggestedPickupAtCreateValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export type TripSubscriptionExpiringSoonCount = {
  count?: number;
};
export type TripsTripSubscriptionExpiringSoonCountRetrieveErrorResponse400 = {
  type: 'client_error';
} & ParseErrorResponse;
export type TripsWithSummaryListRangeStartErrorComponent = {
  attr: 'range_start';
  code: 'invalid';
  detail: string;
};
export type TripsWithSummaryListRangeEndErrorComponent = {
  attr: 'range_end';
  code: 'invalid';
  detail: string;
};
export type TripsWithSummaryListPayersErrorComponent = {
  attr: 'payers';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type TripsWithSummaryListStatusErrorComponent = {
  attr: 'status';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type TripsWithSummaryListPassengersErrorComponent = {
  attr: 'passengers';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type TripsWithSummaryListTagsErrorComponent = {
  attr: 'tags';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type TripsWithSummaryListVehiclesErrorComponent = {
  attr: 'vehicles';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type TripsWithSummaryListSpaceTypeErrorComponent = {
  attr: 'space_type';
  code: 'null_characters_not_allowed';
  detail: string;
};
export type TripsWithSummaryListPriceErrorComponent = {
  attr: 'price';
  code: 'invalid';
  detail: string;
};
export type TripsWithSummaryListCreatedAtRangeStartErrorComponent = {
  attr: 'created_at_range_start';
  code: 'invalid';
  detail: string;
};
export type TripsWithSummaryListCreatedAtRangeEndErrorComponent = {
  attr: 'created_at_range_end';
  code: 'invalid';
  detail: string;
};
export type TripsWithSummaryListError =
  | ({
      attr: 'range_start';
    } & TripsWithSummaryListRangeStartErrorComponent)
  | ({
      attr: 'range_end';
    } & TripsWithSummaryListRangeEndErrorComponent)
  | ({
      attr: 'payers';
    } & TripsWithSummaryListPayersErrorComponent)
  | ({
      attr: 'status';
    } & TripsWithSummaryListStatusErrorComponent)
  | ({
      attr: 'passengers';
    } & TripsWithSummaryListPassengersErrorComponent)
  | ({
      attr: 'tags';
    } & TripsWithSummaryListTagsErrorComponent)
  | ({
      attr: 'vehicles';
    } & TripsWithSummaryListVehiclesErrorComponent)
  | ({
      attr: 'space_type';
    } & TripsWithSummaryListSpaceTypeErrorComponent)
  | ({
      attr: 'price';
    } & TripsWithSummaryListPriceErrorComponent)
  | ({
      attr: 'created_at_range_start';
    } & TripsWithSummaryListCreatedAtRangeStartErrorComponent)
  | ({
      attr: 'created_at_range_end';
    } & TripsWithSummaryListCreatedAtRangeEndErrorComponent);
export type TripsWithSummaryListValidationError = {
  type: ValidationErrorEnum;
  errors: TripsWithSummaryListError[];
};
export type TripsWithSummaryListErrorResponse400 =
  | ({
      type: 'validation_error';
    } & TripsWithSummaryListValidationError)
  | ({
      type: 'client_error';
    } & ParseErrorResponse);
export const {
  useTripsListQuery,
  useLazyTripsListQuery,
  useTripsCreateMutation,
  useTripsRetrieveQuery,
  useLazyTripsRetrieveQuery,
  useTripsPartialUpdateMutation,
  useTripsDestroyMutation,
  useTripsAcceptPartialUpdateMutation,
  useTripsAcceptCancellationRequestPartialUpdateMutation,
  useTripsActivateWillCallPartialUpdateMutation,
  useTripsAddTripLegPartialUpdateMutation,
  useTripsAssignPartialUpdateMutation,
  useTripsCancelPartialUpdateMutation,
  useTripsCancelCodesRetrieveQuery,
  useLazyTripsCancelCodesRetrieveQuery,
  useTripsCancelReasonsRetrieveQuery,
  useLazyTripsCancelReasonsRetrieveQuery,
  useTripsCancellationRequestPartialUpdateMutation,
  useTripsCompletePartialUpdateMutation,
  useTripsCorrelatedListQuery,
  useLazyTripsCorrelatedListQuery,
  useTripsCreatesListQuery,
  useLazyTripsCreatesListQuery,
  useTripsDriverEnteredNotesPartialUpdateMutation,
  useTripsEventManualCreatePartialUpdateMutation,
  useTripsEventsListQuery,
  useLazyTripsEventsListQuery,
  useTripsLocationsListQuery,
  useLazyTripsLocationsListQuery,
  useTripsLockPartialUpdateMutation,
  useTripsOverrideStatusPartialUpdateMutation,
  useTripsPriceSummaryRetrieveQuery,
  useLazyTripsPriceSummaryRetrieveQuery,
  useTripsPublicTripTrackingLinkRetrieveQuery,
  useLazyTripsPublicTripTrackingLinkRetrieveQuery,
  useTripsReassignPartialUpdateMutation,
  useTripsRejectPartialUpdateMutation,
  useTripsRejectCancellationRequestPartialUpdateMutation,
  useTripsRejectCodesRetrieveQuery,
  useLazyTripsRejectCodesRetrieveQuery,
  useTripsRejectReasonsRetrieveQuery,
  useLazyTripsRejectReasonsRetrieveQuery,
  useTripsRelatedListQuery,
  useLazyTripsRelatedListQuery,
  useTripsRemoveCancellationRequestPartialUpdateMutation,
  useTripsSignaturesListQuery,
  useLazyTripsSignaturesListQuery,
  useTripsStatusPartialUpdateMutation,
  useTripsSummaryRetrieveQuery,
  useLazyTripsSummaryRetrieveQuery,
  useTripsTurnbackReasonsRetrieveQuery,
  useLazyTripsTurnbackReasonsRetrieveQuery,
  useTripsUnassignPartialUpdateMutation,
  useTripsUncancelPartialUpdateMutation,
  useTripsUnlockPartialUpdateMutation,
  useTripsUnrejectPartialUpdateMutation,
  useTripsUpdatePickupAtPartialUpdateMutation,
  useTripsUpdatesListQuery,
  useLazyTripsUpdatesListQuery,
  useTripsValidatePartialUpdateMutation,
  useTripsActivatedWillCallCountRetrieveQuery,
  useLazyTripsActivatedWillCallCountRetrieveQuery,
  useTripsAllListQuery,
  useLazyTripsAllListQuery,
  useTripsBulkAcceptCreateMutation,
  useTripsBulkAssignCreateMutation,
  useTripsBulkCancelCreateMutation,
  useTripsBulkCancelReasonsCreateQuery,
  useLazyTripsBulkCancelReasonsCreateQuery,
  useTripsBulkPriceCreateMutation,
  useTripsBulkPriceConfirmCreateMutation,
  useTripsBulkRejectCreateMutation,
  useTripsBulkTripEventsCreateMutation,
  useTripsBulkUnassignCreateMutation,
  useTripsBulkValidateCreateMutation,
  useTripsExportRetrieveQuery,
  useLazyTripsExportRetrieveQuery,
  useTripsImportCreateMutation,
  useTripsMtmDriverManifestListQuery,
  useLazyTripsMtmDriverManifestListQuery,
  useTripsMultiloadListQuery,
  useLazyTripsMultiloadListQuery,
  useTripsMultiloadCreateMutation,
  useTripsMultiloadRetrieveQuery,
  useLazyTripsMultiloadRetrieveQuery,
  useTripsMultiloadPartialUpdateMutation,
  useTripsMultiloadDestroyMutation,
  useTripsMultiloadMobileRetrieveQuery,
  useLazyTripsMultiloadMobileRetrieveQuery,
  useTripsRequestedCountRetrieveQuery,
  useLazyTripsRequestedCountRetrieveQuery,
  useTripsSubscriptionsListQuery,
  useLazyTripsSubscriptionsListQuery,
  useTripsSubscriptionsCreateMutation,
  useTripsSubscriptionsRetrieveQuery,
  useLazyTripsSubscriptionsRetrieveQuery,
  useTripsSubscriptionsPartialUpdateMutation,
  useTripsSubscriptionsDestroyMutation,
  useTripsSuggestedPickupAtCreateMutation,
  useTripsTripSubscriptionExpiringSoonCountRetrieveQuery,
  useLazyTripsTripSubscriptionExpiringSoonCountRetrieveQuery,
  useTripsWithSummaryListQuery,
  useLazyTripsWithSummaryListQuery,
} = injectedRtkApi;
